
const data = [
  {
    "mcc": "289",
    "mnc": "88",
    "iso": "ge",
    "country": "Abkhazia",
    "countryCode": "7",
    "network": "A-Mobile "
  },
  {
    "mcc": "289",
    "mnc": "68",
    "iso": "ge",
    "country": "Abkhazia",
    "countryCode": "7",
    "network": "A-Mobile "
  },
  {
    "mcc": "289",
    "mnc": "67",
    "iso": "ge",
    "country": "Abkhazia",
    "countryCode": "7",
    "network": "Aquafon "
  },
  {
    "mcc": "289",
    "mnc": "299",
    "iso": "ge",
    "country": "Abkhazia",
    "countryCode": "7",
    "network": "Failed Calls "
  },
  {
    "mcc": "289",
    "mnc": "999",
    "iso": "ge",
    "country": "Abkhazia",
    "countryCode": "7",
    "network": "Fix Line "
  },
  {
    "mcc": "412",
    "mnc": "01",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "AWCC "
  },
  {
    "mcc": "412",
    "mnc": "50",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Etisalat "
  },
  {
    "mcc": "412",
    "mnc": "299",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Failed Calls "
  },
  {
    "mcc": "412",
    "mnc": "999",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Fix Line "
  },
  {
    "mcc": "412",
    "mnc": "80",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Mobifone "
  },
  {
    "mcc": "412",
    "mnc": "88",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Mobifone "
  },
  {
    "mcc": "412",
    "mnc": "40",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "MTN "
  },
  {
    "mcc": "412",
    "mnc": "20",
    "iso": "af",
    "country": "Afghanistan",
    "countryCode": "93",
    "network": "Roshan "
  },
  {
    "mcc": "276",
    "mnc": "03",
    "iso": "al",
    "country": "Albania",
    "countryCode": "355",
    "network": "ALBtelecom Mobile / Eagle "
  },
  {
    "mcc": "276",
    "mnc": "299",
    "iso": "al",
    "country": "Albania",
    "countryCode": "355",
    "network": "Failed Calls "
  },
  {
    "mcc": "276",
    "mnc": "999",
    "iso": "al",
    "country": "Albania",
    "countryCode": "355",
    "network": "Fix Line "
  },
  {
    "mcc": "276",
    "mnc": "01",
    "iso": "al",
    "country": "Albania",
    "countryCode": "355",
    "network": "One / AMC "
  },
  {
    "mcc": "276",
    "mnc": "02",
    "iso": "al",
    "country": "Albania",
    "countryCode": "355",
    "network": "Vodafone "
  },
  {
    "mcc": "603",
    "mnc": "02",
    "iso": "dz",
    "country": "Algeria",
    "countryCode": "213",
    "network": "Djezzy "
  },
  {
    "mcc": "603",
    "mnc": "299",
    "iso": "dz",
    "country": "Algeria",
    "countryCode": "213",
    "network": "Failed Calls "
  },
  {
    "mcc": "603",
    "mnc": "999",
    "iso": "dz",
    "country": "Algeria",
    "countryCode": "213",
    "network": "Fix Line "
  },
  {
    "mcc": "603",
    "mnc": "01",
    "iso": "dz",
    "country": "Algeria",
    "countryCode": "213",
    "network": "Mobilis "
  },
  {
    "mcc": "603",
    "mnc": "03",
    "iso": "dz",
    "country": "Algeria",
    "countryCode": "213",
    "network": "Ooredoo "
  },
  {
    "mcc": "544",
    "mnc": "780",
    "iso": "as",
    "country": "American Samoa",
    "countryCode": "684",
    "network": "ASTCA Mobile "
  },
  {
    "mcc": "544",
    "mnc": "11",
    "iso": "as",
    "country": "American Samoa",
    "countryCode": "684",
    "network": "BlueSky "
  },
  {
    "mcc": "544",
    "mnc": "299",
    "iso": "as",
    "country": "American Samoa",
    "countryCode": "684",
    "network": "Failed Calls "
  },
  {
    "mcc": "544",
    "mnc": "999",
    "iso": "as",
    "country": "American Samoa",
    "countryCode": "684",
    "network": "Fix Line "
  },
  {
    "mcc": "213",
    "mnc": "03",
    "iso": "ad",
    "country": "Andorra",
    "countryCode": "376",
    "network": "Andorra Telecom / Mobiland "
  },
  {
    "mcc": "213",
    "mnc": "299",
    "iso": "ad",
    "country": "Andorra",
    "countryCode": "376",
    "network": "Failed Calls "
  },
  {
    "mcc": "213",
    "mnc": "999",
    "iso": "ad",
    "country": "Andorra",
    "countryCode": "376",
    "network": "Fix Line "
  },
  {
    "mcc": "631",
    "mnc": "299",
    "iso": "ao",
    "country": "Angola",
    "countryCode": "244",
    "network": "Failed Calls "
  },
  {
    "mcc": "631",
    "mnc": "999",
    "iso": "ao",
    "country": "Angola",
    "countryCode": "244",
    "network": "Fix Line "
  },
  {
    "mcc": "631",
    "mnc": "04",
    "iso": "ao",
    "country": "Angola",
    "countryCode": "244",
    "network": "MoviCel "
  },
  {
    "mcc": "631",
    "mnc": "02",
    "iso": "ao",
    "country": "Angola",
    "countryCode": "244",
    "network": "Unitel "
  },
  {
    "mcc": "365",
    "mnc": "850",
    "iso": "ai",
    "country": "Anguilla",
    "countryCode": "1264",
    "network": "Digicel "
  },
  {
    "mcc": "365",
    "mnc": "299",
    "iso": "ai",
    "country": "Anguilla",
    "countryCode": "1264",
    "network": "Failed Calls "
  },
  {
    "mcc": "365",
    "mnc": "999",
    "iso": "ai",
    "country": "Anguilla",
    "countryCode": "1264",
    "network": "Fix Line "
  },
  {
    "mcc": "365",
    "mnc": "840",
    "iso": "ai",
    "country": "Anguilla",
    "countryCode": "1264",
    "network": "Flow "
  },
  {
    "mcc": "344",
    "mnc": "93",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Digicel "
  },
  {
    "mcc": "344",
    "mnc": "930",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Digicel "
  },
  {
    "mcc": "344",
    "mnc": "299",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Failed Calls "
  },
  {
    "mcc": "344",
    "mnc": "999",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Fix Line "
  },
  {
    "mcc": "344",
    "mnc": "920",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Flow "
  },
  {
    "mcc": "344",
    "mnc": "92",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "Flow "
  },
  {
    "mcc": "344",
    "mnc": "03",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "imobile / APUA "
  },
  {
    "mcc": "344",
    "mnc": "030",
    "iso": "ag",
    "country": "Antigua and Barbuda",
    "countryCode": "1268",
    "network": "imobile / APUA "
  },
  {
    "mcc": "722",
    "mnc": "031",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Claro "
  },
  {
    "mcc": "722",
    "mnc": "330",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Claro "
  },
  {
    "mcc": "722",
    "mnc": "320",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Claro "
  },
  {
    "mcc": "722",
    "mnc": "310",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Claro "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Express "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Failed Calls "
  },
  {
    "mcc": "722",
    "mnc": "999",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Fix Line "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Imowi "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "IPLAN "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Kallofer "
  },
  {
    "mcc": "722",
    "mnc": "010",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Movistar "
  },
  {
    "mcc": "722",
    "mnc": "070",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Movistar "
  },
  {
    "mcc": "722",
    "mnc": "007",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Movistar "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Nuestro "
  },
  {
    "mcc": "722",
    "mnc": "034",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Personal "
  },
  {
    "mcc": "722",
    "mnc": "299",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Telecentro "
  },
  {
    "mcc": "722",
    "mnc": "340",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Personal "
  },
  {
    "mcc": "722",
    "mnc": "341",
    "iso": "ar",
    "country": "Argentina",
    "countryCode": "54",
    "network": "Personal "
  },
  {
    "mcc": "283",
    "mnc": "01",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "Beeline "
  },
  {
    "mcc": "283",
    "mnc": "299",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "Failed Calls "
  },
  {
    "mcc": "283",
    "mnc": "999",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "Fix Line "
  },
  {
    "mcc": "283",
    "mnc": "04",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "KT "
  },
  {
    "mcc": "283",
    "mnc": "10",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "Orange "
  },
  {
    "mcc": "283",
    "mnc": "05",
    "iso": "am",
    "country": "Armenia",
    "countryCode": "374",
    "network": "Viva-MTS "
  },
  {
    "mcc": "363",
    "mnc": "02",
    "iso": "aw",
    "country": "Aruba",
    "countryCode": "297",
    "network": "Digicel "
  },
  {
    "mcc": "363",
    "mnc": "299",
    "iso": "aw",
    "country": "Aruba",
    "countryCode": "297",
    "network": "Failed Calls "
  },
  {
    "mcc": "363",
    "mnc": "999",
    "iso": "aw",
    "country": "Aruba",
    "countryCode": "297",
    "network": "Fix Line "
  },
  {
    "mcc": "363",
    "mnc": "299",
    "iso": "aw",
    "country": "Aruba",
    "countryCode": "297",
    "network": "MIO "
  },
  {
    "mcc": "363",
    "mnc": "01",
    "iso": "aw",
    "country": "Aruba",
    "countryCode": "297",
    "network": "SETAR "
  },
  {
    "mcc": "505",
    "mnc": "299",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "ACMA "
  },
  {
    "mcc": "505",
    "mnc": "30",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Compatel "
  },
  {
    "mcc": "505",
    "mnc": "299",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Failed Calls "
  },
  {
    "mcc": "505",
    "mnc": "999",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Fix Line "
  },
  {
    "mcc": "505",
    "mnc": "299",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Get SIM "
  },
  {
    "mcc": "505",
    "mnc": "19",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Lycamobile "
  },
  {
    "mcc": "505",
    "mnc": "35",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "MessageBird "
  },
  {
    "mcc": "505",
    "mnc": "10",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Norfolk Telecom "
  },
  {
    "mcc": "505",
    "mnc": "90",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Optus "
  },
  {
    "mcc": "505",
    "mnc": "50",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Pivotel "
  },
  {
    "mcc": "505",
    "mnc": "88",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Pivotel "
  },
  {
    "mcc": "505",
    "mnc": "13",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "RailCorp "
  },
  {
    "mcc": "505",
    "mnc": "26",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Sinch "
  },
  {
    "mcc": "505",
    "mnc": "02",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Optus "
  },
  {
    "mcc": "505",
    "mnc": "299",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Symbio "
  },
  {
    "mcc": "505",
    "mnc": "71",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Telstra "
  },
  {
    "mcc": "505",
    "mnc": "72",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Telstra "
  },
  {
    "mcc": "505",
    "mnc": "01",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Telstra "
  },
  {
    "mcc": "505",
    "mnc": "11",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Telstra "
  },
  {
    "mcc": "505",
    "mnc": "39",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Telstra "
  },
  {
    "mcc": "505",
    "mnc": "16",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "VicTrack "
  },
  {
    "mcc": "505",
    "mnc": "07",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Vodafone "
  },
  {
    "mcc": "505",
    "mnc": "03",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Vodafone "
  },
  {
    "mcc": "505",
    "mnc": "06",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Vodafone "
  },
  {
    "mcc": "505",
    "mnc": "12",
    "iso": "au",
    "country": "Australia",
    "countryCode": "61",
    "network": "Vodafone "
  },
  {
    "mcc": "232",
    "mnc": "19",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "3 "
  },
  {
    "mcc": "232",
    "mnc": "14",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "3 "
  },
  {
    "mcc": "232",
    "mnc": "16",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "3 "
  },
  {
    "mcc": "232",
    "mnc": "10",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "3 "
  },
  {
    "mcc": "232",
    "mnc": "05",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "3 "
  },
  {
    "mcc": "232",
    "mnc": "09",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "A1 Telekom "
  },
  {
    "mcc": "232",
    "mnc": "12",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "A1 Telekom "
  },
  {
    "mcc": "232",
    "mnc": "02",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "A1 Telekom "
  },
  {
    "mcc": "232",
    "mnc": "11",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "A1 Telekom "
  },
  {
    "mcc": "232",
    "mnc": "01",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "A1 Telekom "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "ArgoNET "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "DIALOG telekom "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Digital Privacy "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "DIMOCO "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "educom "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Failed Calls "
  },
  {
    "mcc": "232",
    "mnc": "999",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Fix Line "
  },
  {
    "mcc": "232",
    "mnc": "25",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Holding Graz "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Innsbrucker Kommunalbetriebe "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "kabelplus "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Lenovo Connect "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "LINK Mobility "
  },
  {
    "mcc": "232",
    "mnc": "26",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "LIWEST Mobil "
  },
  {
    "mcc": "232",
    "mnc": "08",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Lycamobile "
  },
  {
    "mcc": "232",
    "mnc": "17",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "MRS "
  },
  {
    "mcc": "232",
    "mnc": "20",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Mtel "
  },
  {
    "mcc": "232",
    "mnc": "91",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "OBB Infrastruktur "
  },
  {
    "mcc": "232",
    "mnc": "22",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Plintron "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Simple SMS "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Skymond Mobile "
  },
  {
    "mcc": "232",
    "mnc": "24",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Smartel Services "
  },
  {
    "mcc": "232",
    "mnc": "18",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "smartspace "
  },
  {
    "mcc": "232",
    "mnc": "03",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "T-Mobile / Magenta "
  },
  {
    "mcc": "232",
    "mnc": "23",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "T-Mobile / Magenta "
  },
  {
    "mcc": "232",
    "mnc": "04",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "T-Mobile / Magenta "
  },
  {
    "mcc": "232",
    "mnc": "13",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "T-Mobile / Magenta "
  },
  {
    "mcc": "232",
    "mnc": "299",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Telfoni "
  },
  {
    "mcc": "232",
    "mnc": "27",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Tismi "
  },
  {
    "mcc": "232",
    "mnc": "07",
    "iso": "at",
    "country": "Austria",
    "countryCode": "43",
    "network": "Ventocom "
  },
  {
    "mcc": "400",
    "mnc": "01",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Azercell "
  },
  {
    "mcc": "400",
    "mnc": "02",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Bakcell "
  },
  {
    "mcc": "400",
    "mnc": "299",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Failed Calls "
  },
  {
    "mcc": "400",
    "mnc": "999",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Fix Line "
  },
  {
    "mcc": "400",
    "mnc": "03",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "FONEX "
  },
  {
    "mcc": "400",
    "mnc": "04",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Nar Mobile "
  },
  {
    "mcc": "400",
    "mnc": "06",
    "iso": "az",
    "country": "Azerbaijan",
    "countryCode": "994",
    "network": "Naxtel "
  },
  {
    "mcc": "364",
    "mnc": "490",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Aliv "
  },
  {
    "mcc": "364",
    "mnc": "390",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Cybercell / BaTelCo "
  },
  {
    "mcc": "364",
    "mnc": "30",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Cybercell / BaTelCo "
  },
  {
    "mcc": "364",
    "mnc": "39",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Cybercell / BaTelCo "
  },
  {
    "mcc": "364",
    "mnc": "299",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Failed Calls "
  },
  {
    "mcc": "364",
    "mnc": "999",
    "iso": "bs",
    "country": "Bahamas",
    "countryCode": "1242",
    "network": "Fix Line "
  },
  {
    "mcc": "426",
    "mnc": "01",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "Batelco "
  },
  {
    "mcc": "426",
    "mnc": "299",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "Failed Calls "
  },
  {
    "mcc": "426",
    "mnc": "999",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "Fix Line "
  },
  {
    "mcc": "426",
    "mnc": "05",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "Royal Court "
  },
  {
    "mcc": "426",
    "mnc": "04",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "VIVA "
  },
  {
    "mcc": "426",
    "mnc": "02",
    "iso": "bh",
    "country": "Bahrain",
    "countryCode": "973",
    "network": "Zain "
  },
  {
    "mcc": "470",
    "mnc": "02",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "Airtel "
  },
  {
    "mcc": "470",
    "mnc": "07",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "Airtel "
  },
  {
    "mcc": "470",
    "mnc": "03",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "Banglalink "
  },
  {
    "mcc": "470",
    "mnc": "299",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "Failed Calls "
  },
  {
    "mcc": "470",
    "mnc": "999",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "Fix Line "
  },
  {
    "mcc": "470",
    "mnc": "01",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "GrameenPhone "
  },
  {
    "mcc": "470",
    "mnc": "04",
    "iso": "bd",
    "country": "Bangladesh",
    "countryCode": "880",
    "network": "TeleTalk "
  },
  {
    "mcc": "342",
    "mnc": "050",
    "iso": "bb",
    "country": "Barbados",
    "countryCode": "1246",
    "network": "Digicel "
  },
  {
    "mcc": "342",
    "mnc": "299",
    "iso": "bb",
    "country": "Barbados",
    "countryCode": "1246",
    "network": "Failed Calls "
  },
  {
    "mcc": "342",
    "mnc": "999",
    "iso": "bb",
    "country": "Barbados",
    "countryCode": "1246",
    "network": "Fix Line "
  },
  {
    "mcc": "342",
    "mnc": "600",
    "iso": "bb",
    "country": "Barbados",
    "countryCode": "1246",
    "network": "Flow / Lime "
  },
  {
    "mcc": "342",
    "mnc": "299",
    "iso": "bb",
    "country": "Barbados",
    "countryCode": "1246",
    "network": "Ozone "
  },
  {
    "mcc": "257",
    "mnc": "04",
    "iso": "by",
    "country": "Belarus",
    "countryCode": "375",
    "network": "life:) "
  },
  {
    "mcc": "257",
    "mnc": "299",
    "iso": "by",
    "country": "Belarus",
    "countryCode": "375",
    "network": "Failed Calls "
  },
  {
    "mcc": "257",
    "mnc": "999",
    "iso": "by",
    "country": "Belarus",
    "countryCode": "375",
    "network": "Fix Line "
  },
  {
    "mcc": "257",
    "mnc": "02",
    "iso": "by",
    "country": "Belarus",
    "countryCode": "375",
    "network": "MTS "
  },
  {
    "mcc": "257",
    "mnc": "01",
    "iso": "by",
    "country": "Belarus",
    "countryCode": "375",
    "network": "velcom A1 "
  },
  {
    "mcc": "206",
    "mnc": "20",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Base "
  },
  {
    "mcc": "206",
    "mnc": "28",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "BICS "
  },
  {
    "mcc": "206",
    "mnc": "25",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Dense Air "
  },
  {
    "mcc": "206",
    "mnc": "23",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Dust Mobile "
  },
  {
    "mcc": "206",
    "mnc": "33",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Ericsson "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Failed Calls "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "FEBO "
  },
  {
    "mcc": "206",
    "mnc": "999",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Fix Line "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "GianCom "
  },
  {
    "mcc": "206",
    "mnc": "02",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Infrabel "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "interactive digital media / IDM "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "L-mobi "
  },
  {
    "mcc": "206",
    "mnc": "99",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Lancelot "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Legos "
  },
  {
    "mcc": "206",
    "mnc": "06",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Lycamobile "
  },
  {
    "mcc": "206",
    "mnc": "30",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Mobile Vikings "
  },
  {
    "mcc": "206",
    "mnc": "10",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Mobistar / Orange "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Nord Connect "
  },
  {
    "mcc": "206",
    "mnc": "34",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "onoff "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "PM Factory "
  },
  {
    "mcc": "206",
    "mnc": "01",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Proximus "
  },
  {
    "mcc": "206",
    "mnc": "00",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Proximus "
  },
  {
    "mcc": "206",
    "mnc": "04",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Proximus "
  },
  {
    "mcc": "206",
    "mnc": "05",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Telenet "
  },
  {
    "mcc": "206",
    "mnc": "07",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "206",
    "mnc": "08",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "VOOmobile "
  },
  {
    "mcc": "206",
    "mnc": "299",
    "iso": "be",
    "country": "Belgium",
    "countryCode": "32",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "702",
    "mnc": "67",
    "iso": "bz",
    "country": "Belize",
    "countryCode": "501",
    "network": "DigiCell "
  },
  {
    "mcc": "702",
    "mnc": "299",
    "iso": "bz",
    "country": "Belize",
    "countryCode": "501",
    "network": "Failed Calls "
  },
  {
    "mcc": "702",
    "mnc": "999",
    "iso": "bz",
    "country": "Belize",
    "countryCode": "501",
    "network": "Fix Line "
  },
  {
    "mcc": "702",
    "mnc": "099",
    "iso": "bz",
    "country": "Belize",
    "countryCode": "501",
    "network": "Smart "
  },
  {
    "mcc": "702",
    "mnc": "69",
    "iso": "bz",
    "country": "Belize",
    "countryCode": "501",
    "network": "Smart "
  },
  {
    "mcc": "616",
    "mnc": "299",
    "iso": "bj",
    "country": "Benin",
    "countryCode": "229",
    "network": "Failed Calls "
  },
  {
    "mcc": "616",
    "mnc": "999",
    "iso": "bj",
    "country": "Benin",
    "countryCode": "229",
    "network": "Fix Line "
  },
  {
    "mcc": "616",
    "mnc": "02",
    "iso": "bj",
    "country": "Benin",
    "countryCode": "229",
    "network": "Moov "
  },
  {
    "mcc": "616",
    "mnc": "03",
    "iso": "bj",
    "country": "Benin",
    "countryCode": "229",
    "network": "MTN "
  },
  {
    "mcc": "350",
    "mnc": "01",
    "iso": "bm",
    "country": "Bermuda",
    "countryCode": "1441",
    "network": "Digicel "
  },
  {
    "mcc": "350",
    "mnc": "299",
    "iso": "bm",
    "country": "Bermuda",
    "countryCode": "1441",
    "network": "Failed Calls "
  },
  {
    "mcc": "350",
    "mnc": "999",
    "iso": "bm",
    "country": "Bermuda",
    "countryCode": "1441",
    "network": "Fix Line "
  },
  {
    "mcc": "350",
    "mnc": "000",
    "iso": "bm",
    "country": "Bermuda",
    "countryCode": "1441",
    "network": "One "
  },
  {
    "mcc": "402",
    "mnc": "17",
    "iso": "bt",
    "country": "Bhutan",
    "countryCode": "975",
    "network": "B-Mobile "
  },
  {
    "mcc": "402",
    "mnc": "11",
    "iso": "bt",
    "country": "Bhutan",
    "countryCode": "975",
    "network": "B-Mobile "
  },
  {
    "mcc": "402",
    "mnc": "299",
    "iso": "bt",
    "country": "Bhutan",
    "countryCode": "975",
    "network": "Failed Calls "
  },
  {
    "mcc": "402",
    "mnc": "999",
    "iso": "bt",
    "country": "Bhutan",
    "countryCode": "975",
    "network": "Fix Line "
  },
  {
    "mcc": "402",
    "mnc": "77",
    "iso": "bt",
    "country": "Bhutan",
    "countryCode": "975",
    "network": "TashiCell "
  },
  {
    "mcc": "736",
    "mnc": "02",
    "iso": "bo",
    "country": "Bolivia",
    "countryCode": "591",
    "network": "Entel Movil "
  },
  {
    "mcc": "736",
    "mnc": "299",
    "iso": "bo",
    "country": "Bolivia",
    "countryCode": "591",
    "network": "Failed Calls "
  },
  {
    "mcc": "736",
    "mnc": "999",
    "iso": "bo",
    "country": "Bolivia",
    "countryCode": "591",
    "network": "Fix Line "
  },
  {
    "mcc": "736",
    "mnc": "03",
    "iso": "bo",
    "country": "Bolivia",
    "countryCode": "591",
    "network": "Tigo "
  },
  {
    "mcc": "736",
    "mnc": "01",
    "iso": "bo",
    "country": "Bolivia",
    "countryCode": "591",
    "network": "Viva "
  },
  {
    "mcc": "218",
    "mnc": "90",
    "iso": "ba",
    "country": "Bosnia and Herzegovina",
    "countryCode": "387",
    "network": "BH Mobile "
  },
  {
    "mcc": "218",
    "mnc": "03",
    "iso": "ba",
    "country": "Bosnia and Herzegovina",
    "countryCode": "387",
    "network": "Eronet "
  },
  {
    "mcc": "218",
    "mnc": "299",
    "iso": "ba",
    "country": "Bosnia and Herzegovina",
    "countryCode": "387",
    "network": "Failed Calls "
  },
  {
    "mcc": "218",
    "mnc": "999",
    "iso": "ba",
    "country": "Bosnia and Herzegovina",
    "countryCode": "387",
    "network": "Fix Line "
  },
  {
    "mcc": "218",
    "mnc": "05",
    "iso": "ba",
    "country": "Bosnia and Herzegovina",
    "countryCode": "387",
    "network": "m:tel "
  },
  {
    "mcc": "652",
    "mnc": "04",
    "iso": "bw",
    "country": "Botswana",
    "countryCode": "267",
    "network": "beMobile "
  },
  {
    "mcc": "652",
    "mnc": "299",
    "iso": "bw",
    "country": "Botswana",
    "countryCode": "267",
    "network": "Failed Calls "
  },
  {
    "mcc": "652",
    "mnc": "999",
    "iso": "bw",
    "country": "Botswana",
    "countryCode": "267",
    "network": "Fix Line "
  },
  {
    "mcc": "652",
    "mnc": "01",
    "iso": "bw",
    "country": "Botswana",
    "countryCode": "267",
    "network": "Mascom "
  },
  {
    "mcc": "652",
    "mnc": "02",
    "iso": "bw",
    "country": "Botswana",
    "countryCode": "267",
    "network": "Orange "
  },
  {
    "mcc": "724",
    "mnc": "32",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Algar Telecom "
  },
  {
    "mcc": "724",
    "mnc": "33",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Algar Telecom "
  },
  {
    "mcc": "724",
    "mnc": "34",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Algar Telecom "
  },
  {
    "mcc": "724",
    "mnc": "26",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Americanet "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "ARQIA "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Bbs Options "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Cinco "
  },
  {
    "mcc": "724",
    "mnc": "05",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Claro "
  },
  {
    "mcc": "724",
    "mnc": "38",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Claro "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Failed Calls "
  },
  {
    "mcc": "724",
    "mnc": "999",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Fix Line "
  },
  {
    "mcc": "724",
    "mnc": "21",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Ligue "
  },
  {
    "mcc": "724",
    "mnc": "00",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Claro-nxt/Nextel "
  },
  {
    "mcc": "724",
    "mnc": "39",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Claro-nxt/Nextel "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "NLT "
  },
  {
    "mcc": "724",
    "mnc": "31",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Oi Movel "
  },
  {
    "mcc": "724",
    "mnc": "16",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Oi Movel "
  },
  {
    "mcc": "724",
    "mnc": "15",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Sercomtel "
  },
  {
    "mcc": "724",
    "mnc": "17",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Surf "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Telecall "
  },
  {
    "mcc": "724",
    "mnc": "54",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "TIM "
  },
  {
    "mcc": "724",
    "mnc": "03",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "TIM "
  },
  {
    "mcc": "724",
    "mnc": "02",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "TIM "
  },
  {
    "mcc": "724",
    "mnc": "04",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "TIM "
  },
  {
    "mcc": "724",
    "mnc": "299",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Vecto Mobile "
  },
  {
    "mcc": "724",
    "mnc": "10",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Vivo "
  },
  {
    "mcc": "724",
    "mnc": "11",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Vivo "
  },
  {
    "mcc": "724",
    "mnc": "23",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Vivo "
  },
  {
    "mcc": "724",
    "mnc": "06",
    "iso": "br",
    "country": "Brazil",
    "countryCode": "55",
    "network": "Vivo "
  },
  {
    "mcc": "348",
    "mnc": "570",
    "iso": "vg",
    "country": "British Virgin Islands",
    "countryCode": "284",
    "network": "CCT "
  },
  {
    "mcc": "348",
    "mnc": "770",
    "iso": "vg",
    "country": "British Virgin Islands",
    "countryCode": "284",
    "network": "Digicel "
  },
  {
    "mcc": "348",
    "mnc": "299",
    "iso": "vg",
    "country": "British Virgin Islands",
    "countryCode": "284",
    "network": "Failed Calls "
  },
  {
    "mcc": "348",
    "mnc": "999",
    "iso": "vg",
    "country": "British Virgin Islands",
    "countryCode": "284",
    "network": "Fix Line "
  },
  {
    "mcc": "348",
    "mnc": "170",
    "iso": "vg",
    "country": "British Virgin Islands",
    "countryCode": "284",
    "network": "Flow "
  },
  {
    "mcc": "528",
    "mnc": "02",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "Progresif Cellular / B-Mobile "
  },
  {
    "mcc": "528",
    "mnc": "03",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "DST "
  },
  {
    "mcc": "528",
    "mnc": "11",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "DST "
  },
  {
    "mcc": "528",
    "mnc": "299",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "Failed Calls "
  },
  {
    "mcc": "528",
    "mnc": "999",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "Fix Line "
  },
  {
    "mcc": "528",
    "mnc": "01",
    "iso": "bn",
    "country": "Brunei",
    "countryCode": "673",
    "network": "imagine "
  },
  {
    "mcc": "284",
    "mnc": "01",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "A1 "
  },
  {
    "mcc": "284",
    "mnc": "11",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "Bulsatcom "
  },
  {
    "mcc": "284",
    "mnc": "299",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "Failed Calls "
  },
  {
    "mcc": "284",
    "mnc": "999",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "Fix Line "
  },
  {
    "mcc": "284",
    "mnc": "13",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "T.com "
  },
  {
    "mcc": "284",
    "mnc": "05",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "Telenor "
  },
  {
    "mcc": "284",
    "mnc": "03",
    "iso": "bg",
    "country": "Bulgaria",
    "countryCode": "359",
    "network": "Vivacom "
  },
  {
    "mcc": "613",
    "mnc": "299",
    "iso": "bf",
    "country": "Burkina Faso",
    "countryCode": "226",
    "network": "Failed Calls "
  },
  {
    "mcc": "613",
    "mnc": "999",
    "iso": "bf",
    "country": "Burkina Faso",
    "countryCode": "226",
    "network": "Fix Line "
  },
  {
    "mcc": "613",
    "mnc": "02",
    "iso": "bf",
    "country": "Burkina Faso",
    "countryCode": "226",
    "network": "Orange "
  },
  {
    "mcc": "613",
    "mnc": "03",
    "iso": "bf",
    "country": "Burkina Faso",
    "countryCode": "226",
    "network": "Telecel "
  },
  {
    "mcc": "613",
    "mnc": "01",
    "iso": "bf",
    "country": "Burkina Faso",
    "countryCode": "226",
    "network": "Telmob "
  },
  {
    "mcc": "642",
    "mnc": "299",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Failed Calls "
  },
  {
    "mcc": "642",
    "mnc": "999",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Fix Line "
  },
  {
    "mcc": "642",
    "mnc": "82",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Leo "
  },
  {
    "mcc": "642",
    "mnc": "01",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Leo "
  },
  {
    "mcc": "642",
    "mnc": "08",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Lumitel "
  },
  {
    "mcc": "642",
    "mnc": "03",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "ONAMOB "
  },
  {
    "mcc": "642",
    "mnc": "07",
    "iso": "bi",
    "country": "Burundi",
    "countryCode": "257",
    "network": "Smart "
  },
  {
    "mcc": "456",
    "mnc": "04",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "QB "
  },
  {
    "mcc": "456",
    "mnc": "01",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Cellcard "
  },
  {
    "mcc": "456",
    "mnc": "18",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Cellcard "
  },
  {
    "mcc": "456",
    "mnc": "16",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "CooTel "
  },
  {
    "mcc": "456",
    "mnc": "299",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Failed Calls "
  },
  {
    "mcc": "456",
    "mnc": "999",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Fix Line "
  },
  {
    "mcc": "456",
    "mnc": "08",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Metfone "
  },
  {
    "mcc": "456",
    "mnc": "299",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "MPTC "
  },
  {
    "mcc": "456",
    "mnc": "11",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Seatel "
  },
  {
    "mcc": "456",
    "mnc": "05",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Smart "
  },
  {
    "mcc": "456",
    "mnc": "06",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Smart "
  },
  {
    "mcc": "456",
    "mnc": "02",
    "iso": "kh",
    "country": "Cambodia",
    "countryCode": "855",
    "network": "Smart "
  },
  {
    "mcc": "624",
    "mnc": "299",
    "iso": "cm",
    "country": "Cameroon",
    "countryCode": "237",
    "network": "Failed Calls "
  },
  {
    "mcc": "624",
    "mnc": "999",
    "iso": "cm",
    "country": "Cameroon",
    "countryCode": "237",
    "network": "Fix Line "
  },
  {
    "mcc": "624",
    "mnc": "01",
    "iso": "cm",
    "country": "Cameroon",
    "countryCode": "237",
    "network": "MTN "
  },
  {
    "mcc": "624",
    "mnc": "04",
    "iso": "cm",
    "country": "Cameroon",
    "countryCode": "237",
    "network": "Nextel "
  },
  {
    "mcc": "624",
    "mnc": "02",
    "iso": "cm",
    "country": "Cameroon",
    "countryCode": "237",
    "network": "Orange "
  },
  {
    "mcc": "302",
    "mnc": "64",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "69",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "640",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "61",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "66",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "63",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "610",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "630",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "690",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "660",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Bell Mobility "
  },
  {
    "mcc": "302",
    "mnc": "270",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "eastlink "
  },
  {
    "mcc": "302",
    "mnc": "299",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Failed Calls "
  },
  {
    "mcc": "302",
    "mnc": "37",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Fido "
  },
  {
    "mcc": "302",
    "mnc": "370",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Fido "
  },
  {
    "mcc": "302",
    "mnc": "999",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Fix Line "
  },
  {
    "mcc": "302",
    "mnc": "491",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Freedom Mobile "
  },
  {
    "mcc": "302",
    "mnc": "490",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Freedom Mobile "
  },
  {
    "mcc": "302",
    "mnc": "49",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Freedom Mobile "
  },
  {
    "mcc": "302",
    "mnc": "62",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Ice Wireless "
  },
  {
    "mcc": "302",
    "mnc": "620",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Ice Wireless "
  },
  {
    "mcc": "302",
    "mnc": "38",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "K-Net Mobile "
  },
  {
    "mcc": "302",
    "mnc": "380",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "K-Net Mobile "
  },
  {
    "mcc": "302",
    "mnc": "530",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "K-Net Mobile "
  },
  {
    "mcc": "302",
    "mnc": "53",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "K-Net Mobile "
  },
  {
    "mcc": "302",
    "mnc": "720",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "721",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "32",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "82",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "320",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "820",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "72",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Rogers "
  },
  {
    "mcc": "302",
    "mnc": "68",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "75",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "78",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "680",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "681",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "780",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "781",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "750",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "SaskTel Mobility "
  },
  {
    "mcc": "302",
    "mnc": "22",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "76",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "360",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "221",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "86",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "36",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "220",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "760",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "22",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "860",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Telus Mobility "
  },
  {
    "mcc": "302",
    "mnc": "51",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Videotron "
  },
  {
    "mcc": "302",
    "mnc": "500",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Videotron "
  },
  {
    "mcc": "302",
    "mnc": "510",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Videotron "
  },
  {
    "mcc": "302",
    "mnc": "520",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Videotron "
  },
  {
    "mcc": "302",
    "mnc": "50",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Videotron "
  },
  {
    "mcc": "302",
    "mnc": "299",
    "iso": "ca",
    "country": "Canada",
    "countryCode": "1",
    "network": "Xplore Mobile "
  },
  {
    "mcc": "625",
    "mnc": "01",
    "iso": "cv",
    "country": "Cape Verde",
    "countryCode": "238",
    "network": "CVMovel "
  },
  {
    "mcc": "625",
    "mnc": "299",
    "iso": "cv",
    "country": "Cape Verde",
    "countryCode": "238",
    "network": "Failed Calls "
  },
  {
    "mcc": "625",
    "mnc": "999",
    "iso": "cv",
    "country": "Cape Verde",
    "countryCode": "238",
    "network": "Fix Line "
  },
  {
    "mcc": "625",
    "mnc": "02",
    "iso": "cv",
    "country": "Cape Verde",
    "countryCode": "238",
    "network": "Unitel T+ "
  },
  {
    "mcc": "346",
    "mnc": "050",
    "iso": "ky",
    "country": "Cayman Islands",
    "countryCode": "1345",
    "network": "Digicel "
  },
  {
    "mcc": "346",
    "mnc": "299",
    "iso": "ky",
    "country": "Cayman Islands",
    "countryCode": "1345",
    "network": "Failed Calls "
  },
  {
    "mcc": "346",
    "mnc": "999",
    "iso": "ky",
    "country": "Cayman Islands",
    "countryCode": "1345",
    "network": "Fix Line "
  },
  {
    "mcc": "346",
    "mnc": "140",
    "iso": "ky",
    "country": "Cayman Islands",
    "countryCode": "1345",
    "network": "Flow / Lime "
  },
  {
    "mcc": "346",
    "mnc": "001",
    "iso": "ky",
    "country": "Cayman Islands",
    "countryCode": "1345",
    "network": "Logic "
  },
  {
    "mcc": "623",
    "mnc": "04",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Azur "
  },
  {
    "mcc": "623",
    "mnc": "299",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Failed Calls "
  },
  {
    "mcc": "623",
    "mnc": "999",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Fix Line "
  },
  {
    "mcc": "623",
    "mnc": "01",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Moov "
  },
  {
    "mcc": "623",
    "mnc": "03",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Orange "
  },
  {
    "mcc": "623",
    "mnc": "299",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Socatel "
  },
  {
    "mcc": "623",
    "mnc": "02",
    "iso": "cf",
    "country": "Central African Republic",
    "countryCode": "236",
    "network": "Telecel "
  },
  {
    "mcc": "622",
    "mnc": "01",
    "iso": "td",
    "country": "Chad",
    "countryCode": "235",
    "network": "Airtel "
  },
  {
    "mcc": "622",
    "mnc": "299",
    "iso": "td",
    "country": "Chad",
    "countryCode": "235",
    "network": "Failed Calls "
  },
  {
    "mcc": "622",
    "mnc": "999",
    "iso": "td",
    "country": "Chad",
    "countryCode": "235",
    "network": "Fix Line "
  },
  {
    "mcc": "622",
    "mnc": "03",
    "iso": "td",
    "country": "Chad",
    "countryCode": "235",
    "network": "Moov "
  },
  {
    "mcc": "622",
    "mnc": "04",
    "iso": "td",
    "country": "Chad",
    "countryCode": "235",
    "network": "Salam "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Boby "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "CellOPS "
  },
  {
    "mcc": "730",
    "mnc": "22",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Cellplus "
  },
  {
    "mcc": "730",
    "mnc": "11",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Celupago "
  },
  {
    "mcc": "730",
    "mnc": "27",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Cibeles Telecom "
  },
  {
    "mcc": "730",
    "mnc": "15",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Cibeles Telecom "
  },
  {
    "mcc": "730",
    "mnc": "03",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Claro "
  },
  {
    "mcc": "730",
    "mnc": "23",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Claro "
  },
  {
    "mcc": "730",
    "mnc": "17",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Compatel "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Dotcom "
  },
  {
    "mcc": "730",
    "mnc": "18",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Empresas Bunker "
  },
  {
    "mcc": "730",
    "mnc": "01",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Entel "
  },
  {
    "mcc": "730",
    "mnc": "10",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Entel "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Failed Calls "
  },
  {
    "mcc": "730",
    "mnc": "999",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Fix Line "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "GTD Movil "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Industel "
  },
  {
    "mcc": "730",
    "mnc": "06",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "INNET "
  },
  {
    "mcc": "730",
    "mnc": "20",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Inversiones Santa Fe "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Mavi "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Mobilink "
  },
  {
    "mcc": "730",
    "mnc": "19",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Movil Falabella "
  },
  {
    "mcc": "730",
    "mnc": "02",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Movistar "
  },
  {
    "mcc": "730",
    "mnc": "07",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Movistar "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Mundo Pacifico "
  },
  {
    "mcc": "730",
    "mnc": "14",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Netline "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "NetUno "
  },
  {
    "mcc": "730",
    "mnc": "16",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Nomade Telecomunicaciones "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Quantax "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "RedVoiss "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Simple "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Swedcom "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Telcomax "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Telefonica Uno Uno Cuatro "
  },
  {
    "mcc": "730",
    "mnc": "12",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Telestar "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Television Interactiva "
  },
  {
    "mcc": "730",
    "mnc": "13",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "730",
    "mnc": "299",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "VOIP Analysis "
  },
  {
    "mcc": "730",
    "mnc": "08",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "VTR Movil "
  },
  {
    "mcc": "730",
    "mnc": "04",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "WOM "
  },
  {
    "mcc": "730",
    "mnc": "09",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "WOM "
  },
  {
    "mcc": "730",
    "mnc": "05",
    "iso": "cl",
    "country": "Chile",
    "countryCode": "56",
    "network": "WOM "
  },
  {
    "mcc": "460",
    "mnc": "04",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Mobile "
  },
  {
    "mcc": "460",
    "mnc": "07",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Mobile "
  },
  {
    "mcc": "460",
    "mnc": "08",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Mobile "
  },
  {
    "mcc": "460",
    "mnc": "02",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Mobile "
  },
  {
    "mcc": "460",
    "mnc": "00",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Mobile "
  },
  {
    "mcc": "460",
    "mnc": "11",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Telecom "
  },
  {
    "mcc": "460",
    "mnc": "12",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Telecom "
  },
  {
    "mcc": "460",
    "mnc": "03",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Telecom "
  },
  {
    "mcc": "460",
    "mnc": "06",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Unicom "
  },
  {
    "mcc": "460",
    "mnc": "01",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Unicom "
  },
  {
    "mcc": "460",
    "mnc": "10",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Unicom "
  },
  {
    "mcc": "460",
    "mnc": "09",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "China Unicom "
  },
  {
    "mcc": "460",
    "mnc": "299",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "Failed Calls "
  },
  {
    "mcc": "460",
    "mnc": "999",
    "iso": "cn",
    "country": "China",
    "countryCode": "86",
    "network": "Fix Line "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "ATnet "
  },
  {
    "mcc": "732",
    "mnc": "130",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Avantel "
  },
  {
    "mcc": "732",
    "mnc": "101",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Claro "
  },
  {
    "mcc": "732",
    "mnc": "666",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Claro "
  },
  {
    "mcc": "732",
    "mnc": "002",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Edatel "
  },
  {
    "mcc": "732",
    "mnc": "187",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "eTb "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Eztalk Mobile "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Failed Calls "
  },
  {
    "mcc": "732",
    "mnc": "999",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Fix Line "
  },
  {
    "mcc": "732",
    "mnc": "240",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Flash Mobile "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Gomobile "
  },
  {
    "mcc": "732",
    "mnc": "220",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Libre Tecnologias "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Movil Exito "
  },
  {
    "mcc": "732",
    "mnc": "123",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Movistar "
  },
  {
    "mcc": "732",
    "mnc": "001",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Movistar "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Plintron "
  },
  {
    "mcc": "732",
    "mnc": "230",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Setroc Mobile "
  },
  {
    "mcc": "732",
    "mnc": "199",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "SUMA movil "
  },
  {
    "mcc": "732",
    "mnc": "103",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Tigo "
  },
  {
    "mcc": "732",
    "mnc": "165",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Tigo "
  },
  {
    "mcc": "732",
    "mnc": "111",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Tigo "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "TuCEL "
  },
  {
    "mcc": "732",
    "mnc": "020",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "UNE "
  },
  {
    "mcc": "732",
    "mnc": "142",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "UNE "
  },
  {
    "mcc": "732",
    "mnc": "299",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Vilacom Mobile "
  },
  {
    "mcc": "732",
    "mnc": "154",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "732",
    "mnc": "360",
    "iso": "co",
    "country": "Colombia",
    "countryCode": "57",
    "network": "WOM "
  },
  {
    "mcc": "654",
    "mnc": "299",
    "iso": "km",
    "country": "Comoros",
    "countryCode": "269",
    "network": "Failed Calls "
  },
  {
    "mcc": "654",
    "mnc": "999",
    "iso": "km",
    "country": "Comoros",
    "countryCode": "269",
    "network": "Fix Line "
  },
  {
    "mcc": "654",
    "mnc": "01",
    "iso": "km",
    "country": "Comoros",
    "countryCode": "269",
    "network": "HURI "
  },
  {
    "mcc": "654",
    "mnc": "02",
    "iso": "km",
    "country": "Comoros",
    "countryCode": "269",
    "network": "Telma "
  },
  {
    "mcc": "629",
    "mnc": "01",
    "iso": "cg",
    "country": "Congo",
    "countryCode": "242",
    "network": "Airtel "
  },
  {
    "mcc": "629",
    "mnc": "299",
    "iso": "cg",
    "country": "Congo",
    "countryCode": "242",
    "network": "Failed Calls "
  },
  {
    "mcc": "629",
    "mnc": "999",
    "iso": "cg",
    "country": "Congo",
    "countryCode": "242",
    "network": "Fix Line "
  },
  {
    "mcc": "629",
    "mnc": "10",
    "iso": "cg",
    "country": "Congo",
    "countryCode": "242",
    "network": "MTN "
  },
  {
    "mcc": "629",
    "mnc": "07",
    "iso": "cg",
    "country": "Congo",
    "countryCode": "242",
    "network": "Warid "
  },
  {
    "mcc": "548",
    "mnc": "01",
    "iso": "ck",
    "country": "Cook Islands",
    "countryCode": "682",
    "network": "Vodafone / Bluesky "
  },
  {
    "mcc": "548",
    "mnc": "299",
    "iso": "ck",
    "country": "Cook Islands",
    "countryCode": "682",
    "network": "Failed Calls "
  },
  {
    "mcc": "548",
    "mnc": "999",
    "iso": "ck",
    "country": "Cook Islands",
    "countryCode": "682",
    "network": "Fix Line "
  },
  {
    "mcc": "712",
    "mnc": "03",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Claro "
  },
  {
    "mcc": "712",
    "mnc": "299",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Failed Calls "
  },
  {
    "mcc": "712",
    "mnc": "999",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Fix Line "
  },
  {
    "mcc": "712",
    "mnc": "02",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Kolbi / ICE "
  },
  {
    "mcc": "712",
    "mnc": "01",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Kolbi / ICE "
  },
  {
    "mcc": "712",
    "mnc": "04",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Movistar "
  },
  {
    "mcc": "712",
    "mnc": "299",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "MultiCom "
  },
  {
    "mcc": "712",
    "mnc": "299",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "racsa "
  },
  {
    "mcc": "712",
    "mnc": "299",
    "iso": "cr",
    "country": "Costa Rica",
    "countryCode": "506",
    "network": "Tuyo Movil "
  },
  {
    "mcc": "219",
    "mnc": "10",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "A1 / VIP "
  },
  {
    "mcc": "219",
    "mnc": "299",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "Failed Calls "
  },
  {
    "mcc": "219",
    "mnc": "999",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "Fix Line "
  },
  {
    "mcc": "219",
    "mnc": "01",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "T-Mobile "
  },
  {
    "mcc": "219",
    "mnc": "12",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "TELE FOCUS "
  },
  {
    "mcc": "219",
    "mnc": "02",
    "iso": "hr",
    "country": "Croatia",
    "countryCode": "385",
    "network": "Telemach / Tele2 "
  },
  {
    "mcc": "368",
    "mnc": "01",
    "iso": "cu",
    "country": "Cuba",
    "countryCode": "53",
    "network": "Cubacel "
  },
  {
    "mcc": "368",
    "mnc": "299",
    "iso": "cu",
    "country": "Cuba",
    "countryCode": "53",
    "network": "Failed Calls "
  },
  {
    "mcc": "368",
    "mnc": "999",
    "iso": "cu",
    "country": "Cuba",
    "countryCode": "53",
    "network": "Fix Line "
  },
  {
    "mcc": "368",
    "mnc": "299",
    "iso": "cu",
    "country": "Cuba",
    "countryCode": "53",
    "network": "MoviTel "
  },
  {
    "mcc": "280",
    "mnc": "22",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Cablenet / Lemontel "
  },
  {
    "mcc": "280",
    "mnc": "02",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Cytamobile-Vodafone "
  },
  {
    "mcc": "280",
    "mnc": "01",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Cytamobile-Vodafone "
  },
  {
    "mcc": "280",
    "mnc": "10",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Epic / MTN "
  },
  {
    "mcc": "280",
    "mnc": "299",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Failed Calls "
  },
  {
    "mcc": "280",
    "mnc": "999",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "Fix Line "
  },
  {
    "mcc": "280",
    "mnc": "20",
    "iso": "cy",
    "country": "Cyprus",
    "countryCode": "357",
    "network": "PrimeTel "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "+4U Mobile "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "3ton "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "CEZ "
  },
  {
    "mcc": "230",
    "mnc": "08",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Compatel "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Dragon "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "EriMobile "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Failed Calls "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Fayn "
  },
  {
    "mcc": "230",
    "mnc": "999",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Fix Line "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "GoMobil "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "ha-loo mobil "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Laudatio "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "METRONET "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "MOBIL21 "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Nej Mobil "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "NETBOX Mobil "
  },
  {
    "mcc": "230",
    "mnc": "04",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Nordic Telecom "
  },
  {
    "mcc": "230",
    "mnc": "02",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "O2 "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Odorik "
  },
  {
    "mcc": "230",
    "mnc": "05",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "PODA "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "SAZKA "
  },
  {
    "mcc": "230",
    "mnc": "98",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "SZDC "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "SZDC "
  },
  {
    "mcc": "230",
    "mnc": "01",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "T-Mobile "
  },
  {
    "mcc": "230",
    "mnc": "07",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "T-Mobile "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Tesco Mobile "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "TOPefekt "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "TT Quality "
  },
  {
    "mcc": "230",
    "mnc": "299",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Uniphone "
  },
  {
    "mcc": "230",
    "mnc": "09",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Uniphone "
  },
  {
    "mcc": "230",
    "mnc": "03",
    "iso": "cz",
    "country": "Czech Republic",
    "countryCode": "420",
    "network": "Vodafone "
  },
  {
    "mcc": "630",
    "mnc": "90",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Africell "
  },
  {
    "mcc": "630",
    "mnc": "02",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Airtel "
  },
  {
    "mcc": "630",
    "mnc": "299",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Failed Calls "
  },
  {
    "mcc": "630",
    "mnc": "999",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Fix Line "
  },
  {
    "mcc": "630",
    "mnc": "86",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Orange "
  },
  {
    "mcc": "630",
    "mnc": "05",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Supercell "
  },
  {
    "mcc": "630",
    "mnc": "299",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Tatem "
  },
  {
    "mcc": "630",
    "mnc": "01",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Vodacom "
  },
  {
    "mcc": "630",
    "mnc": "88",
    "iso": "cd",
    "country": "Democratic Republic of Congo",
    "countryCode": "243",
    "network": "Yozma Timeturns "
  },
  {
    "mcc": "238",
    "mnc": "06",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "3 "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "42 Telecom "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "5Tel "
  },
  {
    "mcc": "238",
    "mnc": "23",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Banedanmark "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Benemen "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Bolignet-Aarhus "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "CBB Mobil "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "celfon "
  },
  {
    "mcc": "238",
    "mnc": "88",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Cobira "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Companymobile "
  },
  {
    "mcc": "238",
    "mnc": "13",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Compatel "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Comtalk "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Evercall "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Failed Calls "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Firmafon "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Firstcom "
  },
  {
    "mcc": "238",
    "mnc": "999",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Fix Line "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Flexfone "
  },
  {
    "mcc": "238",
    "mnc": "17",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Gotanet "
  },
  {
    "mcc": "238",
    "mnc": "42",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Greenwave "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "ipnordic "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Ipvision "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Lancelot "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Lebara "
  },
  {
    "mcc": "238",
    "mnc": "28",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "LINK Mobility "
  },
  {
    "mcc": "238",
    "mnc": "12",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Lycamobile "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Maxtel.dk "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "MI Carrier Services "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Mitto "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Mobiweb "
  },
  {
    "mcc": "238",
    "mnc": "14",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Monty Mobile "
  },
  {
    "mcc": "238",
    "mnc": "15",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Net 1 "
  },
  {
    "mcc": "238",
    "mnc": "04",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Nexcon.io "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "NextM2M "
  },
  {
    "mcc": "238",
    "mnc": "73",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Onomondo "
  },
  {
    "mcc": "238",
    "mnc": "30",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Pareteum "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "SimService "
  },
  {
    "mcc": "238",
    "mnc": "03",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Syniverse "
  },
  {
    "mcc": "238",
    "mnc": "10",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "TDC "
  },
  {
    "mcc": "238",
    "mnc": "01",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "TDC "
  },
  {
    "mcc": "238",
    "mnc": "77",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Telenor "
  },
  {
    "mcc": "238",
    "mnc": "02",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Telenor "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Telenor Connexion "
  },
  {
    "mcc": "238",
    "mnc": "20",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Telia "
  },
  {
    "mcc": "238",
    "mnc": "96",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Telia "
  },
  {
    "mcc": "238",
    "mnc": "16",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Tismi "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Tripple Track "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Uni-tel "
  },
  {
    "mcc": "238",
    "mnc": "25",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Viahub "
  },
  {
    "mcc": "238",
    "mnc": "299",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Viptel "
  },
  {
    "mcc": "238",
    "mnc": "08",
    "iso": "dk",
    "country": "Denmark",
    "countryCode": "45",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "310",
    "mnc": "299",
    "iso": "dg",
    "country": "Diego Garcia",
    "countryCode": "246",
    "network": "Failed Calls "
  },
  {
    "mcc": "310",
    "mnc": "999",
    "iso": "dg",
    "country": "Diego Garcia",
    "countryCode": "246",
    "network": "Fix Line "
  },
  {
    "mcc": "310",
    "mnc": "299",
    "iso": "dg",
    "country": "Diego Garcia",
    "countryCode": "246",
    "network": "Sure "
  },
  {
    "mcc": "638",
    "mnc": "01",
    "iso": "dj",
    "country": "Djibouti",
    "countryCode": "253",
    "network": "Evatis "
  },
  {
    "mcc": "638",
    "mnc": "299",
    "iso": "dj",
    "country": "Djibouti",
    "countryCode": "253",
    "network": "Failed Calls "
  },
  {
    "mcc": "638",
    "mnc": "999",
    "iso": "dj",
    "country": "Djibouti",
    "countryCode": "253",
    "network": "Fix Line "
  },
  {
    "mcc": "366",
    "mnc": "050",
    "iso": "dm",
    "country": "Dominica",
    "countryCode": "1767",
    "network": "Digicel "
  },
  {
    "mcc": "366",
    "mnc": "299",
    "iso": "dm",
    "country": "Dominica",
    "countryCode": "1767",
    "network": "Failed Calls "
  },
  {
    "mcc": "366",
    "mnc": "999",
    "iso": "dm",
    "country": "Dominica",
    "countryCode": "1767",
    "network": "Fix Line "
  },
  {
    "mcc": "366",
    "mnc": "110",
    "iso": "dm",
    "country": "Dominica",
    "countryCode": "1767",
    "network": "Flow "
  },
  {
    "mcc": "370",
    "mnc": "02",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Claro "
  },
  {
    "mcc": "370",
    "mnc": "299",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Failed Calls "
  },
  {
    "mcc": "370",
    "mnc": "999",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Fix Line "
  },
  {
    "mcc": "370",
    "mnc": "01",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Orange / Altice "
  },
  {
    "mcc": "370",
    "mnc": "299",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Satel "
  },
  {
    "mcc": "370",
    "mnc": "04",
    "iso": "do",
    "country": "Dominican Republic",
    "countryCode": "1809",
    "network": "Viva "
  },
  {
    "mcc": "514",
    "mnc": "299",
    "iso": "tl",
    "country": "East Timor",
    "countryCode": "670",
    "network": "Failed Calls "
  },
  {
    "mcc": "514",
    "mnc": "999",
    "iso": "tl",
    "country": "East Timor",
    "countryCode": "670",
    "network": "Fix Line "
  },
  {
    "mcc": "514",
    "mnc": "03",
    "iso": "tl",
    "country": "East Timor",
    "countryCode": "670",
    "network": "Telemor "
  },
  {
    "mcc": "514",
    "mnc": "01",
    "iso": "tl",
    "country": "East Timor",
    "countryCode": "670",
    "network": "Telkomcel "
  },
  {
    "mcc": "514",
    "mnc": "02",
    "iso": "tl",
    "country": "East Timor",
    "countryCode": "670",
    "network": "Timor Telecom "
  },
  {
    "mcc": "740",
    "mnc": "01",
    "iso": "ec",
    "country": "Ecuador",
    "countryCode": "593",
    "network": "Claro "
  },
  {
    "mcc": "740",
    "mnc": "02",
    "iso": "ec",
    "country": "Ecuador",
    "countryCode": "593",
    "network": "CNT movil "
  },
  {
    "mcc": "740",
    "mnc": "299",
    "iso": "ec",
    "country": "Ecuador",
    "countryCode": "593",
    "network": "Failed Calls "
  },
  {
    "mcc": "740",
    "mnc": "999",
    "iso": "ec",
    "country": "Ecuador",
    "countryCode": "593",
    "network": "Fix Line "
  },
  {
    "mcc": "740",
    "mnc": "00",
    "iso": "ec",
    "country": "Ecuador",
    "countryCode": "593",
    "network": "Movistar "
  },
  {
    "mcc": "602",
    "mnc": "03",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "Etisalat "
  },
  {
    "mcc": "602",
    "mnc": "299",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "Failed Calls "
  },
  {
    "mcc": "602",
    "mnc": "999",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "Fix Line "
  },
  {
    "mcc": "602",
    "mnc": "01",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "Orange "
  },
  {
    "mcc": "602",
    "mnc": "02",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "Vodafone "
  },
  {
    "mcc": "602",
    "mnc": "04",
    "iso": "eg",
    "country": "Egypt",
    "countryCode": "20",
    "network": "WE "
  },
  {
    "mcc": "706",
    "mnc": "01",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Claro "
  },
  {
    "mcc": "706",
    "mnc": "02",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Digicel "
  },
  {
    "mcc": "706",
    "mnc": "299",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Failed Calls "
  },
  {
    "mcc": "706",
    "mnc": "999",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Fix Line "
  },
  {
    "mcc": "706",
    "mnc": "04",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Movistar "
  },
  {
    "mcc": "706",
    "mnc": "05",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "RED "
  },
  {
    "mcc": "706",
    "mnc": "03",
    "iso": "sv",
    "country": "El Salvador",
    "countryCode": "503",
    "network": "Tigo "
  },
  {
    "mcc": "627",
    "mnc": "299",
    "iso": "gq",
    "country": "Equatorial Guinea",
    "countryCode": "240",
    "network": "Failed Calls "
  },
  {
    "mcc": "627",
    "mnc": "999",
    "iso": "gq",
    "country": "Equatorial Guinea",
    "countryCode": "240",
    "network": "Fix Line "
  },
  {
    "mcc": "627",
    "mnc": "03",
    "iso": "gq",
    "country": "Equatorial Guinea",
    "countryCode": "240",
    "network": "Muni "
  },
  {
    "mcc": "627",
    "mnc": "01",
    "iso": "gq",
    "country": "Equatorial Guinea",
    "countryCode": "240",
    "network": "Orange "
  },
  {
    "mcc": "657",
    "mnc": "01",
    "iso": "er",
    "country": "Eritrea",
    "countryCode": "291",
    "network": "Eritel "
  },
  {
    "mcc": "657",
    "mnc": "299",
    "iso": "er",
    "country": "Eritrea",
    "countryCode": "291",
    "network": "Failed Calls "
  },
  {
    "mcc": "657",
    "mnc": "999",
    "iso": "er",
    "country": "Eritrea",
    "countryCode": "291",
    "network": "Fix Line "
  },
  {
    "mcc": "248",
    "mnc": "02",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Elisa "
  },
  {
    "mcc": "248",
    "mnc": "299",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Failed Calls "
  },
  {
    "mcc": "248",
    "mnc": "999",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Fix Line "
  },
  {
    "mcc": "248",
    "mnc": "03",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Tele2 "
  },
  {
    "mcc": "248",
    "mnc": "01",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Telia "
  },
  {
    "mcc": "248",
    "mnc": "13",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "Telia "
  },
  {
    "mcc": "248",
    "mnc": "04",
    "iso": "ee",
    "country": "Estonia",
    "countryCode": "372",
    "network": "TravelSim "
  },
  {
    "mcc": "636",
    "mnc": "01",
    "iso": "et",
    "country": "Ethiopia",
    "countryCode": "251",
    "network": "Ethio Mobile "
  },
  {
    "mcc": "636",
    "mnc": "299",
    "iso": "et",
    "country": "Ethiopia",
    "countryCode": "251",
    "network": "Failed Calls "
  },
  {
    "mcc": "636",
    "mnc": "999",
    "iso": "et",
    "country": "Ethiopia",
    "countryCode": "251",
    "network": "Fix Line "
  },
  {
    "mcc": "636",
    "mnc": "02",
    "iso": "et",
    "country": "Ethiopia",
    "countryCode": "251",
    "network": "Safaricom "
  },
  {
    "mcc": "750",
    "mnc": "999",
    "iso": "fk",
    "country": "Falkland Islands",
    "countryCode": "500",
    "network": "Fix Line "
  },
  {
    "mcc": "750",
    "mnc": "299",
    "iso": "fk",
    "country": "Falkland Islands",
    "countryCode": "500",
    "network": "Failed Calls "
  },
  {
    "mcc": "750",
    "mnc": "001",
    "iso": "fk",
    "country": "Falkland Islands",
    "countryCode": "500",
    "network": "Sure "
  },
  {
    "mcc": "288",
    "mnc": "299",
    "iso": "fo",
    "country": "Faroe Islands",
    "countryCode": "298",
    "network": "Failed Calls "
  },
  {
    "mcc": "288",
    "mnc": "01",
    "iso": "fo",
    "country": "Faroe Islands",
    "countryCode": "298",
    "network": "Faroese Telecom "
  },
  {
    "mcc": "288",
    "mnc": "999",
    "iso": "fo",
    "country": "Faroe Islands",
    "countryCode": "298",
    "network": "Fix Line "
  },
  {
    "mcc": "288",
    "mnc": "02",
    "iso": "fo",
    "country": "Faroe Islands",
    "countryCode": "298",
    "network": "Hey / Kall "
  },
  {
    "mcc": "288",
    "mnc": "03",
    "iso": "fo",
    "country": "Faroe Islands",
    "countryCode": "298",
    "network": "Tosa "
  },
  {
    "mcc": "542",
    "mnc": "02",
    "iso": "fj",
    "country": "Fiji",
    "countryCode": "679",
    "network": "DigiCell "
  },
  {
    "mcc": "542",
    "mnc": "299",
    "iso": "fj",
    "country": "Fiji",
    "countryCode": "679",
    "network": "Failed Calls "
  },
  {
    "mcc": "542",
    "mnc": "999",
    "iso": "fj",
    "country": "Fiji",
    "countryCode": "679",
    "network": "Fix Line "
  },
  {
    "mcc": "542",
    "mnc": "01",
    "iso": "fj",
    "country": "Fiji",
    "countryCode": "679",
    "network": "Vodafone "
  },
  {
    "mcc": "244",
    "mnc": "14",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Alcom "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Benemen "
  },
  {
    "mcc": "244",
    "mnc": "26",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Compatel "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Cuuma "
  },
  {
    "mcc": "244",
    "mnc": "12",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "DNA "
  },
  {
    "mcc": "244",
    "mnc": "13",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "DNA "
  },
  {
    "mcc": "244",
    "mnc": "04",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "DNA "
  },
  {
    "mcc": "244",
    "mnc": "03",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "DNA "
  },
  {
    "mcc": "244",
    "mnc": "06",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Elisa "
  },
  {
    "mcc": "244",
    "mnc": "21",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Elisa "
  },
  {
    "mcc": "244",
    "mnc": "05",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Elisa "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Failed Calls "
  },
  {
    "mcc": "244",
    "mnc": "999",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Fix Line "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "interactive digital media / IDM "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "IPIFY "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Lancelot "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "MI Carrier Services "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "MobiWeb "
  },
  {
    "mcc": "244",
    "mnc": "24",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Nord Connect "
  },
  {
    "mcc": "244",
    "mnc": "09",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "39",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "38",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "41",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "40",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "07",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "08",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "NSN "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Premium Numbers "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "RAILI "
  },
  {
    "mcc": "244",
    "mnc": "43",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Telavox "
  },
  {
    "mcc": "244",
    "mnc": "36",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Telia "
  },
  {
    "mcc": "244",
    "mnc": "91",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Telia "
  },
  {
    "mcc": "244",
    "mnc": "15",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Telit "
  },
  {
    "mcc": "244",
    "mnc": "37",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Tismi "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "TravelSim "
  },
  {
    "mcc": "244",
    "mnc": "299",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Twilio "
  },
  {
    "mcc": "244",
    "mnc": "35",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Ukko Mobile "
  },
  {
    "mcc": "244",
    "mnc": "42",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Viahub "
  },
  {
    "mcc": "244",
    "mnc": "46",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "VIRVE "
  },
  {
    "mcc": "244",
    "mnc": "45",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "VIRVE "
  },
  {
    "mcc": "244",
    "mnc": "33",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "VIRVE "
  },
  {
    "mcc": "244",
    "mnc": "47",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "VIRVE "
  },
  {
    "mcc": "244",
    "mnc": "32",
    "iso": "fi",
    "country": "Finland",
    "countryCode": "358",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Add-On Multimedia "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Afone Mobile "
  },
  {
    "mcc": "208",
    "mnc": "28",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Airmob "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Alphalink "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Alphalink "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Annatel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Atlas "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Auchan "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Auchan "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Axialys "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Bazile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "BJT "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "BJT "
  },
  {
    "mcc": "208",
    "mnc": "20",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Bouygues Telecom "
  },
  {
    "mcc": "208",
    "mnc": "88",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Bouygues Telecom "
  },
  {
    "mcc": "208",
    "mnc": "21",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Bouygues Telecom "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Bretagne Telecom "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CAT "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CELESTE "
  },
  {
    "mcc": "208",
    "mnc": "34",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Cellhire "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Codepi "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Coolwave "
  },
  {
    "mcc": "208",
    "mnc": "27",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Coriolis "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CPRO "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CRH "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CRT "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "CTExcel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Doctolib "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Failed Calls "
  },
  {
    "mcc": "208",
    "mnc": "999",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Fix Line "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Foliateam "
  },
  {
    "mcc": "208",
    "mnc": "15",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Free Mobile "
  },
  {
    "mcc": "208",
    "mnc": "36",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Free Mobile "
  },
  {
    "mcc": "208",
    "mnc": "35",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Free Mobile "
  },
  {
    "mcc": "208",
    "mnc": "16",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Free Mobile "
  },
  {
    "mcc": "208",
    "mnc": "94",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Halys "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Happy Telecom "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Hexatel "
  },
  {
    "mcc": "208",
    "mnc": "89",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Hub One "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "i-via "
  },
  {
    "mcc": "208",
    "mnc": "37",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "IP Directions "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "IP Telecom "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Iptis "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "JOi "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Kertel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Keyyo Mobile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "La Poste Mobile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "La Poste Mobile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "LASOTEL "
  },
  {
    "mcc": "208",
    "mnc": "38",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Lebara "
  },
  {
    "mcc": "208",
    "mnc": "17",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Legos "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Linkt "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "LITEYEAR "
  },
  {
    "mcc": "208",
    "mnc": "25",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Lycamobile "
  },
  {
    "mcc": "208",
    "mnc": "03",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "MobiquiThings "
  },
  {
    "mcc": "208",
    "mnc": "24",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "MobiquiThings "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Netcom "
  },
  {
    "mcc": "208",
    "mnc": "39",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Networth Telecom "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Nordnet "
  },
  {
    "mcc": "208",
    "mnc": "26",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "NRJ "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "onoff "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "OpenIP "
  },
  {
    "mcc": "208",
    "mnc": "01",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Orange "
  },
  {
    "mcc": "208",
    "mnc": "32",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Orange "
  },
  {
    "mcc": "208",
    "mnc": "91",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Orange "
  },
  {
    "mcc": "208",
    "mnc": "02",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Orange "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Paritel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Prixtel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Prixtel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SCT TELECOM "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SCT TELECOM "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Sewan Communications "
  },
  {
    "mcc": "208",
    "mnc": "10",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SFR "
  },
  {
    "mcc": "208",
    "mnc": "09",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SFR "
  },
  {
    "mcc": "208",
    "mnc": "13",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SFR "
  },
  {
    "mcc": "208",
    "mnc": "08",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SFR "
  },
  {
    "mcc": "208",
    "mnc": "11",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SFR "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "SIMbioz "
  },
  {
    "mcc": "208",
    "mnc": "30",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Syma Mobile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "TDF "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Tismi "
  },
  {
    "mcc": "208",
    "mnc": "22",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Transatel "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Trunkline "
  },
  {
    "mcc": "208",
    "mnc": "12",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Truphone "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "unyc "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "VA SOLUTIONS "
  },
  {
    "mcc": "208",
    "mnc": "31",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "208",
    "mnc": "299",
    "iso": "fr",
    "country": "France",
    "countryCode": "33",
    "network": "VOIP Telecom "
  },
  {
    "mcc": "547",
    "mnc": "299",
    "iso": "pf",
    "country": "French Polynesia",
    "countryCode": "689",
    "network": "Failed Calls "
  },
  {
    "mcc": "547",
    "mnc": "999",
    "iso": "pf",
    "country": "French Polynesia",
    "countryCode": "689",
    "network": "Fix Line "
  },
  {
    "mcc": "547",
    "mnc": "299",
    "iso": "pf",
    "country": "French Polynesia",
    "countryCode": "689",
    "network": "Ora "
  },
  {
    "mcc": "547",
    "mnc": "20",
    "iso": "pf",
    "country": "French Polynesia",
    "countryCode": "689",
    "network": "Vini "
  },
  {
    "mcc": "547",
    "mnc": "15",
    "iso": "pf",
    "country": "French Polynesia",
    "countryCode": "689",
    "network": "Vodafone "
  },
  {
    "mcc": "628",
    "mnc": "03",
    "iso": "ga",
    "country": "Gabon",
    "countryCode": "241",
    "network": "Airtel "
  },
  {
    "mcc": "628",
    "mnc": "299",
    "iso": "ga",
    "country": "Gabon",
    "countryCode": "241",
    "network": "Failed Calls "
  },
  {
    "mcc": "628",
    "mnc": "999",
    "iso": "ga",
    "country": "Gabon",
    "countryCode": "241",
    "network": "Fix Line "
  },
  {
    "mcc": "628",
    "mnc": "01",
    "iso": "ga",
    "country": "Gabon",
    "countryCode": "241",
    "network": "Libertis "
  },
  {
    "mcc": "607",
    "mnc": "02",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "Africel "
  },
  {
    "mcc": "607",
    "mnc": "03",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "Comium "
  },
  {
    "mcc": "607",
    "mnc": "299",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "Failed Calls "
  },
  {
    "mcc": "607",
    "mnc": "999",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "Fix Line "
  },
  {
    "mcc": "607",
    "mnc": "01",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "Gamcel "
  },
  {
    "mcc": "607",
    "mnc": "04",
    "iso": "gm",
    "country": "Gambia",
    "countryCode": "220",
    "network": "QCell "
  },
  {
    "mcc": "282",
    "mnc": "04",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Beeline "
  },
  {
    "mcc": "282",
    "mnc": "299",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Failed Calls "
  },
  {
    "mcc": "282",
    "mnc": "999",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Fix Line "
  },
  {
    "mcc": "282",
    "mnc": "01",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Geocell "
  },
  {
    "mcc": "282",
    "mnc": "07",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "GlobalCell "
  },
  {
    "mcc": "282",
    "mnc": "02",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "MagtiCom "
  },
  {
    "mcc": "282",
    "mnc": "11",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Mobilive "
  },
  {
    "mcc": "282",
    "mnc": "22",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "MyPhone "
  },
  {
    "mcc": "282",
    "mnc": "10",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Premium Net "
  },
  {
    "mcc": "282",
    "mnc": "08",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Silknet "
  },
  {
    "mcc": "282",
    "mnc": "12",
    "iso": "ge",
    "country": "Georgia",
    "countryCode": "995",
    "network": "Telecom 1 "
  },
  {
    "mcc": "262",
    "mnc": "23",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "1&1 "
  },
  {
    "mcc": "262",
    "mnc": "299",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Argon Networks "
  },
  {
    "mcc": "262",
    "mnc": "10",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "DB Netz "
  },
  {
    "mcc": "262",
    "mnc": "299",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Failed Calls "
  },
  {
    "mcc": "262",
    "mnc": "999",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Fix Line "
  },
  {
    "mcc": "262",
    "mnc": "14",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Lebara "
  },
  {
    "mcc": "262",
    "mnc": "43",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Lycamobile "
  },
  {
    "mcc": "262",
    "mnc": "13",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "T-mobile "
  },
  {
    "mcc": "262",
    "mnc": "25",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Mtel "
  },
  {
    "mcc": "262",
    "mnc": "21",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Multiconnect "
  },
  {
    "mcc": "262",
    "mnc": "22",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "sipgate "
  },
  {
    "mcc": "262",
    "mnc": "12",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "sipgate "
  },
  {
    "mcc": "262",
    "mnc": "06",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "T-mobile "
  },
  {
    "mcc": "262",
    "mnc": "78",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "T-mobile "
  },
  {
    "mcc": "262",
    "mnc": "01",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "T-mobile "
  },
  {
    "mcc": "262",
    "mnc": "24",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "TelcoVillage "
  },
  {
    "mcc": "262",
    "mnc": "20",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "03",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "05",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "17",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "11",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "07",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "16",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "08",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Telefonica / O2 "
  },
  {
    "mcc": "262",
    "mnc": "299",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Tismi "
  },
  {
    "mcc": "262",
    "mnc": "42",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Truphone "
  },
  {
    "mcc": "262",
    "mnc": "02",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Vodafone "
  },
  {
    "mcc": "262",
    "mnc": "09",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Vodafone "
  },
  {
    "mcc": "262",
    "mnc": "04",
    "iso": "de",
    "country": "Germany",
    "countryCode": "49",
    "network": "Vodafone "
  },
  {
    "mcc": "620",
    "mnc": "03",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Airtel "
  },
  {
    "mcc": "620",
    "mnc": "06",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Airtel "
  },
  {
    "mcc": "620",
    "mnc": "299",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Comsys "
  },
  {
    "mcc": "620",
    "mnc": "299",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Failed Calls "
  },
  {
    "mcc": "620",
    "mnc": "999",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Fix Line "
  },
  {
    "mcc": "620",
    "mnc": "07",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Glo "
  },
  {
    "mcc": "620",
    "mnc": "01",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "MTN "
  },
  {
    "mcc": "620",
    "mnc": "05",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "National Security "
  },
  {
    "mcc": "620",
    "mnc": "08",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Surfline "
  },
  {
    "mcc": "620",
    "mnc": "02",
    "iso": "gh",
    "country": "Ghana",
    "countryCode": "233",
    "network": "Vodafone "
  },
  {
    "mcc": "266",
    "mnc": "299",
    "iso": "gi",
    "country": "Gibraltar",
    "countryCode": "350",
    "network": "Failed Calls "
  },
  {
    "mcc": "266",
    "mnc": "999",
    "iso": "gi",
    "country": "Gibraltar",
    "countryCode": "350",
    "network": "Fix Line "
  },
  {
    "mcc": "266",
    "mnc": "299",
    "iso": "gi",
    "country": "Gibraltar",
    "countryCode": "350",
    "network": "GibFibreSpeed "
  },
  {
    "mcc": "266",
    "mnc": "01",
    "iso": "gi",
    "country": "Gibraltar",
    "countryCode": "350",
    "network": "Gibtel "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "AMD Telecom "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Apifon "
  },
  {
    "mcc": "202",
    "mnc": "15",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "BWS "
  },
  {
    "mcc": "202",
    "mnc": "02",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Cosmote "
  },
  {
    "mcc": "202",
    "mnc": "01",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Cosmote "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Failed Calls "
  },
  {
    "mcc": "202",
    "mnc": "999",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Fix Line "
  },
  {
    "mcc": "202",
    "mnc": "16",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Inter Telecom "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Interconnect "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "M-STAT "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Nova "
  },
  {
    "mcc": "202",
    "mnc": "04",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "OSE "
  },
  {
    "mcc": "202",
    "mnc": "03",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "OTE "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "OTEGLOBE "
  },
  {
    "mcc": "202",
    "mnc": "299",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Premium Net "
  },
  {
    "mcc": "202",
    "mnc": "05",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Vodafone "
  },
  {
    "mcc": "202",
    "mnc": "10",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Wind "
  },
  {
    "mcc": "202",
    "mnc": "09",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Wind "
  },
  {
    "mcc": "202",
    "mnc": "12",
    "iso": "gr",
    "country": "Greece",
    "countryCode": "30",
    "network": "Yuboto "
  },
  {
    "mcc": "290",
    "mnc": "299",
    "iso": "gl",
    "country": "Greenland",
    "countryCode": "299",
    "network": "Failed Calls "
  },
  {
    "mcc": "290",
    "mnc": "999",
    "iso": "gl",
    "country": "Greenland",
    "countryCode": "299",
    "network": "Fix Line "
  },
  {
    "mcc": "290",
    "mnc": "01",
    "iso": "gl",
    "country": "Greenland",
    "countryCode": "299",
    "network": "Tele Greenland "
  },
  {
    "mcc": "352",
    "mnc": "050",
    "iso": "gd",
    "country": "Grenada",
    "countryCode": "1473",
    "network": "Digicel "
  },
  {
    "mcc": "352",
    "mnc": "299",
    "iso": "gd",
    "country": "Grenada",
    "countryCode": "1473",
    "network": "Failed Calls "
  },
  {
    "mcc": "352",
    "mnc": "999",
    "iso": "gd",
    "country": "Grenada",
    "countryCode": "1473",
    "network": "Fix Line "
  },
  {
    "mcc": "352",
    "mnc": "110",
    "iso": "gd",
    "country": "Grenada",
    "countryCode": "1473",
    "network": "Flow "
  },
  {
    "mcc": "352",
    "mnc": "299",
    "iso": "gd",
    "country": "Grenada",
    "countryCode": "1473",
    "network": "Spice Mobile "
  },
  {
    "mcc": "340",
    "mnc": "08",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Amigo "
  },
  {
    "mcc": "340",
    "mnc": "20",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Digicel "
  },
  {
    "mcc": "340",
    "mnc": "299",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Failed Calls "
  },
  {
    "mcc": "340",
    "mnc": "999",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Fix Line "
  },
  {
    "mcc": "340",
    "mnc": "04",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Free "
  },
  {
    "mcc": "340",
    "mnc": "01",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "Orange "
  },
  {
    "mcc": "340",
    "mnc": "02",
    "iso": "gf",
    "country": "Guadeloupe and Martinique and French Guiana",
    "countryCode": "594",
    "network": "SFR "
  },
  {
    "mcc": "310",
    "mnc": "370",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "Docomo Pacific "
  },
  {
    "mcc": "310",
    "mnc": "470",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "Docomo Pacific "
  },
  {
    "mcc": "310",
    "mnc": "299",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "Failed Calls "
  },
  {
    "mcc": "310",
    "mnc": "999",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "Fix Line "
  },
  {
    "mcc": "310",
    "mnc": "140",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "GTA "
  },
  {
    "mcc": "310",
    "mnc": "110",
    "iso": "gu",
    "country": "Guam",
    "countryCode": "1671",
    "network": "IT&E "
  },
  {
    "mcc": "704",
    "mnc": "01",
    "iso": "gt",
    "country": "Guatemala",
    "countryCode": "502",
    "network": "Claro "
  },
  {
    "mcc": "704",
    "mnc": "299",
    "iso": "gt",
    "country": "Guatemala",
    "countryCode": "502",
    "network": "Failed Calls "
  },
  {
    "mcc": "704",
    "mnc": "999",
    "iso": "gt",
    "country": "Guatemala",
    "countryCode": "502",
    "network": "Fix Line "
  },
  {
    "mcc": "704",
    "mnc": "03",
    "iso": "gt",
    "country": "Guatemala",
    "countryCode": "502",
    "network": "Movistar "
  },
  {
    "mcc": "704",
    "mnc": "02",
    "iso": "gt",
    "country": "Guatemala",
    "countryCode": "502",
    "network": "Tigo "
  },
  {
    "mcc": "611",
    "mnc": "05",
    "iso": "gn",
    "country": "Guinea",
    "countryCode": "224",
    "network": "Cellcom "
  },
  {
    "mcc": "611",
    "mnc": "299",
    "iso": "gn",
    "country": "Guinea",
    "countryCode": "224",
    "network": "Failed Calls "
  },
  {
    "mcc": "611",
    "mnc": "999",
    "iso": "gn",
    "country": "Guinea",
    "countryCode": "224",
    "network": "Fix Line "
  },
  {
    "mcc": "611",
    "mnc": "04",
    "iso": "gn",
    "country": "Guinea",
    "countryCode": "224",
    "network": "MTN "
  },
  {
    "mcc": "611",
    "mnc": "01",
    "iso": "gn",
    "country": "Guinea",
    "countryCode": "224",
    "network": "Orange "
  },
  {
    "mcc": "632",
    "mnc": "299",
    "iso": "gw",
    "country": "Guinea-Bissau",
    "countryCode": "245",
    "network": "Failed Calls "
  },
  {
    "mcc": "632",
    "mnc": "999",
    "iso": "gw",
    "country": "Guinea-Bissau",
    "countryCode": "245",
    "network": "Fix Line "
  },
  {
    "mcc": "632",
    "mnc": "01",
    "iso": "gw",
    "country": "Guinea-Bissau",
    "countryCode": "245",
    "network": "Guinetel "
  },
  {
    "mcc": "632",
    "mnc": "02",
    "iso": "gw",
    "country": "Guinea-Bissau",
    "countryCode": "245",
    "network": "MTN "
  },
  {
    "mcc": "632",
    "mnc": "03",
    "iso": "gw",
    "country": "Guinea-Bissau",
    "countryCode": "245",
    "network": "Orange "
  },
  {
    "mcc": "738",
    "mnc": "02",
    "iso": "gy",
    "country": "Guyana",
    "countryCode": "592",
    "network": "Cellink "
  },
  {
    "mcc": "738",
    "mnc": "01",
    "iso": "gy",
    "country": "Guyana",
    "countryCode": "592",
    "network": "Digicel "
  },
  {
    "mcc": "738",
    "mnc": "299",
    "iso": "gy",
    "country": "Guyana",
    "countryCode": "592",
    "network": "Failed Calls "
  },
  {
    "mcc": "738",
    "mnc": "999",
    "iso": "gy",
    "country": "Guyana",
    "countryCode": "592",
    "network": "Fix Line "
  },
  {
    "mcc": "372",
    "mnc": "02",
    "iso": "ht",
    "country": "Haiti",
    "countryCode": "509",
    "network": "Digicel "
  },
  {
    "mcc": "372",
    "mnc": "299",
    "iso": "ht",
    "country": "Haiti",
    "countryCode": "509",
    "network": "Failed Calls "
  },
  {
    "mcc": "372",
    "mnc": "999",
    "iso": "ht",
    "country": "Haiti",
    "countryCode": "509",
    "network": "Fix Line "
  },
  {
    "mcc": "372",
    "mnc": "03",
    "iso": "ht",
    "country": "Haiti",
    "countryCode": "509",
    "network": "Natcom "
  },
  {
    "mcc": "708",
    "mnc": "01",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Claro "
  },
  {
    "mcc": "708",
    "mnc": "001",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Claro "
  },
  {
    "mcc": "708",
    "mnc": "299",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Failed Calls "
  },
  {
    "mcc": "708",
    "mnc": "999",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Fix Line "
  },
  {
    "mcc": "708",
    "mnc": "030",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "HonduTel "
  },
  {
    "mcc": "708",
    "mnc": "30",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "HonduTel "
  },
  {
    "mcc": "708",
    "mnc": "002",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Tigo "
  },
  {
    "mcc": "708",
    "mnc": "02",
    "iso": "hn",
    "country": "Honduras",
    "countryCode": "504",
    "network": "Tigo "
  },
  {
    "mcc": "454",
    "mnc": "14",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "3 "
  },
  {
    "mcc": "454",
    "mnc": "05",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "3 "
  },
  {
    "mcc": "454",
    "mnc": "04",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "3 "
  },
  {
    "mcc": "454",
    "mnc": "03",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "3 "
  },
  {
    "mcc": "454",
    "mnc": "32",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "HKBN "
  },
  {
    "mcc": "454",
    "mnc": "13",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "China Mobile "
  },
  {
    "mcc": "454",
    "mnc": "30",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "China Mobile "
  },
  {
    "mcc": "454",
    "mnc": "12",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "China Mobile "
  },
  {
    "mcc": "454",
    "mnc": "07",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "China Unicom "
  },
  {
    "mcc": "454",
    "mnc": "11",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "CHKTL "
  },
  {
    "mcc": "454",
    "mnc": "01",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Citic "
  },
  {
    "mcc": "454",
    "mnc": "31",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "CTExcel "
  },
  {
    "mcc": "454",
    "mnc": "36",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Eascotel "
  },
  {
    "mcc": "454",
    "mnc": "999",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Fix Line "
  },
  {
    "mcc": "454",
    "mnc": "390",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "394",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "398",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "27",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "393",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "25",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "397",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "392",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "396",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "28",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "26",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "391",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "395",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Government "
  },
  {
    "mcc": "454",
    "mnc": "24",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Multibyte "
  },
  {
    "mcc": "454",
    "mnc": "15",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SmarTone "
  },
  {
    "mcc": "454",
    "mnc": "17",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SmarTone "
  },
  {
    "mcc": "454",
    "mnc": "06",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SmarTone "
  },
  {
    "mcc": "454",
    "mnc": "18",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "19",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "00",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "02",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "16",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "10",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "20",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "SUN Mobile / CSL "
  },
  {
    "mcc": "454",
    "mnc": "08",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Tru "
  },
  {
    "mcc": "454",
    "mnc": "35",
    "iso": "hk",
    "country": "Hong Kong",
    "countryCode": "852",
    "network": "Webbing "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Antenna "
  },
  {
    "mcc": "216",
    "mnc": "03",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Digi "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Failed Calls "
  },
  {
    "mcc": "216",
    "mnc": "999",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Fix line "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Invitech "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Mobil4 "
  },
  {
    "mcc": "216",
    "mnc": "02",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "MVM NET "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Netfone "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "TARR "
  },
  {
    "mcc": "216",
    "mnc": "30",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Telekom "
  },
  {
    "mcc": "216",
    "mnc": "01",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Telenor "
  },
  {
    "mcc": "216",
    "mnc": "299",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Vidanet "
  },
  {
    "mcc": "216",
    "mnc": "70",
    "iso": "hu",
    "country": "Hungary",
    "countryCode": "36",
    "network": "Vodafone "
  },
  {
    "mcc": "274",
    "mnc": "299",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Failed Calls "
  },
  {
    "mcc": "274",
    "mnc": "999",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Fix Line "
  },
  {
    "mcc": "274",
    "mnc": "11",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "NOVA "
  },
  {
    "mcc": "274",
    "mnc": "08",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Siminn "
  },
  {
    "mcc": "274",
    "mnc": "01",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Siminn "
  },
  {
    "mcc": "274",
    "mnc": "31",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Siminn "
  },
  {
    "mcc": "274",
    "mnc": "16",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Tismi "
  },
  {
    "mcc": "274",
    "mnc": "04",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Viking Wireless "
  },
  {
    "mcc": "274",
    "mnc": "02",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Vodafone "
  },
  {
    "mcc": "274",
    "mnc": "12",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Vodafone "
  },
  {
    "mcc": "274",
    "mnc": "03",
    "iso": "is",
    "country": "Iceland",
    "countryCode": "354",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "28",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "98",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "49",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "41",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "42",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "29",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "94",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "06",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "29",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "70",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "91",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "25",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "42",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "41",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "28",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "95",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "10",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "33",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "90",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "91",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "37",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "17",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "35",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "96",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "16",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "35",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "92",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "02",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "25",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "17",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "97",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "31",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "37",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "404",
    "mnc": "33",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Aircel "
  },
  {
    "mcc": "405",
    "mnc": "93",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "03",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "96",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "02",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "90",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "16",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "95",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "70",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "10",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "94",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "98",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "06",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "93",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "49",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "97",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "03",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "92",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "404",
    "mnc": "31",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Airtel "
  },
  {
    "mcc": "405",
    "mnc": "59",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "74",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "38",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "72",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "64",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "81",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "54",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "77",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "55",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "62",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "73",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "34",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "34",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "73",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "62",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "80",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "55",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "77",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "80",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "54",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "64",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "72",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "38",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "74",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "59",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "57",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "76",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "81",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "53",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "66",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "71",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "51",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "75",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "58",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "58",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "75",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "51",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "71",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "66",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "53",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "76",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "404",
    "mnc": "57",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "BSNL Mobile "
  },
  {
    "mcc": "405",
    "mnc": "69",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Dolphin "
  },
  {
    "mcc": "404",
    "mnc": "69",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Dolphin "
  },
  {
    "mcc": "404",
    "mnc": "299",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Failed Calls "
  },
  {
    "mcc": "405",
    "mnc": "999",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Fix Line "
  },
  {
    "mcc": "404",
    "mnc": "999",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Fix Line "
  },
  {
    "mcc": "405",
    "mnc": "68",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Garuda "
  },
  {
    "mcc": "404",
    "mnc": "68",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Garuda "
  },
  {
    "mcc": "405",
    "mnc": "89",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "19",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "82",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "848",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "07",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "850",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "56",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "24",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "853",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "14",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "845",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "846",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "12",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "852",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "44",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "44",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "852",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "12",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "846",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "845",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "14",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "853",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "24",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "56",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "850",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "07",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "848",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "82",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "19",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "89",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "87",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "22",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "78",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "849",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "04",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "04",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "849",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "78",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "22",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "404",
    "mnc": "87",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Idea "
  },
  {
    "mcc": "405",
    "mnc": "871",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "860",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "862",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "870",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "861",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "867",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "858",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "857",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "874",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "866",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "872",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "863",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "854",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "854",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "871",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "861",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "862",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "868",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "859",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "867",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "873",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "864",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "855",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "855",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "872",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "863",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "869",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "858",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "860",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "868",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "874",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "865",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "856",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "873",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "864",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "870",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "859",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "861",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "869",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "866",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "857",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "856",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "404",
    "mnc": "865",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Jio "
  },
  {
    "mcc": "405",
    "mnc": "21",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Loop Mobile "
  },
  {
    "mcc": "404",
    "mnc": "21",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Loop Mobile "
  },
  {
    "mcc": "404",
    "mnc": "52",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "08",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "18",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "18",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "67",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "67",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "09",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "23",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "23",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "83",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "83",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "36",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "36",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "85",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "08",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "85",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "50",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "404",
    "mnc": "50",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "09",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "52",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Reliance Mobile "
  },
  {
    "mcc": "405",
    "mnc": "30",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "27",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "86",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "05",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "13",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "60",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "43",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "20",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "01",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "88",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "01",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "15",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "46",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "46",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "15",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "88",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "20",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "43",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "60",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "13",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "05",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "86",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "27",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "30",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "84",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "11",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "405",
    "mnc": "11",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "404",
    "mnc": "84",
    "iso": "in",
    "country": "India",
    "countryCode": "91",
    "network": "Vodafone "
  },
  {
    "mcc": "510",
    "mnc": "89",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "3 "
  },
  {
    "mcc": "510",
    "mnc": "299",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Failed Calls "
  },
  {
    "mcc": "510",
    "mnc": "999",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Fix Line "
  },
  {
    "mcc": "510",
    "mnc": "01",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Indosat Ooredoo "
  },
  {
    "mcc": "510",
    "mnc": "21",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Indosat Ooredoo "
  },
  {
    "mcc": "510",
    "mnc": "62",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Indosat Ooredoo "
  },
  {
    "mcc": "510",
    "mnc": "27",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Net1 "
  },
  {
    "mcc": "510",
    "mnc": "09",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Smartfren "
  },
  {
    "mcc": "510",
    "mnc": "28",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Smartfren "
  },
  {
    "mcc": "510",
    "mnc": "99",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Smartfren "
  },
  {
    "mcc": "510",
    "mnc": "10",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Telkomsel "
  },
  {
    "mcc": "510",
    "mnc": "20",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "Telkomsel "
  },
  {
    "mcc": "510",
    "mnc": "08",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "XL "
  },
  {
    "mcc": "510",
    "mnc": "11",
    "iso": "id",
    "country": "Indonesia",
    "countryCode": "62",
    "network": "XL "
  },
  {
    "mcc": "901",
    "mnc": "67",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "1NCE "
  },
  {
    "mcc": "901",
    "mnc": "76",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "A1 "
  },
  {
    "mcc": "901",
    "mnc": "14",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "AeroMobile "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Afinna One "
  },
  {
    "mcc": "901",
    "mnc": "81",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Airnity "
  },
  {
    "mcc": "901",
    "mnc": "82",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "AnyNet "
  },
  {
    "mcc": "901",
    "mnc": "24",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Bandwidth "
  },
  {
    "mcc": "901",
    "mnc": "55",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Beezz "
  },
  {
    "mcc": "901",
    "mnc": "58",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "BICS "
  },
  {
    "mcc": "901",
    "mnc": "70",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Bubbletone "
  },
  {
    "mcc": "901",
    "mnc": "18",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Cingular Wireless Network "
  },
  {
    "mcc": "901",
    "mnc": "16",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Cisco Jasper "
  },
  {
    "mcc": "901",
    "mnc": "48",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Com4 Sweden "
  },
  {
    "mcc": "901",
    "mnc": "73",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Cubic "
  },
  {
    "mcc": "901",
    "mnc": "42",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "DCN Hub "
  },
  {
    "mcc": "901",
    "mnc": "40",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Deutsche Telekom "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "DIDWW "
  },
  {
    "mcc": "901",
    "mnc": "50",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "EchoStar Mobile "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Ellipsat "
  },
  {
    "mcc": "901",
    "mnc": "43",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "EMnify "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "EMSAT "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Failed Calls "
  },
  {
    "mcc": "901",
    "mnc": "999",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Fix Line "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Global Access Services "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Globalstar "
  },
  {
    "mcc": "901",
    "mnc": "13",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "GSM.AQ "
  },
  {
    "mcc": "901",
    "mnc": "22",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "i-lincc "
  },
  {
    "mcc": "901",
    "mnc": "11",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Inmarsat "
  },
  {
    "mcc": "901",
    "mnc": "20",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Intermatica "
  },
  {
    "mcc": "901",
    "mnc": "03",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Iridium "
  },
  {
    "mcc": "901",
    "mnc": "69",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Legos "
  },
  {
    "mcc": "901",
    "mnc": "66",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Limitless "
  },
  {
    "mcc": "901",
    "mnc": "52",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Manx Telecom "
  },
  {
    "mcc": "901",
    "mnc": "19",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Maritime Roaming Service "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "MCNtelecom "
  },
  {
    "mcc": "901",
    "mnc": "12",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "MCP "
  },
  {
    "mcc": "901",
    "mnc": "59",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "MessageBird "
  },
  {
    "mcc": "901",
    "mnc": "27",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Monaco Telecom "
  },
  {
    "mcc": "901",
    "mnc": "84",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Movistar "
  },
  {
    "mcc": "901",
    "mnc": "38",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "MTT "
  },
  {
    "mcc": "901",
    "mnc": "39",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "MTX Connect "
  },
  {
    "mcc": "901",
    "mnc": "17",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Navitas Telecom "
  },
  {
    "mcc": "901",
    "mnc": "79",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Nokia "
  },
  {
    "mcc": "901",
    "mnc": "85",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "O2 "
  },
  {
    "mcc": "901",
    "mnc": "15",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "OnAir "
  },
  {
    "mcc": "901",
    "mnc": "41",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "One Network "
  },
  {
    "mcc": "901",
    "mnc": "47",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Ooredoo "
  },
  {
    "mcc": "901",
    "mnc": "31",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Orange "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Oration Technologies "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Phonegroup "
  },
  {
    "mcc": "901",
    "mnc": "65",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Plintron "
  },
  {
    "mcc": "901",
    "mnc": "75",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Pod "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "republic wireless "
  },
  {
    "mcc": "901",
    "mnc": "57",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "SAP "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Sipme "
  },
  {
    "mcc": "901",
    "mnc": "33",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "SMART "
  },
  {
    "mcc": "901",
    "mnc": "78",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Sparkle "
  },
  {
    "mcc": "901",
    "mnc": "64",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Syniverse "
  },
  {
    "mcc": "901",
    "mnc": "72",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Tele2 "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Telecom26 "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Telekom Malaysia "
  },
  {
    "mcc": "901",
    "mnc": "29",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Telenor Connexion "
  },
  {
    "mcc": "901",
    "mnc": "05",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Thuraya RMSS "
  },
  {
    "mcc": "901",
    "mnc": "37",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Transatel "
  },
  {
    "mcc": "901",
    "mnc": "62",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Twilio "
  },
  {
    "mcc": "901",
    "mnc": "34",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "tyntec "
  },
  {
    "mcc": "901",
    "mnc": "51",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "VisionNG "
  },
  {
    "mcc": "901",
    "mnc": "21",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Wins "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "International Networks",
    "countryCode": "882",
    "network": "Zain "
  },
  {
    "mcc": "432",
    "mnc": "299",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Anarestan "
  },
  {
    "mcc": "432",
    "mnc": "299",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "ApTel "
  },
  {
    "mcc": "432",
    "mnc": "299",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Arian Tel "
  },
  {
    "mcc": "432",
    "mnc": "299",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Failed Calls "
  },
  {
    "mcc": "432",
    "mnc": "999",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Fix Line "
  },
  {
    "mcc": "432",
    "mnc": "299",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "LotusTel "
  },
  {
    "mcc": "432",
    "mnc": "11",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "MCI "
  },
  {
    "mcc": "432",
    "mnc": "19",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "MTCE "
  },
  {
    "mcc": "432",
    "mnc": "35",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "MTN IranCell "
  },
  {
    "mcc": "432",
    "mnc": "20",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "RighTel "
  },
  {
    "mcc": "432",
    "mnc": "01",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "SamanTel "
  },
  {
    "mcc": "432",
    "mnc": "08",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Shatel Mobile "
  },
  {
    "mcc": "432",
    "mnc": "32",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Taliya "
  },
  {
    "mcc": "432",
    "mnc": "14",
    "iso": "ir",
    "country": "Iran",
    "countryCode": "98",
    "network": "Telekish "
  },
  {
    "mcc": "418",
    "mnc": "05",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Asia Cell "
  },
  {
    "mcc": "418",
    "mnc": "299",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Failed Calls "
  },
  {
    "mcc": "418",
    "mnc": "999",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Fix Line "
  },
  {
    "mcc": "418",
    "mnc": "40",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Korek "
  },
  {
    "mcc": "418",
    "mnc": "45",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Mobitel "
  },
  {
    "mcc": "418",
    "mnc": "30",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Zain "
  },
  {
    "mcc": "418",
    "mnc": "20",
    "iso": "iq",
    "country": "Iraq",
    "countryCode": "964",
    "network": "Zain "
  },
  {
    "mcc": "272",
    "mnc": "02",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "3 "
  },
  {
    "mcc": "272",
    "mnc": "17",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "3 "
  },
  {
    "mcc": "272",
    "mnc": "05",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "3 "
  },
  {
    "mcc": "272",
    "mnc": "299",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "BT "
  },
  {
    "mcc": "272",
    "mnc": "16",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Carphone Mobile "
  },
  {
    "mcc": "272",
    "mnc": "299",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Cubic Telecom "
  },
  {
    "mcc": "272",
    "mnc": "299",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Failed Calls "
  },
  {
    "mcc": "272",
    "mnc": "999",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Fix Line "
  },
  {
    "mcc": "272",
    "mnc": "13",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Lycamobile "
  },
  {
    "mcc": "272",
    "mnc": "03",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Meteor "
  },
  {
    "mcc": "272",
    "mnc": "07",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Meteor "
  },
  {
    "mcc": "272",
    "mnc": "08",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Meteor "
  },
  {
    "mcc": "272",
    "mnc": "299",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Net Feasa "
  },
  {
    "mcc": "272",
    "mnc": "299",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "OGCIO "
  },
  {
    "mcc": "272",
    "mnc": "11",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Tesco Mobile "
  },
  {
    "mcc": "272",
    "mnc": "15",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Virgin Media "
  },
  {
    "mcc": "272",
    "mnc": "01",
    "iso": "ie",
    "country": "Ireland",
    "countryCode": "353",
    "network": "Vodafone "
  },
  {
    "mcc": "425",
    "mnc": "19",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "019 Mobile "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Annatel Mobile "
  },
  {
    "mcc": "425",
    "mnc": "23",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Beezz "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Bynet "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Cellact "
  },
  {
    "mcc": "425",
    "mnc": "02",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Cellcom "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Failed Calls "
  },
  {
    "mcc": "425",
    "mnc": "999",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Fix Line "
  },
  {
    "mcc": "425",
    "mnc": "08",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Golan Telecom "
  },
  {
    "mcc": "425",
    "mnc": "15",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Home Cellular "
  },
  {
    "mcc": "425",
    "mnc": "77",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Hot Mobile "
  },
  {
    "mcc": "425",
    "mnc": "07",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Hot Mobile "
  },
  {
    "mcc": "425",
    "mnc": "13",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Ituran "
  },
  {
    "mcc": "425",
    "mnc": "22",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Maskyoo "
  },
  {
    "mcc": "425",
    "mnc": "01",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Orange "
  },
  {
    "mcc": "425",
    "mnc": "03",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Pelephone "
  },
  {
    "mcc": "425",
    "mnc": "12",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Pelephone "
  },
  {
    "mcc": "425",
    "mnc": "16",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Rami Levy Communications "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "T2T "
  },
  {
    "mcc": "425",
    "mnc": "17",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "Von waves "
  },
  {
    "mcc": "425",
    "mnc": "09",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "We4G "
  },
  {
    "mcc": "425",
    "mnc": "14",
    "iso": "il",
    "country": "Israel",
    "countryCode": "972",
    "network": "YouPhone "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "1Mobile "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "A-Tono "
  },
  {
    "mcc": "222",
    "mnc": "40",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Agile Telecom "
  },
  {
    "mcc": "222",
    "mnc": "34",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "BT mobile "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Esendex "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Compatel "
  },
  {
    "mcc": "222",
    "mnc": "53",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "CoopVoce "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Daily Telecom Mobile "
  },
  {
    "mcc": "222",
    "mnc": "36",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Digi "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "DireQ "
  },
  {
    "mcc": "222",
    "mnc": "42",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Enel "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Failed Calls "
  },
  {
    "mcc": "222",
    "mnc": "08",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Fastweb "
  },
  {
    "mcc": "222",
    "mnc": "999",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Fix Line "
  },
  {
    "mcc": "222",
    "mnc": "99",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "WindTre / Hi3G "
  },
  {
    "mcc": "222",
    "mnc": "50",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Iliad "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Kaleyra "
  },
  {
    "mcc": "222",
    "mnc": "39",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "SMS.it / LINK Mobility "
  },
  {
    "mcc": "222",
    "mnc": "35",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Lycamobile "
  },
  {
    "mcc": "222",
    "mnc": "07",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Noverca Italia "
  },
  {
    "mcc": "222",
    "mnc": "54",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Plintron "
  },
  {
    "mcc": "222",
    "mnc": "33",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Poste Mobile "
  },
  {
    "mcc": "222",
    "mnc": "999",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Premium Numbers "
  },
  {
    "mcc": "222",
    "mnc": "58",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "rdcom "
  },
  {
    "mcc": "222",
    "mnc": "30",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "RFI "
  },
  {
    "mcc": "222",
    "mnc": "56",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "spusu "
  },
  {
    "mcc": "222",
    "mnc": "01",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "TIM "
  },
  {
    "mcc": "222",
    "mnc": "48",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Telecom Italia Mobile "
  },
  {
    "mcc": "222",
    "mnc": "43",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Telecom Italia Mobile "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Sparkle "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Tiscali "
  },
  {
    "mcc": "222",
    "mnc": "44",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Mundio "
  },
  {
    "mcc": "222",
    "mnc": "51",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "ho. "
  },
  {
    "mcc": "222",
    "mnc": "49",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Vianova Mobile "
  },
  {
    "mcc": "222",
    "mnc": "10",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Vodafone "
  },
  {
    "mcc": "222",
    "mnc": "06",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Vodafone "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Vola "
  },
  {
    "mcc": "222",
    "mnc": "299",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "Webcom "
  },
  {
    "mcc": "222",
    "mnc": "88",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "WindTre / WIND "
  },
  {
    "mcc": "222",
    "mnc": "37",
    "iso": "it",
    "country": "Italy",
    "countryCode": "39",
    "network": "WindTre / Hi3G "
  },
  {
    "mcc": "612",
    "mnc": "299",
    "iso": "ci",
    "country": "Ivory Coast",
    "countryCode": "225",
    "network": "Failed Calls "
  },
  {
    "mcc": "612",
    "mnc": "999",
    "iso": "ci",
    "country": "Ivory Coast",
    "countryCode": "225",
    "network": "Fix Line "
  },
  {
    "mcc": "612",
    "mnc": "02",
    "iso": "ci",
    "country": "Ivory Coast",
    "countryCode": "225",
    "network": "Moov "
  },
  {
    "mcc": "612",
    "mnc": "05",
    "iso": "ci",
    "country": "Ivory Coast",
    "countryCode": "225",
    "network": "MTN "
  },
  {
    "mcc": "612",
    "mnc": "03",
    "iso": "ci",
    "country": "Ivory Coast",
    "countryCode": "225",
    "network": "Orange "
  },
  {
    "mcc": "338",
    "mnc": "050",
    "iso": "jm",
    "country": "Jamaica",
    "countryCode": "1876",
    "network": "Digicel "
  },
  {
    "mcc": "338",
    "mnc": "299",
    "iso": "jm",
    "country": "Jamaica",
    "countryCode": "1876",
    "network": "Failed Calls "
  },
  {
    "mcc": "338",
    "mnc": "999",
    "iso": "jm",
    "country": "Jamaica",
    "countryCode": "1876",
    "network": "Fix Line "
  },
  {
    "mcc": "338",
    "mnc": "110",
    "iso": "jm",
    "country": "Jamaica",
    "countryCode": "1876",
    "network": "Flow "
  },
  {
    "mcc": "338",
    "mnc": "180",
    "iso": "jm",
    "country": "Jamaica",
    "countryCode": "1876",
    "network": "Flow "
  },
  {
    "mcc": "440",
    "mnc": "299",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "Failed Calls "
  },
  {
    "mcc": "440",
    "mnc": "999",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "Fix Line "
  },
  {
    "mcc": "440",
    "mnc": "73",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "51",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "74",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "52",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "75",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "53",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "71",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "76",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "70",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "54",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "72",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "50",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "KDDI "
  },
  {
    "mcc": "440",
    "mnc": "10",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "NTT DoCoMo "
  },
  {
    "mcc": "440",
    "mnc": "78",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "Okinawa Cellular "
  },
  {
    "mcc": "440",
    "mnc": "11",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "Rakuten Mobile "
  },
  {
    "mcc": "440",
    "mnc": "20",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "SoftBank "
  },
  {
    "mcc": "440",
    "mnc": "21",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "SoftBank "
  },
  {
    "mcc": "440",
    "mnc": "00",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "SoftBank "
  },
  {
    "mcc": "440",
    "mnc": "05",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "SoftBank "
  },
  {
    "mcc": "440",
    "mnc": "01",
    "iso": "jp",
    "country": "Japan",
    "countryCode": "81",
    "network": "SoftBank "
  },
  {
    "mcc": "416",
    "mnc": "299",
    "iso": "jo",
    "country": "Jordan",
    "countryCode": "962",
    "network": "Failed Calls "
  },
  {
    "mcc": "416",
    "mnc": "999",
    "iso": "jo",
    "country": "Jordan",
    "countryCode": "962",
    "network": "Fix Line "
  },
  {
    "mcc": "416",
    "mnc": "77",
    "iso": "jo",
    "country": "Jordan",
    "countryCode": "962",
    "network": "Orange "
  },
  {
    "mcc": "416",
    "mnc": "03",
    "iso": "jo",
    "country": "Jordan",
    "countryCode": "962",
    "network": "Umniah "
  },
  {
    "mcc": "416",
    "mnc": "01",
    "iso": "jo",
    "country": "Jordan",
    "countryCode": "962",
    "network": "Zain "
  },
  {
    "mcc": "401",
    "mnc": "07",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Altel "
  },
  {
    "mcc": "401",
    "mnc": "299",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Arna "
  },
  {
    "mcc": "401",
    "mnc": "01",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Beeline "
  },
  {
    "mcc": "401",
    "mnc": "299",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Failed Calls "
  },
  {
    "mcc": "401",
    "mnc": "999",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Fix Line "
  },
  {
    "mcc": "401",
    "mnc": "08",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Kazakhstan Online "
  },
  {
    "mcc": "401",
    "mnc": "02",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Kcell "
  },
  {
    "mcc": "401",
    "mnc": "77",
    "iso": "kz",
    "country": "Kazakhstan",
    "countryCode": "7",
    "network": "Tele2 "
  },
  {
    "mcc": "639",
    "mnc": "03",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Airtel "
  },
  {
    "mcc": "639",
    "mnc": "05",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Airtel "
  },
  {
    "mcc": "639",
    "mnc": "299",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "eferio "
  },
  {
    "mcc": "639",
    "mnc": "299",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Failed Calls "
  },
  {
    "mcc": "639",
    "mnc": "06",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Finserve Africa "
  },
  {
    "mcc": "639",
    "mnc": "999",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Fix Line "
  },
  {
    "mcc": "639",
    "mnc": "09",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Homeland Media "
  },
  {
    "mcc": "639",
    "mnc": "12",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Infura "
  },
  {
    "mcc": "639",
    "mnc": "11",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Jambo Telcoms "
  },
  {
    "mcc": "639",
    "mnc": "10",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Jamii Telecommunications "
  },
  {
    "mcc": "639",
    "mnc": "04",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Mobile Pay "
  },
  {
    "mcc": "639",
    "mnc": "02",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Safaricom "
  },
  {
    "mcc": "639",
    "mnc": "01",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Safaricom "
  },
  {
    "mcc": "639",
    "mnc": "07",
    "iso": "ke",
    "country": "Kenya",
    "countryCode": "254",
    "network": "Telkom "
  },
  {
    "mcc": "545",
    "mnc": "299",
    "iso": "ki",
    "country": "Kiribati",
    "countryCode": "686",
    "network": "Failed Calls "
  },
  {
    "mcc": "545",
    "mnc": "999",
    "iso": "ki",
    "country": "Kiribati",
    "countryCode": "686",
    "network": "Fix Line "
  },
  {
    "mcc": "545",
    "mnc": "09",
    "iso": "ki",
    "country": "Kiribati",
    "countryCode": "686",
    "network": "FrigateNet "
  },
  {
    "mcc": "545",
    "mnc": "01",
    "iso": "ki",
    "country": "Kiribati",
    "countryCode": "686",
    "network": "FrigateNet "
  },
  {
    "mcc": "545",
    "mnc": "299",
    "iso": "ki",
    "country": "Kiribati",
    "countryCode": "686",
    "network": "Ocean Link "
  },
  {
    "mcc": "221",
    "mnc": "07",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "D3 mobile "
  },
  {
    "mcc": "221",
    "mnc": "299",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "Failed Calls "
  },
  {
    "mcc": "221",
    "mnc": "999",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "Fix Line "
  },
  {
    "mcc": "221",
    "mnc": "02",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "IPKO "
  },
  {
    "mcc": "221",
    "mnc": "299",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "MTS "
  },
  {
    "mcc": "221",
    "mnc": "01",
    "iso": "xk",
    "country": "Kosovo",
    "countryCode": "383",
    "network": "Vala "
  },
  {
    "mcc": "419",
    "mnc": "299",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Failed Calls "
  },
  {
    "mcc": "419",
    "mnc": "999",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Fix Line "
  },
  {
    "mcc": "419",
    "mnc": "03",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Ooredoo "
  },
  {
    "mcc": "419",
    "mnc": "299",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "419",
    "mnc": "04",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Viva "
  },
  {
    "mcc": "419",
    "mnc": "02",
    "iso": "kw",
    "country": "Kuwait",
    "countryCode": "965",
    "network": "Zain "
  },
  {
    "mcc": "437",
    "mnc": "01",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "Beeline "
  },
  {
    "mcc": "437",
    "mnc": "299",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "Failed Calls "
  },
  {
    "mcc": "437",
    "mnc": "999",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "Fix Line "
  },
  {
    "mcc": "437",
    "mnc": "06",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "KT Mobile "
  },
  {
    "mcc": "437",
    "mnc": "05",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "MegaCom "
  },
  {
    "mcc": "437",
    "mnc": "09",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "O! "
  },
  {
    "mcc": "437",
    "mnc": "10",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "Saima "
  },
  {
    "mcc": "437",
    "mnc": "03",
    "iso": "kg",
    "country": "Kyrgyzstan",
    "countryCode": "996",
    "network": "Fonex "
  },
  {
    "mcc": "457",
    "mnc": "08",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "Beeline "
  },
  {
    "mcc": "457",
    "mnc": "02",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "ETL Mobile "
  },
  {
    "mcc": "457",
    "mnc": "299",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "Failed Calls "
  },
  {
    "mcc": "457",
    "mnc": "999",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "Fix Line "
  },
  {
    "mcc": "457",
    "mnc": "01",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "LTC "
  },
  {
    "mcc": "457",
    "mnc": "03",
    "iso": "la",
    "country": "Laos",
    "countryCode": "856",
    "network": "Unitel "
  },
  {
    "mcc": "247",
    "mnc": "05",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Bite "
  },
  {
    "mcc": "247",
    "mnc": "299",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Failed Calls "
  },
  {
    "mcc": "247",
    "mnc": "999",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Fix Line "
  },
  {
    "mcc": "247",
    "mnc": "10",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "LMT "
  },
  {
    "mcc": "247",
    "mnc": "01",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "LMT "
  },
  {
    "mcc": "247",
    "mnc": "299",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Premium Numbers "
  },
  {
    "mcc": "247",
    "mnc": "02",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Tele2 "
  },
  {
    "mcc": "247",
    "mnc": "04",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "Tet "
  },
  {
    "mcc": "247",
    "mnc": "03",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "TRIATEL "
  },
  {
    "mcc": "247",
    "mnc": "08",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "VENTA Mobile "
  },
  {
    "mcc": "247",
    "mnc": "09",
    "iso": "lv",
    "country": "Latvia",
    "countryCode": "371",
    "network": "XOmobile "
  },
  {
    "mcc": "415",
    "mnc": "01",
    "iso": "lb",
    "country": "Lebanon",
    "countryCode": "961",
    "network": "Alfa "
  },
  {
    "mcc": "415",
    "mnc": "299",
    "iso": "lb",
    "country": "Lebanon",
    "countryCode": "961",
    "network": "Failed Calls "
  },
  {
    "mcc": "415",
    "mnc": "999",
    "iso": "lb",
    "country": "Lebanon",
    "countryCode": "961",
    "network": "Fix Line "
  },
  {
    "mcc": "415",
    "mnc": "03",
    "iso": "lb",
    "country": "Lebanon",
    "countryCode": "961",
    "network": "Touch "
  },
  {
    "mcc": "651",
    "mnc": "02",
    "iso": "ls",
    "country": "Lesotho",
    "countryCode": "266",
    "network": "Econet "
  },
  {
    "mcc": "651",
    "mnc": "299",
    "iso": "ls",
    "country": "Lesotho",
    "countryCode": "266",
    "network": "Failed Calls "
  },
  {
    "mcc": "651",
    "mnc": "999",
    "iso": "ls",
    "country": "Lesotho",
    "countryCode": "266",
    "network": "Fix Line "
  },
  {
    "mcc": "651",
    "mnc": "01",
    "iso": "ls",
    "country": "Lesotho",
    "countryCode": "266",
    "network": "Vodacom "
  },
  {
    "mcc": "618",
    "mnc": "299",
    "iso": "lr",
    "country": "Liberia",
    "countryCode": "231",
    "network": "Failed Calls "
  },
  {
    "mcc": "618",
    "mnc": "999",
    "iso": "lr",
    "country": "Liberia",
    "countryCode": "231",
    "network": "Fix Line "
  },
  {
    "mcc": "618",
    "mnc": "01",
    "iso": "lr",
    "country": "Liberia",
    "countryCode": "231",
    "network": "MTN / Lonestar "
  },
  {
    "mcc": "618",
    "mnc": "04",
    "iso": "lr",
    "country": "Liberia",
    "countryCode": "231",
    "network": "Novafone "
  },
  {
    "mcc": "618",
    "mnc": "07",
    "iso": "lr",
    "country": "Liberia",
    "countryCode": "231",
    "network": "Orange "
  },
  {
    "mcc": "606",
    "mnc": "01",
    "iso": "ly",
    "country": "Libya",
    "countryCode": "218",
    "network": "Al-Madar "
  },
  {
    "mcc": "606",
    "mnc": "299",
    "iso": "ly",
    "country": "Libya",
    "countryCode": "218",
    "network": "Failed Calls "
  },
  {
    "mcc": "606",
    "mnc": "999",
    "iso": "ly",
    "country": "Libya",
    "countryCode": "218",
    "network": "Fix Line "
  },
  {
    "mcc": "606",
    "mnc": "00",
    "iso": "ly",
    "country": "Libya",
    "countryCode": "218",
    "network": "Libyana "
  },
  {
    "mcc": "606",
    "mnc": "03",
    "iso": "ly",
    "country": "Libya",
    "countryCode": "218",
    "network": "LibyaPhone Mobile "
  },
  {
    "mcc": "295",
    "mnc": "02",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "7acht "
  },
  {
    "mcc": "295",
    "mnc": "06",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "CUBIC "
  },
  {
    "mcc": "295",
    "mnc": "299",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Datamobile "
  },
  {
    "mcc": "295",
    "mnc": "299",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Dimoco "
  },
  {
    "mcc": "295",
    "mnc": "09",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "EMnify "
  },
  {
    "mcc": "295",
    "mnc": "299",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Failed Calls "
  },
  {
    "mcc": "295",
    "mnc": "999",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Fix Line "
  },
  {
    "mcc": "246",
    "mnc": "999",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Fix Line "
  },
  {
    "mcc": "295",
    "mnc": "01",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "FL GSM "
  },
  {
    "mcc": "295",
    "mnc": "05",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "FL1 "
  },
  {
    "mcc": "295",
    "mnc": "299",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "SORACOM "
  },
  {
    "mcc": "295",
    "mnc": "299",
    "iso": "li",
    "country": "Liechtenstein",
    "countryCode": "423",
    "network": "Telna "
  },
  {
    "mcc": "246",
    "mnc": "02",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Bite "
  },
  {
    "mcc": "246",
    "mnc": "299",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Failed Calls "
  },
  {
    "mcc": "246",
    "mnc": "05",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "LTG "
  },
  {
    "mcc": "246",
    "mnc": "06",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Mediafon "
  },
  {
    "mcc": "246",
    "mnc": "299",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "SkyCall "
  },
  {
    "mcc": "246",
    "mnc": "03",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Tele2 "
  },
  {
    "mcc": "246",
    "mnc": "299",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Teletel "
  },
  {
    "mcc": "246",
    "mnc": "01",
    "iso": "lt",
    "country": "Lithuania",
    "countryCode": "370",
    "network": "Telia "
  },
  {
    "mcc": "270",
    "mnc": "10",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Blue Communications "
  },
  {
    "mcc": "270",
    "mnc": "299",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Bouygues Telecom "
  },
  {
    "mcc": "270",
    "mnc": "81",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "e-LUX Mobile "
  },
  {
    "mcc": "270",
    "mnc": "299",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Eltrona "
  },
  {
    "mcc": "270",
    "mnc": "299",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Failed Calls "
  },
  {
    "mcc": "270",
    "mnc": "999",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Fix Line "
  },
  {
    "mcc": "270",
    "mnc": "05",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Luxembourg Online "
  },
  {
    "mcc": "270",
    "mnc": "299",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "MTX Connect "
  },
  {
    "mcc": "270",
    "mnc": "99",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Orange "
  },
  {
    "mcc": "270",
    "mnc": "01",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Post "
  },
  {
    "mcc": "270",
    "mnc": "77",
    "iso": "lu",
    "country": "Luxembourg",
    "countryCode": "352",
    "network": "Tango "
  },
  {
    "mcc": "455",
    "mnc": "05",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "3 "
  },
  {
    "mcc": "455",
    "mnc": "03",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "3 "
  },
  {
    "mcc": "455",
    "mnc": "07",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "China Telecom "
  },
  {
    "mcc": "455",
    "mnc": "02",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "China Telecom "
  },
  {
    "mcc": "455",
    "mnc": "04",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "CTM "
  },
  {
    "mcc": "455",
    "mnc": "01",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "CTM "
  },
  {
    "mcc": "455",
    "mnc": "299",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "Failed Calls "
  },
  {
    "mcc": "455",
    "mnc": "999",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "Fix Line "
  },
  {
    "mcc": "455",
    "mnc": "06",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "SmarTone "
  },
  {
    "mcc": "455",
    "mnc": "00",
    "iso": "mo",
    "country": "Macao",
    "countryCode": "853",
    "network": "SmarTone "
  },
  {
    "mcc": "646",
    "mnc": "01",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Airtel "
  },
  {
    "mcc": "646",
    "mnc": "299",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Bip "
  },
  {
    "mcc": "646",
    "mnc": "299",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Failed Calls "
  },
  {
    "mcc": "646",
    "mnc": "999",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Fix Line "
  },
  {
    "mcc": "646",
    "mnc": "02",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Orange "
  },
  {
    "mcc": "646",
    "mnc": "04",
    "iso": "mg",
    "country": "Madagascar",
    "countryCode": "261",
    "network": "Telma "
  },
  {
    "mcc": "650",
    "mnc": "10",
    "iso": "mw",
    "country": "Malawi",
    "countryCode": "265",
    "network": "Airtel "
  },
  {
    "mcc": "650",
    "mnc": "299",
    "iso": "mw",
    "country": "Malawi",
    "countryCode": "265",
    "network": "Failed Calls "
  },
  {
    "mcc": "650",
    "mnc": "999",
    "iso": "mw",
    "country": "Malawi",
    "countryCode": "265",
    "network": "Fix Line "
  },
  {
    "mcc": "650",
    "mnc": "01",
    "iso": "mw",
    "country": "Malawi",
    "countryCode": "265",
    "network": "TNM "
  },
  {
    "mcc": "502",
    "mnc": "156",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Altel Communications "
  },
  {
    "mcc": "502",
    "mnc": "11",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Telekom Malaysia "
  },
  {
    "mcc": "502",
    "mnc": "14",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Telekom Malaysia "
  },
  {
    "mcc": "502",
    "mnc": "19",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Celcom "
  },
  {
    "mcc": "502",
    "mnc": "13",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Celcom "
  },
  {
    "mcc": "502",
    "mnc": "10",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "DiGi "
  },
  {
    "mcc": "502",
    "mnc": "16",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "DiGi "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Failed Calls "
  },
  {
    "mcc": "502",
    "mnc": "999",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Fix Line "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "MKN "
  },
  {
    "mcc": "502",
    "mnc": "17",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Maxis "
  },
  {
    "mcc": "502",
    "mnc": "12",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Maxis "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Maxis Broadband "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "OCESB "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "REDtone Mobile "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "REDtone "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "TT dotCom "
  },
  {
    "mcc": "502",
    "mnc": "150",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Tune Talk "
  },
  {
    "mcc": "502",
    "mnc": "18",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "U Mobile "
  },
  {
    "mcc": "502",
    "mnc": "153",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Webe Digital "
  },
  {
    "mcc": "502",
    "mnc": "195",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "XOX Com "
  },
  {
    "mcc": "502",
    "mnc": "299",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Y-Max "
  },
  {
    "mcc": "502",
    "mnc": "152",
    "iso": "my",
    "country": "Malaysia",
    "countryCode": "60",
    "network": "Yes "
  },
  {
    "mcc": "472",
    "mnc": "01",
    "iso": "mv",
    "country": "Maldives",
    "countryCode": "960",
    "network": "DhiMobile "
  },
  {
    "mcc": "472",
    "mnc": "299",
    "iso": "mv",
    "country": "Maldives",
    "countryCode": "960",
    "network": "Failed Calls "
  },
  {
    "mcc": "472",
    "mnc": "999",
    "iso": "mv",
    "country": "Maldives",
    "countryCode": "960",
    "network": "Fix Line "
  },
  {
    "mcc": "472",
    "mnc": "02",
    "iso": "mv",
    "country": "Maldives",
    "countryCode": "960",
    "network": "Ooredoo "
  },
  {
    "mcc": "610",
    "mnc": "299",
    "iso": "ml",
    "country": "Mali",
    "countryCode": "223",
    "network": "Failed Calls "
  },
  {
    "mcc": "610",
    "mnc": "999",
    "iso": "ml",
    "country": "Mali",
    "countryCode": "223",
    "network": "Fix Line "
  },
  {
    "mcc": "610",
    "mnc": "01",
    "iso": "ml",
    "country": "Mali",
    "countryCode": "223",
    "network": "Malitel "
  },
  {
    "mcc": "610",
    "mnc": "02",
    "iso": "ml",
    "country": "Mali",
    "countryCode": "223",
    "network": "Orange "
  },
  {
    "mcc": "610",
    "mnc": "03",
    "iso": "ml",
    "country": "Mali",
    "countryCode": "223",
    "network": "Telecel "
  },
  {
    "mcc": "278",
    "mnc": "01",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "Epic "
  },
  {
    "mcc": "278",
    "mnc": "299",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "Failed Calls "
  },
  {
    "mcc": "278",
    "mnc": "999",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "Fix Line "
  },
  {
    "mcc": "278",
    "mnc": "30",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "GO Mobile "
  },
  {
    "mcc": "278",
    "mnc": "21",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "GO Mobile "
  },
  {
    "mcc": "278",
    "mnc": "77",
    "iso": "mt",
    "country": "Malta",
    "countryCode": "356",
    "network": "Melita "
  },
  {
    "mcc": "551",
    "mnc": "299",
    "iso": "mh",
    "country": "Marshall Islands",
    "countryCode": "692",
    "network": "Failed Calls "
  },
  {
    "mcc": "551",
    "mnc": "999",
    "iso": "mh",
    "country": "Marshall Islands",
    "countryCode": "692",
    "network": "Fix Line "
  },
  {
    "mcc": "551",
    "mnc": "299",
    "iso": "mh",
    "country": "Marshall Islands",
    "countryCode": "692",
    "network": "MINTA "
  },
  {
    "mcc": "609",
    "mnc": "02",
    "iso": "mr",
    "country": "Mauritania",
    "countryCode": "222",
    "network": "Chinguitel "
  },
  {
    "mcc": "609",
    "mnc": "299",
    "iso": "mr",
    "country": "Mauritania",
    "countryCode": "222",
    "network": "Failed Calls "
  },
  {
    "mcc": "609",
    "mnc": "999",
    "iso": "mr",
    "country": "Mauritania",
    "countryCode": "222",
    "network": "Fix Line "
  },
  {
    "mcc": "609",
    "mnc": "01",
    "iso": "mr",
    "country": "Mauritania",
    "countryCode": "222",
    "network": "Mattel "
  },
  {
    "mcc": "609",
    "mnc": "10",
    "iso": "mr",
    "country": "Mauritania",
    "countryCode": "222",
    "network": "Mauritel "
  },
  {
    "mcc": "617",
    "mnc": "02",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "Chili "
  },
  {
    "mcc": "617",
    "mnc": "03",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "Chili "
  },
  {
    "mcc": "617",
    "mnc": "10",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "Emtel "
  },
  {
    "mcc": "617",
    "mnc": "299",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "Failed Calls "
  },
  {
    "mcc": "617",
    "mnc": "999",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "Fix Line "
  },
  {
    "mcc": "617",
    "mnc": "01",
    "iso": "mu",
    "country": "Mauritius",
    "countryCode": "230",
    "network": "my.t mobile "
  },
  {
    "mcc": "647",
    "mnc": "299",
    "iso": "yt",
    "country": "Mayotte",
    "countryCode": "262",
    "network": "Failed Calls "
  },
  {
    "mcc": "647",
    "mnc": "999",
    "iso": "yt",
    "country": "Mayotte",
    "countryCode": "262",
    "network": "Fix Line "
  },
  {
    "mcc": "647",
    "mnc": "01",
    "iso": "yt",
    "country": "Mayotte",
    "countryCode": "262",
    "network": "Maore Mobile "
  },
  {
    "mcc": "647",
    "mnc": "10",
    "iso": "yt",
    "country": "Mayotte",
    "countryCode": "262",
    "network": "SFR "
  },
  {
    "mcc": "334",
    "mnc": "140",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "ALTAN Redes "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Altcel "
  },
  {
    "mcc": "334",
    "mnc": "50",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "AT&T / IUSACell "
  },
  {
    "mcc": "334",
    "mnc": "050",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "AT&T / IUSACell "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Failed Calls "
  },
  {
    "mcc": "334",
    "mnc": "999",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Fix Line "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "FreedomPop "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Ibo Cell "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Maxcom "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "MegaTel "
  },
  {
    "mcc": "334",
    "mnc": "030",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Movistar "
  },
  {
    "mcc": "334",
    "mnc": "03",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Movistar "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "NEUS Mobile "
  },
  {
    "mcc": "334",
    "mnc": "01",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Nextel "
  },
  {
    "mcc": "334",
    "mnc": "90",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Nextel "
  },
  {
    "mcc": "334",
    "mnc": "010",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Nextel "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "QBOcel "
  },
  {
    "mcc": "334",
    "mnc": "060",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "SAI PCS "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Servitron "
  },
  {
    "mcc": "334",
    "mnc": "020",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Telcel "
  },
  {
    "mcc": "334",
    "mnc": "02",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Telcel "
  },
  {
    "mcc": "334",
    "mnc": "299",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Telecomunicaciones 360 "
  },
  {
    "mcc": "334",
    "mnc": "80",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Unefon "
  },
  {
    "mcc": "334",
    "mnc": "70",
    "iso": "mx",
    "country": "Mexico",
    "countryCode": "52",
    "network": "Unefon "
  },
  {
    "mcc": "550",
    "mnc": "299",
    "iso": "fm",
    "country": "Micronesia",
    "countryCode": "691",
    "network": "Failed Calls "
  },
  {
    "mcc": "550",
    "mnc": "999",
    "iso": "fm",
    "country": "Micronesia",
    "countryCode": "691",
    "network": "Fix Line "
  },
  {
    "mcc": "550",
    "mnc": "01",
    "iso": "fm",
    "country": "Micronesia",
    "countryCode": "691",
    "network": "FSMTCeLL "
  },
  {
    "mcc": "259",
    "mnc": "299",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Failed Calls "
  },
  {
    "mcc": "259",
    "mnc": "02",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Moldcell "
  },
  {
    "mcc": "259",
    "mnc": "01",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Orange "
  },
  {
    "mcc": "259",
    "mnc": "03",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Unite "
  },
  {
    "mcc": "259",
    "mnc": "99",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Unite "
  },
  {
    "mcc": "259",
    "mnc": "05",
    "iso": "md",
    "country": "Moldova",
    "countryCode": "373",
    "network": "Unite "
  },
  {
    "mcc": "212",
    "mnc": "299",
    "iso": "mc",
    "country": "Monaco",
    "countryCode": "377",
    "network": "Failed Calls "
  },
  {
    "mcc": "212",
    "mnc": "999",
    "iso": "mc",
    "country": "Monaco",
    "countryCode": "377",
    "network": "Fix Line "
  },
  {
    "mcc": "212",
    "mnc": "10",
    "iso": "mc",
    "country": "Monaco",
    "countryCode": "377",
    "network": "Monaco Telecom "
  },
  {
    "mcc": "212",
    "mnc": "01",
    "iso": "mc",
    "country": "Monaco",
    "countryCode": "377",
    "network": "Monaco Telecom "
  },
  {
    "mcc": "428",
    "mnc": "299",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "Failed Calls "
  },
  {
    "mcc": "428",
    "mnc": "999",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "Fix Line "
  },
  {
    "mcc": "428",
    "mnc": "98",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "G-Mobile "
  },
  {
    "mcc": "428",
    "mnc": "99",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "Mobicom "
  },
  {
    "mcc": "428",
    "mnc": "00",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "Skytel "
  },
  {
    "mcc": "428",
    "mnc": "88",
    "iso": "mn",
    "country": "Mongolia",
    "countryCode": "976",
    "network": "Unitel "
  },
  {
    "mcc": "297",
    "mnc": "299",
    "iso": "me",
    "country": "Montenegro",
    "countryCode": "382",
    "network": "Failed Calls "
  },
  {
    "mcc": "297",
    "mnc": "999",
    "iso": "me",
    "country": "Montenegro",
    "countryCode": "382",
    "network": "Fix Line "
  },
  {
    "mcc": "297",
    "mnc": "03",
    "iso": "me",
    "country": "Montenegro",
    "countryCode": "382",
    "network": "Mtel "
  },
  {
    "mcc": "297",
    "mnc": "02",
    "iso": "me",
    "country": "Montenegro",
    "countryCode": "382",
    "network": "Telekom / T-mobile "
  },
  {
    "mcc": "297",
    "mnc": "01",
    "iso": "me",
    "country": "Montenegro",
    "countryCode": "382",
    "network": "Telenor "
  },
  {
    "mcc": "354",
    "mnc": "299",
    "iso": "ms",
    "country": "Montserrat",
    "countryCode": "1664",
    "network": "Digicel "
  },
  {
    "mcc": "354",
    "mnc": "299",
    "iso": "ms",
    "country": "Montserrat",
    "countryCode": "1664",
    "network": "Failed Calls "
  },
  {
    "mcc": "354",
    "mnc": "999",
    "iso": "ms",
    "country": "Montserrat",
    "countryCode": "1664",
    "network": "Fix Line "
  },
  {
    "mcc": "354",
    "mnc": "860",
    "iso": "ms",
    "country": "Montserrat",
    "countryCode": "1664",
    "network": "Flow "
  },
  {
    "mcc": "604",
    "mnc": "299",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "Failed Calls "
  },
  {
    "mcc": "604",
    "mnc": "999",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "Fix Line "
  },
  {
    "mcc": "604",
    "mnc": "01",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "IAM "
  },
  {
    "mcc": "604",
    "mnc": "05",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "inwi "
  },
  {
    "mcc": "604",
    "mnc": "02",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "inwi "
  },
  {
    "mcc": "604",
    "mnc": "00",
    "iso": "ma",
    "country": "Morocco",
    "countryCode": "212",
    "network": "Orange "
  },
  {
    "mcc": "643",
    "mnc": "299",
    "iso": "mz",
    "country": "Mozambique",
    "countryCode": "258",
    "network": "Failed Calls "
  },
  {
    "mcc": "643",
    "mnc": "999",
    "iso": "mz",
    "country": "Mozambique",
    "countryCode": "258",
    "network": "Fix Line "
  },
  {
    "mcc": "643",
    "mnc": "03",
    "iso": "mz",
    "country": "Mozambique",
    "countryCode": "258",
    "network": "Movitel "
  },
  {
    "mcc": "643",
    "mnc": "01",
    "iso": "mz",
    "country": "Mozambique",
    "countryCode": "258",
    "network": "TMCEL "
  },
  {
    "mcc": "643",
    "mnc": "04",
    "iso": "mz",
    "country": "Mozambique",
    "countryCode": "258",
    "network": "Vodacom "
  },
  {
    "mcc": "414",
    "mnc": "299",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "Failed Calls "
  },
  {
    "mcc": "414",
    "mnc": "999",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "Fix Line "
  },
  {
    "mcc": "414",
    "mnc": "03",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "MecTel "
  },
  {
    "mcc": "414",
    "mnc": "01",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "MPT "
  },
  {
    "mcc": "414",
    "mnc": "00",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "MPT "
  },
  {
    "mcc": "414",
    "mnc": "09",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "Mytel "
  },
  {
    "mcc": "414",
    "mnc": "05",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "Ooredoo "
  },
  {
    "mcc": "414",
    "mnc": "06",
    "iso": "mm",
    "country": "Myanmar",
    "countryCode": "95",
    "network": "Telenor "
  },
  {
    "mcc": "649",
    "mnc": "299",
    "iso": "na",
    "country": "Namibia",
    "countryCode": "264",
    "network": "Demshi "
  },
  {
    "mcc": "649",
    "mnc": "299",
    "iso": "na",
    "country": "Namibia",
    "countryCode": "264",
    "network": "Failed Calls "
  },
  {
    "mcc": "649",
    "mnc": "999",
    "iso": "na",
    "country": "Namibia",
    "countryCode": "264",
    "network": "Fix Line "
  },
  {
    "mcc": "649",
    "mnc": "01",
    "iso": "na",
    "country": "Namibia",
    "countryCode": "264",
    "network": "MTC "
  },
  {
    "mcc": "649",
    "mnc": "03",
    "iso": "na",
    "country": "Namibia",
    "countryCode": "264",
    "network": "TN Mobile "
  },
  {
    "mcc": "536",
    "mnc": "02",
    "iso": "nr",
    "country": "Nauru",
    "countryCode": "674",
    "network": "Digicel "
  },
  {
    "mcc": "536",
    "mnc": "299",
    "iso": "nr",
    "country": "Nauru",
    "countryCode": "674",
    "network": "Failed Calls "
  },
  {
    "mcc": "536",
    "mnc": "999",
    "iso": "nr",
    "country": "Nauru",
    "countryCode": "674",
    "network": "Fix Line "
  },
  {
    "mcc": "429",
    "mnc": "299",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "CG Telecom "
  },
  {
    "mcc": "429",
    "mnc": "299",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Failed Calls "
  },
  {
    "mcc": "429",
    "mnc": "999",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Fix Line "
  },
  {
    "mcc": "429",
    "mnc": "03",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Hello Nepal "
  },
  {
    "mcc": "429",
    "mnc": "02",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Ncell "
  },
  {
    "mcc": "429",
    "mnc": "01",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Nepal Telecom "
  },
  {
    "mcc": "429",
    "mnc": "04",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "Smart "
  },
  {
    "mcc": "429",
    "mnc": "00",
    "iso": "np",
    "country": "Nepal",
    "countryCode": "977",
    "network": "UTL "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "88 mobile "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "AGMS "
  },
  {
    "mcc": "204",
    "mnc": "30",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "ASPIDER Solutions "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Belcentrale "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "BodyTrace "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Combird Mobile "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Dean Mobile "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Eazit "
  },
  {
    "mcc": "204",
    "mnc": "05",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "ElephantTalk "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "EziMobile "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Failed Calls "
  },
  {
    "mcc": "204",
    "mnc": "999",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Fix Line "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "interactive digital media / IDM "
  },
  {
    "mcc": "204",
    "mnc": "00",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Intovoice "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KeenMobile "
  },
  {
    "mcc": "204",
    "mnc": "23",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KORE "
  },
  {
    "mcc": "204",
    "mnc": "69",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KPN "
  },
  {
    "mcc": "204",
    "mnc": "12",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KPN "
  },
  {
    "mcc": "204",
    "mnc": "08",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KPN "
  },
  {
    "mcc": "204",
    "mnc": "10",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "KPN "
  },
  {
    "mcc": "204",
    "mnc": "27",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "L-mobi "
  },
  {
    "mcc": "204",
    "mnc": "28",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Lancelot "
  },
  {
    "mcc": "204",
    "mnc": "98",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Lancelot "
  },
  {
    "mcc": "204",
    "mnc": "09",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Lycamobile "
  },
  {
    "mcc": "204",
    "mnc": "63",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "MessageBird "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "mGage "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Motto "
  },
  {
    "mcc": "204",
    "mnc": "07",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Move / Teleena "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Okta8 "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Premium Numbers "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Premium Routing "
  },
  {
    "mcc": "204",
    "mnc": "24",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Private Mobility "
  },
  {
    "mcc": "204",
    "mnc": "21",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "ProRail "
  },
  {
    "mcc": "204",
    "mnc": "299",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Redworks "
  },
  {
    "mcc": "204",
    "mnc": "26",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "SpeakUp "
  },
  {
    "mcc": "204",
    "mnc": "02",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "T-Mobile "
  },
  {
    "mcc": "204",
    "mnc": "20",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "T-Mobile "
  },
  {
    "mcc": "204",
    "mnc": "16",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "T-Mobile "
  },
  {
    "mcc": "204",
    "mnc": "29",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Tismi "
  },
  {
    "mcc": "204",
    "mnc": "33",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Truphone "
  },
  {
    "mcc": "204",
    "mnc": "06",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "204",
    "mnc": "04",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Vodafone "
  },
  {
    "mcc": "204",
    "mnc": "03",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Voiceworks Mobile "
  },
  {
    "mcc": "204",
    "mnc": "15",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Ziggo "
  },
  {
    "mcc": "204",
    "mnc": "18",
    "iso": "nl",
    "country": "Netherlands",
    "countryCode": "31",
    "network": "Ziggo Services "
  },
  {
    "mcc": "362",
    "mnc": "91",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "Chippie "
  },
  {
    "mcc": "362",
    "mnc": "69",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "Digicel "
  },
  {
    "mcc": "362",
    "mnc": "299",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "Failed Calls "
  },
  {
    "mcc": "362",
    "mnc": "999",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "Fix Line "
  },
  {
    "mcc": "362",
    "mnc": "299",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "Premium Numbers "
  },
  {
    "mcc": "362",
    "mnc": "51",
    "iso": "an",
    "country": "Netherlands Antilles",
    "countryCode": "599",
    "network": "TelCell "
  },
  {
    "mcc": "546",
    "mnc": "299",
    "iso": "nc",
    "country": "New Caledonia",
    "countryCode": "687",
    "network": "Failed Calls "
  },
  {
    "mcc": "546",
    "mnc": "999",
    "iso": "nc",
    "country": "New Caledonia",
    "countryCode": "687",
    "network": "Fix Line "
  },
  {
    "mcc": "546",
    "mnc": "01",
    "iso": "nc",
    "country": "New Caledonia",
    "countryCode": "687",
    "network": "Mobilis "
  },
  {
    "mcc": "530",
    "mnc": "24",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "2degrees "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Compass Mobile "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Devoli "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Failed Calls "
  },
  {
    "mcc": "530",
    "mnc": "999",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Fix Line "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "LinkTel "
  },
  {
    "mcc": "530",
    "mnc": "06",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Skinny Mobile "
  },
  {
    "mcc": "530",
    "mnc": "02",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Spark Mobile "
  },
  {
    "mcc": "530",
    "mnc": "05",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Spark Mobile "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Symbio "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Vocus "
  },
  {
    "mcc": "530",
    "mnc": "01",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Vodafone "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "Voyager Internet "
  },
  {
    "mcc": "530",
    "mnc": "299",
    "iso": "nz",
    "country": "New Zealand",
    "countryCode": "64",
    "network": "WXC "
  },
  {
    "mcc": "710",
    "mnc": "21",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "Claro "
  },
  {
    "mcc": "710",
    "mnc": "73",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "Claro "
  },
  {
    "mcc": "710",
    "mnc": "68",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "CooTel "
  },
  {
    "mcc": "710",
    "mnc": "299",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "Failed Calls "
  },
  {
    "mcc": "710",
    "mnc": "999",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "Fix Line "
  },
  {
    "mcc": "710",
    "mnc": "30",
    "iso": "ni",
    "country": "Nicaragua",
    "countryCode": "505",
    "network": "Movistar "
  },
  {
    "mcc": "614",
    "mnc": "02",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Airtel "
  },
  {
    "mcc": "614",
    "mnc": "299",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Failed Calls "
  },
  {
    "mcc": "614",
    "mnc": "999",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Fix Line "
  },
  {
    "mcc": "614",
    "mnc": "03",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Moov "
  },
  {
    "mcc": "614",
    "mnc": "01",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Niger Telecoms "
  },
  {
    "mcc": "614",
    "mnc": "04",
    "iso": "ne",
    "country": "Niger",
    "countryCode": "227",
    "network": "Orange "
  },
  {
    "mcc": "621",
    "mnc": "60",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "9mobile "
  },
  {
    "mcc": "621",
    "mnc": "20",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Airtel "
  },
  {
    "mcc": "621",
    "mnc": "299",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Alpha Technologies "
  },
  {
    "mcc": "621",
    "mnc": "299",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Failed Calls "
  },
  {
    "mcc": "621",
    "mnc": "999",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Fix Line "
  },
  {
    "mcc": "621",
    "mnc": "50",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Glo Mobile "
  },
  {
    "mcc": "621",
    "mnc": "30",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "MTN "
  },
  {
    "mcc": "621",
    "mnc": "40",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "ntel "
  },
  {
    "mcc": "621",
    "mnc": "27",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Smile "
  },
  {
    "mcc": "621",
    "mnc": "299",
    "iso": "ng",
    "country": "Nigeria",
    "countryCode": "234",
    "network": "Zodafones "
  },
  {
    "mcc": "555",
    "mnc": "299",
    "iso": "nu",
    "country": "Niue",
    "countryCode": "683",
    "network": "Failed Calls "
  },
  {
    "mcc": "555",
    "mnc": "999",
    "iso": "nu",
    "country": "Niue",
    "countryCode": "683",
    "network": "Fix Line "
  },
  {
    "mcc": "555",
    "mnc": "01",
    "iso": "nu",
    "country": "Niue",
    "countryCode": "683",
    "network": "Telecom Niue "
  },
  {
    "mcc": "467",
    "mnc": "299",
    "iso": "kp",
    "country": "North Korea",
    "countryCode": "850",
    "network": "Failed Calls "
  },
  {
    "mcc": "467",
    "mnc": "999",
    "iso": "kp",
    "country": "North Korea",
    "countryCode": "850",
    "network": "Fix Line "
  },
  {
    "mcc": "467",
    "mnc": "299",
    "iso": "kp",
    "country": "North Korea",
    "countryCode": "850",
    "network": "Kangsung Net "
  },
  {
    "mcc": "467",
    "mnc": "192",
    "iso": "kp",
    "country": "North Korea",
    "countryCode": "850",
    "network": "Koryolink "
  },
  {
    "mcc": "294",
    "mnc": "02",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "A1 "
  },
  {
    "mcc": "294",
    "mnc": "03",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "A1 "
  },
  {
    "mcc": "294",
    "mnc": "299",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Failed Calls "
  },
  {
    "mcc": "259",
    "mnc": "999",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Fix Line "
  },
  {
    "mcc": "294",
    "mnc": "999",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Fix Line "
  },
  {
    "mcc": "294",
    "mnc": "299",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "LATRON "
  },
  {
    "mcc": "294",
    "mnc": "04",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Lycamobile "
  },
  {
    "mcc": "294",
    "mnc": "11",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Mobik "
  },
  {
    "mcc": "294",
    "mnc": "299",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Telekabel "
  },
  {
    "mcc": "294",
    "mnc": "01",
    "iso": "mk",
    "country": "North Macedonia",
    "countryCode": "389",
    "network": "Telekom "
  },
  {
    "mcc": "534",
    "mnc": "299",
    "iso": "mp",
    "country": "Northern Mariana Islands",
    "countryCode": "1670",
    "network": "Failed Calls "
  },
  {
    "mcc": "534",
    "mnc": "999",
    "iso": "mp",
    "country": "Northern Mariana Islands",
    "countryCode": "1670",
    "network": "Fix Line "
  },
  {
    "mcc": "242",
    "mnc": "22",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Altibox Mobil "
  },
  {
    "mcc": "242",
    "mnc": "21",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "BANE NOR "
  },
  {
    "mcc": "242",
    "mnc": "20",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "BANE NOR "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "bigblu "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Chilimobil "
  },
  {
    "mcc": "242",
    "mnc": "09",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Com4 "
  },
  {
    "mcc": "242",
    "mnc": "15",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "eRate "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Failed Calls "
  },
  {
    "mcc": "242",
    "mnc": "999",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Fix Line "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "GlobalConnect "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": ""
  },
  {
    "mcc": "242",
    "mnc": "14",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "ICE "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "intility "
  },
  {
    "mcc": "242",
    "mnc": "16",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Iristel "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "JetNett "
  },
  {
    "mcc": "242",
    "mnc": "23",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Lycamobile "
  },
  {
    "mcc": "242",
    "mnc": "05",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Network Norway "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "NextGenTel "
  },
  {
    "mcc": "242",
    "mnc": "10",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Nkom "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Nodnett "
  },
  {
    "mcc": "242",
    "mnc": "06",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "ICE "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Puzzel "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Sierra Wireless "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Svea "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Telavox "
  },
  {
    "mcc": "242",
    "mnc": "12",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Telenor "
  },
  {
    "mcc": "242",
    "mnc": "01",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Telenor "
  },
  {
    "mcc": "242",
    "mnc": "02",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Telia / NetCom "
  },
  {
    "mcc": "242",
    "mnc": "08",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "Telia / NetCom "
  },
  {
    "mcc": "242",
    "mnc": "299",
    "iso": "no",
    "country": "Norway",
    "countryCode": "47",
    "network": "unifon "
  },
  {
    "mcc": "422",
    "mnc": "299",
    "iso": "om",
    "country": "Oman",
    "countryCode": "968",
    "network": "Failed Calls "
  },
  {
    "mcc": "422",
    "mnc": "999",
    "iso": "om",
    "country": "Oman",
    "countryCode": "968",
    "network": "Fix Line "
  },
  {
    "mcc": "422",
    "mnc": "02",
    "iso": "om",
    "country": "Oman",
    "countryCode": "968",
    "network": "Omantel Mobile "
  },
  {
    "mcc": "422",
    "mnc": "03",
    "iso": "om",
    "country": "Oman",
    "countryCode": "968",
    "network": "Ooredoo / Nawras "
  },
  {
    "mcc": "410",
    "mnc": "299",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Failed Calls "
  },
  {
    "mcc": "410",
    "mnc": "999",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Fix Line "
  },
  {
    "mcc": "410",
    "mnc": "01",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Jazz "
  },
  {
    "mcc": "410",
    "mnc": "07",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Jazz "
  },
  {
    "mcc": "410",
    "mnc": "05",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "SCO Mobile "
  },
  {
    "mcc": "410",
    "mnc": "06",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Telenor "
  },
  {
    "mcc": "410",
    "mnc": "03",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Ufone "
  },
  {
    "mcc": "410",
    "mnc": "299",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Warid "
  },
  {
    "mcc": "410",
    "mnc": "04",
    "iso": "pk",
    "country": "Pakistan",
    "countryCode": "92",
    "network": "Zong "
  },
  {
    "mcc": "552",
    "mnc": "299",
    "iso": "pw",
    "country": "Palau",
    "countryCode": "680",
    "network": "Failed Calls "
  },
  {
    "mcc": "552",
    "mnc": "999",
    "iso": "pw",
    "country": "Palau",
    "countryCode": "680",
    "network": "Fix Line "
  },
  {
    "mcc": "552",
    "mnc": "99",
    "iso": "pw",
    "country": "Palau",
    "countryCode": "680",
    "network": "Palau Mobile "
  },
  {
    "mcc": "552",
    "mnc": "01",
    "iso": "pw",
    "country": "Palau",
    "countryCode": "680",
    "network": "PalauCel "
  },
  {
    "mcc": "552",
    "mnc": "02",
    "iso": "pw",
    "country": "Palau",
    "countryCode": "680",
    "network": "PT Waves "
  },
  {
    "mcc": "425",
    "mnc": "299",
    "iso": "ps",
    "country": "Palestinian Territory",
    "countryCode": "970",
    "network": "Failed Calls "
  },
  {
    "mcc": "425",
    "mnc": "999",
    "iso": "ps",
    "country": "Palestinian Territory",
    "countryCode": "970",
    "network": "Fix Line "
  },
  {
    "mcc": "425",
    "mnc": "05",
    "iso": "ps",
    "country": "Palestinian Territory",
    "countryCode": "970",
    "network": "Jawwal "
  },
  {
    "mcc": "425",
    "mnc": "06",
    "iso": "ps",
    "country": "Palestinian Territory",
    "countryCode": "970",
    "network": "Ooredoo "
  },
  {
    "mcc": "714",
    "mnc": "01",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "+Movil "
  },
  {
    "mcc": "714",
    "mnc": "03",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Claro "
  },
  {
    "mcc": "714",
    "mnc": "04",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Digicel "
  },
  {
    "mcc": "714",
    "mnc": "299",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Failed Calls "
  },
  {
    "mcc": "714",
    "mnc": "999",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Fix Line "
  },
  {
    "mcc": "714",
    "mnc": "020",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Movistar "
  },
  {
    "mcc": "714",
    "mnc": "02",
    "iso": "pa",
    "country": "Panama",
    "countryCode": "507",
    "network": "Movistar "
  },
  {
    "mcc": "537",
    "mnc": "01",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "BeMobile Vodafone "
  },
  {
    "mcc": "537",
    "mnc": "02",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "Citifon "
  },
  {
    "mcc": "537",
    "mnc": "03",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "Digicel "
  },
  {
    "mcc": "537",
    "mnc": "299",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "DIGIVOIP "
  },
  {
    "mcc": "537",
    "mnc": "299",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "Failed Calls "
  },
  {
    "mcc": "537",
    "mnc": "999",
    "iso": "pg",
    "country": "Papua New Guinea",
    "countryCode": "675",
    "network": "Fix Line "
  },
  {
    "mcc": "744",
    "mnc": "02",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Claro "
  },
  {
    "mcc": "744",
    "mnc": "299",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Failed Calls "
  },
  {
    "mcc": "744",
    "mnc": "999",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Fix Line "
  },
  {
    "mcc": "744",
    "mnc": "03",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Personal "
  },
  {
    "mcc": "744",
    "mnc": "05",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Personal "
  },
  {
    "mcc": "744",
    "mnc": "04",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "Tigo "
  },
  {
    "mcc": "744",
    "mnc": "01",
    "iso": "py",
    "country": "Paraguay",
    "countryCode": "595",
    "network": "VOX "
  },
  {
    "mcc": "716",
    "mnc": "20",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Claro "
  },
  {
    "mcc": "716",
    "mnc": "10",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Claro "
  },
  {
    "mcc": "716",
    "mnc": "70",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Claro "
  },
  {
    "mcc": "716",
    "mnc": "299",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Dolphin "
  },
  {
    "mcc": "716",
    "mnc": "17",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Entel "
  },
  {
    "mcc": "716",
    "mnc": "299",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Failed Calls "
  },
  {
    "mcc": "716",
    "mnc": "999",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Fix Line "
  },
  {
    "mcc": "716",
    "mnc": "06",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Movistar "
  },
  {
    "mcc": "716",
    "mnc": "07",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Entel "
  },
  {
    "mcc": "716",
    "mnc": "30",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Tuyo "
  },
  {
    "mcc": "716",
    "mnc": "15",
    "iso": "pe",
    "country": "Peru",
    "countryCode": "51",
    "network": "Viettel "
  },
  {
    "mcc": "515",
    "mnc": "66",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "DITO "
  },
  {
    "mcc": "515",
    "mnc": "299",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Failed Calls "
  },
  {
    "mcc": "515",
    "mnc": "999",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Fix Line "
  },
  {
    "mcc": "515",
    "mnc": "02",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Globe "
  },
  {
    "mcc": "515",
    "mnc": "01",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Globe "
  },
  {
    "mcc": "515",
    "mnc": "03",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Smart "
  },
  {
    "mcc": "515",
    "mnc": "05",
    "iso": "ph",
    "country": "Philippines",
    "countryCode": "63",
    "network": "Sun Cellular "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "3S "
  },
  {
    "mcc": "260",
    "mnc": "16",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Aero2 "
  },
  {
    "mcc": "260",
    "mnc": "15",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Aero2 "
  },
  {
    "mcc": "260",
    "mnc": "04",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Aero2 "
  },
  {
    "mcc": "260",
    "mnc": "17",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Aero2 "
  },
  {
    "mcc": "260",
    "mnc": "48",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Agile Telecom "
  },
  {
    "mcc": "260",
    "mnc": "18",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "AMD Telecom "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Benemen "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "BSG "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Caritas Laczy "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Cludo "
  },
  {
    "mcc": "260",
    "mnc": "32",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Compatel "
  },
  {
    "mcc": "260",
    "mnc": "12",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Cyfrowy Polsat "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "e-Telko "
  },
  {
    "mcc": "260",
    "mnc": "41",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "EZ Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Failed Calls "
  },
  {
    "mcc": "260",
    "mnc": "999",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Fix Line "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "I.M. Consulting "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Inea "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "IZZI "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "JMDI J. Maleszko "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Klucz Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "lajt mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "LoVo "
  },
  {
    "mcc": "260",
    "mnc": "09",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Lycamobile "
  },
  {
    "mcc": "260",
    "mnc": "49",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Messagebird "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Metro Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Mobile Vikings "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Mobiledata "
  },
  {
    "mcc": "260",
    "mnc": "42",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "MobiWeb "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Moja GSM "
  },
  {
    "mcc": "260",
    "mnc": "13",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Move "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "multiMOBILE "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Nasza Wizja "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "NAU Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "nc+ Mobile "
  },
  {
    "mcc": "260",
    "mnc": "19",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "NetBalt "
  },
  {
    "mcc": "260",
    "mnc": "07",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Netia "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Next Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "NIMBOW "
  },
  {
    "mcc": "260",
    "mnc": "27",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Ntel Solutions "
  },
  {
    "mcc": "260",
    "mnc": "03",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Orange "
  },
  {
    "mcc": "260",
    "mnc": "05",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Orange "
  },
  {
    "mcc": "260",
    "mnc": "35",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "PKP "
  },
  {
    "mcc": "260",
    "mnc": "98",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Play "
  },
  {
    "mcc": "260",
    "mnc": "06",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Play "
  },
  {
    "mcc": "260",
    "mnc": "11",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Plus "
  },
  {
    "mcc": "260",
    "mnc": "01",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Plus "
  },
  {
    "mcc": "260",
    "mnc": "97",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Politechnika Lodzka Uczelniane "
  },
  {
    "mcc": "260",
    "mnc": "90",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Polska Spolka Gazownictwa "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Polvoice "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Pomagacz "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Premium Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Premium Numbers "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "SAT FILM "
  },
  {
    "mcc": "260",
    "mnc": "14",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Move "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "SGT "
  },
  {
    "mcc": "260",
    "mnc": "47",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "SMSHIGHWAY "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Softelnet "
  },
  {
    "mcc": "260",
    "mnc": "34",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "T-Mobile "
  },
  {
    "mcc": "260",
    "mnc": "02",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "T-Mobile "
  },
  {
    "mcc": "260",
    "mnc": "10",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "T-Mobile "
  },
  {
    "mcc": "260",
    "mnc": "14",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Telco Leaders "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Tele GO "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "TeleCube "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Telenabler "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "TELGAM "
  },
  {
    "mcc": "260",
    "mnc": "20",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Tismi "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "TOYAmobilna "
  },
  {
    "mcc": "260",
    "mnc": "22",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Twilio "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "UPC "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Vectra "
  },
  {
    "mcc": "260",
    "mnc": "45",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "260",
    "mnc": "45",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Vonage "
  },
  {
    "mcc": "260",
    "mnc": "39",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "260",
    "mnc": "299",
    "iso": "pl",
    "country": "Poland",
    "countryCode": "48",
    "network": "w naszej Rodzinie "
  },
  {
    "mcc": "268",
    "mnc": "299",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Failed Calls "
  },
  {
    "mcc": "268",
    "mnc": "999",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Fix Line "
  },
  {
    "mcc": "268",
    "mnc": "04",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Lycamobile "
  },
  {
    "mcc": "268",
    "mnc": "08",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "MEO "
  },
  {
    "mcc": "268",
    "mnc": "06",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "MEO "
  },
  {
    "mcc": "268",
    "mnc": "80",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "MEO "
  },
  {
    "mcc": "268",
    "mnc": "03",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "NOS "
  },
  {
    "mcc": "268",
    "mnc": "93",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "NOS "
  },
  {
    "mcc": "268",
    "mnc": "299",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "NOWO "
  },
  {
    "mcc": "268",
    "mnc": "299",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Oni "
  },
  {
    "mcc": "410",
    "mnc": "299",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Premium Numbers "
  },
  {
    "mcc": "268",
    "mnc": "01",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Vodafone "
  },
  {
    "mcc": "268",
    "mnc": "91",
    "iso": "pt",
    "country": "Portugal",
    "countryCode": "351",
    "network": "Vodafone "
  },
  {
    "mcc": "330",
    "mnc": "30",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "330",
    "mnc": "110",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "Claro "
  },
  {
    "mcc": "330",
    "mnc": "11",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "Claro "
  },
  {
    "mcc": "330",
    "mnc": "299",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "330",
    "mnc": "999",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "330",
    "mnc": "490",
    "iso": "pr",
    "country": "Puerto Rico",
    "countryCode": "",
    "network": "T-Mobile "
  },
  {
    "mcc": "427",
    "mnc": "299",
    "iso": "qa",
    "country": "Qatar",
    "countryCode": "974",
    "network": "Failed Calls "
  },
  {
    "mcc": "427",
    "mnc": "999",
    "iso": "qa",
    "country": "Qatar",
    "countryCode": "974",
    "network": "Fix Line "
  },
  {
    "mcc": "427",
    "mnc": "01",
    "iso": "qa",
    "country": "Qatar",
    "countryCode": "974",
    "network": "Ooredoo "
  },
  {
    "mcc": "427",
    "mnc": "06",
    "iso": "qa",
    "country": "Qatar",
    "countryCode": "974",
    "network": "Ooredoo "
  },
  {
    "mcc": "427",
    "mnc": "02",
    "iso": "qa",
    "country": "Qatar",
    "countryCode": "974",
    "network": "Vodafone "
  },
  {
    "mcc": "647",
    "mnc": "299",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "Failed Calls "
  },
  {
    "mcc": "647",
    "mnc": "999",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "Fix Line "
  },
  {
    "mcc": "647",
    "mnc": "03",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "Only "
  },
  {
    "mcc": "647",
    "mnc": "02",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "Only "
  },
  {
    "mcc": "647",
    "mnc": "00",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "Orange "
  },
  {
    "mcc": "647",
    "mnc": "04",
    "iso": "re",
    "country": "Reunion",
    "countryCode": "262",
    "network": "ZEOP Mobile "
  },
  {
    "mcc": "226",
    "mnc": "05",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Digi Mobil "
  },
  {
    "mcc": "226",
    "mnc": "299",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Failed Calls "
  },
  {
    "mcc": "226",
    "mnc": "999",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Fix Line "
  },
  {
    "mcc": "226",
    "mnc": "299",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Iristel "
  },
  {
    "mcc": "226",
    "mnc": "16",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Lycamobile "
  },
  {
    "mcc": "226",
    "mnc": "10",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Orange "
  },
  {
    "mcc": "226",
    "mnc": "03",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Telekom "
  },
  {
    "mcc": "226",
    "mnc": "02",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Telekom "
  },
  {
    "mcc": "226",
    "mnc": "01",
    "iso": "ro",
    "country": "Romania",
    "countryCode": "40",
    "network": "Vodafone "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Antares "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Arktur "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Astran "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "ASVT "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Aurora Telecom "
  },
  {
    "mcc": "250",
    "mnc": "99",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Beeline "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Beliton "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "BIT-CENTR "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Center 2M "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Cifra 1 "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "CountryCom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "ECO Networks "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Elemte "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "ER-Telecom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Failed Calls "
  },
  {
    "mcc": "250",
    "mnc": "999",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Fix Line "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Gazprom Telecom "
  },
  {
    "mcc": "250",
    "mnc": "48",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Global Telecom "
  },
  {
    "mcc": "250",
    "mnc": "55",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Glonass "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "GLONASS MOBILE "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Integral "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Internod "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Intersvyaz-2 "
  },
  {
    "mcc": "250",
    "mnc": "34",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Krymtelecom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "KvatroPlus "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Lardex "
  },
  {
    "mcc": "250",
    "mnc": "54",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Letai Mobile "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Lycamobile "
  },
  {
    "mcc": "250",
    "mnc": "57",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Matrix Mobile "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Media-Market "
  },
  {
    "mcc": "250",
    "mnc": "02",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Megafon "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Metro-Pei "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "MGTS "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Miatel "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "MOSTELECOM "
  },
  {
    "mcc": "250",
    "mnc": "35",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Motiv "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "MSN Telekom "
  },
  {
    "mcc": "250",
    "mnc": "01",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "MTS "
  },
  {
    "mcc": "250",
    "mnc": "42",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "MTT "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "NCI "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "NETBYNET "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "New Mobile Communications "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "OBIT "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Orange Business Services "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "PIN "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Plintron "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Quantech "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "RECONN "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Reteyl Innovatsii "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sberbank-Telecom "
  },
  {
    "mcc": "250",
    "mnc": "33",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "SEVTELECOM "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sim Sim "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sintonik "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sky Networks "
  },
  {
    "mcc": "250",
    "mnc": "09",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Skylink "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "SkyNet "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sonet "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Sprint "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Start "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "SunSIM "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Surgutneftegaz "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Svyazresurs-Mobile "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Tander "
  },
  {
    "mcc": "250",
    "mnc": "20",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Tele2 "
  },
  {
    "mcc": "250",
    "mnc": "12",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Tele2 "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Tinkoff Mobile "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TMT "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TransMobilCom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TRASTEL "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TRN-telecom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TTK "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TTK-Svyaz "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "TVE "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "UnitTelecom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Unycel "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Vainah Telecom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "ViKom "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Virgin Connect "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Voentelecom "
  },
  {
    "mcc": "250",
    "mnc": "77",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Glonass "
  },
  {
    "mcc": "250",
    "mnc": "60",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Volna Mobile "
  },
  {
    "mcc": "250",
    "mnc": "299",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "VTB Mobile "
  },
  {
    "mcc": "250",
    "mnc": "32",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Win Mobile "
  },
  {
    "mcc": "250",
    "mnc": "11",
    "iso": "ru",
    "country": "Russia",
    "countryCode": "79",
    "network": "Yota "
  },
  {
    "mcc": "635",
    "mnc": "13",
    "iso": "rw",
    "country": "Rwanda",
    "countryCode": "250",
    "network": "Airtel "
  },
  {
    "mcc": "635",
    "mnc": "299",
    "iso": "rw",
    "country": "Rwanda",
    "countryCode": "250",
    "network": "Failed Calls "
  },
  {
    "mcc": "635",
    "mnc": "999",
    "iso": "rw",
    "country": "Rwanda",
    "countryCode": "250",
    "network": "Fix Line "
  },
  {
    "mcc": "635",
    "mnc": "10",
    "iso": "rw",
    "country": "Rwanda",
    "countryCode": "250",
    "network": "MTN "
  },
  {
    "mcc": "658",
    "mnc": "299",
    "iso": "sh",
    "country": "Saint Helena and Ascension and Tristan da Cunha",
    "countryCode": "290",
    "network": "Failed Calls "
  },
  {
    "mcc": "658",
    "mnc": "999",
    "iso": "sh",
    "country": "Saint Helena and Ascension and Tristan da Cunha",
    "countryCode": "290",
    "network": "Fix Line "
  },
  {
    "mcc": "356",
    "mnc": "70",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Chippie "
  },
  {
    "mcc": "356",
    "mnc": "070",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Chippie "
  },
  {
    "mcc": "356",
    "mnc": "50",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Digicel "
  },
  {
    "mcc": "356",
    "mnc": "050",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Digicel "
  },
  {
    "mcc": "356",
    "mnc": "299",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Failed Calls "
  },
  {
    "mcc": "356",
    "mnc": "999",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Fix Line "
  },
  {
    "mcc": "356",
    "mnc": "110",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Flow "
  },
  {
    "mcc": "356",
    "mnc": "11",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "Flow "
  },
  {
    "mcc": "356",
    "mnc": "299",
    "iso": "kn",
    "country": "Saint Kitts and Nevis",
    "countryCode": "1869",
    "network": "The Cable "
  },
  {
    "mcc": "358",
    "mnc": "050",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Digicel "
  },
  {
    "mcc": "358",
    "mnc": "05",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Digicel "
  },
  {
    "mcc": "358",
    "mnc": "299",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Failed Calls "
  },
  {
    "mcc": "358",
    "mnc": "999",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Fix Line "
  },
  {
    "mcc": "358",
    "mnc": "110",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Flow "
  },
  {
    "mcc": "358",
    "mnc": "11",
    "iso": "lc",
    "country": "Saint Lucia",
    "countryCode": "1758",
    "network": "Flow "
  },
  {
    "mcc": "308",
    "mnc": "03",
    "iso": "pm",
    "country": "Saint Pierre and Miquelon",
    "countryCode": "508",
    "network": "Ameris "
  },
  {
    "mcc": "308",
    "mnc": "01",
    "iso": "pm",
    "country": "Saint Pierre and Miquelon",
    "countryCode": "508",
    "network": "Ameris "
  },
  {
    "mcc": "308",
    "mnc": "299",
    "iso": "pm",
    "country": "Saint Pierre and Miquelon",
    "countryCode": "508",
    "network": "Failed Calls "
  },
  {
    "mcc": "308",
    "mnc": "999",
    "iso": "pm",
    "country": "Saint Pierre and Miquelon",
    "countryCode": "508",
    "network": "Fix Line "
  },
  {
    "mcc": "308",
    "mnc": "02",
    "iso": "pm",
    "country": "Saint Pierre and Miquelon",
    "countryCode": "508",
    "network": "Globaltel "
  },
  {
    "mcc": "360",
    "mnc": "070",
    "iso": "vc",
    "country": "Saint Vincent and the Grenadines",
    "countryCode": "1784",
    "network": "Digicel "
  },
  {
    "mcc": "360",
    "mnc": "050",
    "iso": "vc",
    "country": "Saint Vincent and the Grenadines",
    "countryCode": "1784",
    "network": "Digicel "
  },
  {
    "mcc": "360",
    "mnc": "299",
    "iso": "vc",
    "country": "Saint Vincent and the Grenadines",
    "countryCode": "1784",
    "network": "Failed Calls "
  },
  {
    "mcc": "360",
    "mnc": "999",
    "iso": "vc",
    "country": "Saint Vincent and the Grenadines",
    "countryCode": "1784",
    "network": "Fix Line "
  },
  {
    "mcc": "360",
    "mnc": "110",
    "iso": "vc",
    "country": "Saint Vincent and the Grenadines",
    "countryCode": "1784",
    "network": "Flow "
  },
  {
    "mcc": "549",
    "mnc": "27",
    "iso": "ws",
    "country": "Samoa",
    "countryCode": "685",
    "network": "BlueSky "
  },
  {
    "mcc": "549",
    "mnc": "01",
    "iso": "ws",
    "country": "Samoa",
    "countryCode": "685",
    "network": "Digicel "
  },
  {
    "mcc": "549",
    "mnc": "299",
    "iso": "ws",
    "country": "Samoa",
    "countryCode": "685",
    "network": "Failed Calls "
  },
  {
    "mcc": "549",
    "mnc": "999",
    "iso": "ws",
    "country": "Samoa",
    "countryCode": "685",
    "network": "Fix Line "
  },
  {
    "mcc": "292",
    "mnc": "299",
    "iso": "sm",
    "country": "San Marino",
    "countryCode": "378",
    "network": "Failed Calls "
  },
  {
    "mcc": "292",
    "mnc": "999",
    "iso": "sm",
    "country": "San Marino",
    "countryCode": "378",
    "network": "Fix Line "
  },
  {
    "mcc": "292",
    "mnc": "01",
    "iso": "sm",
    "country": "San Marino",
    "countryCode": "378",
    "network": "Prima "
  },
  {
    "mcc": "292",
    "mnc": "299",
    "iso": "sm",
    "country": "San Marino",
    "countryCode": "378",
    "network": "TeleneT "
  },
  {
    "mcc": "626",
    "mnc": "01",
    "iso": "st",
    "country": "Sao Tome and Principe",
    "countryCode": "239",
    "network": "CSTmovel "
  },
  {
    "mcc": "626",
    "mnc": "299",
    "iso": "st",
    "country": "Sao Tome and Principe",
    "countryCode": "239",
    "network": "Failed Calls "
  },
  {
    "mcc": "626",
    "mnc": "999",
    "iso": "st",
    "country": "Sao Tome and Principe",
    "countryCode": "239",
    "network": "Fix Line "
  },
  {
    "mcc": "626",
    "mnc": "02",
    "iso": "st",
    "country": "Sao Tome and Principe",
    "countryCode": "239",
    "network": "Unitel "
  },
  {
    "mcc": "901",
    "mnc": "299",
    "iso": "n/a",
    "country": "Satellite Networks",
    "countryCode": "870",
    "network": "Failed Calls "
  },
  {
    "mcc": "901",
    "mnc": "999",
    "iso": "n/a",
    "country": "Satellite Networks",
    "countryCode": "870",
    "network": "Fix Line "
  },
  {
    "mcc": "420",
    "mnc": "299",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Failed Calls "
  },
  {
    "mcc": "420",
    "mnc": "999",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Fix Line "
  },
  {
    "mcc": "420",
    "mnc": "06",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Lebara Mobile "
  },
  {
    "mcc": "420",
    "mnc": "03",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Mobily "
  },
  {
    "mcc": "420",
    "mnc": "299",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Red Bull MOBILE "
  },
  {
    "mcc": "420",
    "mnc": "299",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Salam "
  },
  {
    "mcc": "420",
    "mnc": "01",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "STC / Al Jawal "
  },
  {
    "mcc": "420",
    "mnc": "05",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "420",
    "mnc": "04",
    "iso": "sa",
    "country": "Saudi Arabia",
    "countryCode": "966",
    "network": "Zain "
  },
  {
    "mcc": "608",
    "mnc": "299",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "2s Mobile "
  },
  {
    "mcc": "608",
    "mnc": "03",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Expresso "
  },
  {
    "mcc": "608",
    "mnc": "299",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Failed Calls "
  },
  {
    "mcc": "608",
    "mnc": "999",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Fix Line "
  },
  {
    "mcc": "608",
    "mnc": "02",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Free "
  },
  {
    "mcc": "608",
    "mnc": "04",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "HAYO "
  },
  {
    "mcc": "608",
    "mnc": "01",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Orange "
  },
  {
    "mcc": "608",
    "mnc": "299",
    "iso": "sn",
    "country": "Senegal",
    "countryCode": "221",
    "network": "Promobile "
  },
  {
    "mcc": "220",
    "mnc": "299",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "Failed Calls "
  },
  {
    "mcc": "220",
    "mnc": "999",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "Fix Line "
  },
  {
    "mcc": "220",
    "mnc": "11",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "Globaltel "
  },
  {
    "mcc": "220",
    "mnc": "03",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "MTS "
  },
  {
    "mcc": "220",
    "mnc": "01",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "Telenor "
  },
  {
    "mcc": "220",
    "mnc": "20",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "VIP "
  },
  {
    "mcc": "220",
    "mnc": "05",
    "iso": "rs",
    "country": "Serbia",
    "countryCode": "381",
    "network": "VIP "
  },
  {
    "mcc": "633",
    "mnc": "10",
    "iso": "sc",
    "country": "Seychelles",
    "countryCode": "248",
    "network": "Airtel "
  },
  {
    "mcc": "633",
    "mnc": "01",
    "iso": "sc",
    "country": "Seychelles",
    "countryCode": "248",
    "network": "Cable & Wireless "
  },
  {
    "mcc": "633",
    "mnc": "299",
    "iso": "sc",
    "country": "Seychelles",
    "countryCode": "248",
    "network": "Failed Calls "
  },
  {
    "mcc": "633",
    "mnc": "999",
    "iso": "sc",
    "country": "Seychelles",
    "countryCode": "248",
    "network": "Fix Line "
  },
  {
    "mcc": "633",
    "mnc": "05",
    "iso": "sc",
    "country": "Seychelles",
    "countryCode": "248",
    "network": "Intelvision "
  },
  {
    "mcc": "619",
    "mnc": "05",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Africell "
  },
  {
    "mcc": "619",
    "mnc": "03",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Africell "
  },
  {
    "mcc": "619",
    "mnc": "04",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Comium "
  },
  {
    "mcc": "619",
    "mnc": "299",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Failed Calls "
  },
  {
    "mcc": "619",
    "mnc": "999",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Fix Line "
  },
  {
    "mcc": "619",
    "mnc": "299",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "IPTel "
  },
  {
    "mcc": "619",
    "mnc": "25",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Mobitel "
  },
  {
    "mcc": "619",
    "mnc": "299",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Onlime "
  },
  {
    "mcc": "619",
    "mnc": "01",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Orange "
  },
  {
    "mcc": "619",
    "mnc": "07",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "Qcell "
  },
  {
    "mcc": "619",
    "mnc": "299",
    "iso": "sl",
    "country": "Sierra Leone",
    "countryCode": "232",
    "network": "SierraTel "
  },
  {
    "mcc": "525",
    "mnc": "09",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Circles.Life "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Failed Calls "
  },
  {
    "mcc": "525",
    "mnc": "999",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Fix Line "
  },
  {
    "mcc": "525",
    "mnc": "12",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "GRID "
  },
  {
    "mcc": "525",
    "mnc": "03",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "M1 "
  },
  {
    "mcc": "525",
    "mnc": "11",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "M1 "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "MyRepublic "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Nexwave "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "redONE "
  },
  {
    "mcc": "525",
    "mnc": "02",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "SingTel "
  },
  {
    "mcc": "525",
    "mnc": "01",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "SingTel "
  },
  {
    "mcc": "525",
    "mnc": "07",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "SingTel "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Smart Pinoy "
  },
  {
    "mcc": "525",
    "mnc": "06",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Starhub "
  },
  {
    "mcc": "525",
    "mnc": "05",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Starhub "
  },
  {
    "mcc": "525",
    "mnc": "08",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Starhub "
  },
  {
    "mcc": "525",
    "mnc": "10",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "TPG Telecom "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "VivoBee "
  },
  {
    "mcc": "525",
    "mnc": "299",
    "iso": "sg",
    "country": "Singapore",
    "countryCode": "65",
    "network": "Zero1 "
  },
  {
    "mcc": "231",
    "mnc": "299",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Failed Calls "
  },
  {
    "mcc": "231",
    "mnc": "999",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Fix Line "
  },
  {
    "mcc": "231",
    "mnc": "06",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "O2 "
  },
  {
    "mcc": "231",
    "mnc": "05",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Orange "
  },
  {
    "mcc": "231",
    "mnc": "07",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Orange "
  },
  {
    "mcc": "231",
    "mnc": "01",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Orange "
  },
  {
    "mcc": "231",
    "mnc": "03",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Swan / 4ka "
  },
  {
    "mcc": "231",
    "mnc": "02",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Telekom "
  },
  {
    "mcc": "231",
    "mnc": "50",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Telekom "
  },
  {
    "mcc": "231",
    "mnc": "04",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Telekom "
  },
  {
    "mcc": "231",
    "mnc": "08",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Uniphone "
  },
  {
    "mcc": "231",
    "mnc": "299",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "Vonage "
  },
  {
    "mcc": "231",
    "mnc": "99",
    "iso": "sk",
    "country": "Slovakia",
    "countryCode": "421",
    "network": "ZSR "
  },
  {
    "mcc": "293",
    "mnc": "40",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "A1 / Si.mobil "
  },
  {
    "mcc": "293",
    "mnc": "20",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Compatel "
  },
  {
    "mcc": "293",
    "mnc": "86",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Elektro Gorenjska "
  },
  {
    "mcc": "293",
    "mnc": "299",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Failed Calls "
  },
  {
    "mcc": "293",
    "mnc": "999",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Fix Line "
  },
  {
    "mcc": "293",
    "mnc": "299",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "HOT mobil "
  },
  {
    "mcc": "293",
    "mnc": "299",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Me2 "
  },
  {
    "mcc": "293",
    "mnc": "41",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Mobitel "
  },
  {
    "mcc": "293",
    "mnc": "299",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Novatel "
  },
  {
    "mcc": "293",
    "mnc": "10",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Slovenske zeleznice "
  },
  {
    "mcc": "293",
    "mnc": "299",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "SoftNET "
  },
  {
    "mcc": "293",
    "mnc": "64",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "T-2 "
  },
  {
    "mcc": "293",
    "mnc": "70",
    "iso": "si",
    "country": "Slovenia",
    "countryCode": "386",
    "network": "Telemach / Tusmobil "
  },
  {
    "mcc": "540",
    "mnc": "02",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "bemobile "
  },
  {
    "mcc": "540",
    "mnc": "01",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "Breeze "
  },
  {
    "mcc": "540",
    "mnc": "299",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "Failed Calls "
  },
  {
    "mcc": "540",
    "mnc": "999",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "Fix Line "
  },
  {
    "mcc": "540",
    "mnc": "299",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "Satsol "
  },
  {
    "mcc": "540",
    "mnc": "299",
    "iso": "sb",
    "country": "Solomon Islands",
    "countryCode": "677",
    "network": "Smile "
  },
  {
    "mcc": "637",
    "mnc": "299",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "AirSom "
  },
  {
    "mcc": "637",
    "mnc": "299",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Failed Calls "
  },
  {
    "mcc": "637",
    "mnc": "999",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Fix Line "
  },
  {
    "mcc": "637",
    "mnc": "30",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Golis "
  },
  {
    "mcc": "637",
    "mnc": "19",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Hormuud "
  },
  {
    "mcc": "637",
    "mnc": "10",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Nationlink "
  },
  {
    "mcc": "637",
    "mnc": "299",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "NETCO "
  },
  {
    "mcc": "637",
    "mnc": "70",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Onkod "
  },
  {
    "mcc": "637",
    "mnc": "04",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Somafone "
  },
  {
    "mcc": "637",
    "mnc": "299",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "SomNetworks "
  },
  {
    "mcc": "637",
    "mnc": "71",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Somtel "
  },
  {
    "mcc": "637",
    "mnc": "299",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "STG "
  },
  {
    "mcc": "637",
    "mnc": "82",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Telcom Mobile "
  },
  {
    "mcc": "637",
    "mnc": "01",
    "iso": "so",
    "country": "Somalia",
    "countryCode": "252",
    "network": "Telesom "
  },
  {
    "mcc": "655",
    "mnc": "07",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Cell C "
  },
  {
    "mcc": "655",
    "mnc": "299",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Failed Calls "
  },
  {
    "mcc": "655",
    "mnc": "999",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Fix Line "
  },
  {
    "mcc": "655",
    "mnc": "299",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Lycamobile "
  },
  {
    "mcc": "655",
    "mnc": "12",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "MTN "
  },
  {
    "mcc": "655",
    "mnc": "10",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "MTN "
  },
  {
    "mcc": "655",
    "mnc": "73",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Rain "
  },
  {
    "mcc": "655",
    "mnc": "74",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Rain "
  },
  {
    "mcc": "655",
    "mnc": "38",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Rain "
  },
  {
    "mcc": "655",
    "mnc": "19",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Rain "
  },
  {
    "mcc": "655",
    "mnc": "05",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Telkom "
  },
  {
    "mcc": "655",
    "mnc": "02",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Telkom "
  },
  {
    "mcc": "655",
    "mnc": "299",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "655",
    "mnc": "01",
    "iso": "za",
    "country": "South Africa",
    "countryCode": "27",
    "network": "Vodacom "
  },
  {
    "mcc": "450",
    "mnc": "299",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "Failed Calls "
  },
  {
    "mcc": "450",
    "mnc": "999",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "Fix Line "
  },
  {
    "mcc": "450",
    "mnc": "07",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "KT Powertel "
  },
  {
    "mcc": "450",
    "mnc": "06",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "LG U+ "
  },
  {
    "mcc": "450",
    "mnc": "02",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "olleh / KT "
  },
  {
    "mcc": "450",
    "mnc": "04",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "olleh / KT "
  },
  {
    "mcc": "450",
    "mnc": "08",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "olleh / KT "
  },
  {
    "mcc": "450",
    "mnc": "11",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "SK Telecom "
  },
  {
    "mcc": "450",
    "mnc": "12",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "SK Telecom "
  },
  {
    "mcc": "450",
    "mnc": "05",
    "iso": "kr",
    "country": "South Korea",
    "countryCode": "82",
    "network": "SK Telecom "
  },
  {
    "mcc": "659",
    "mnc": "299",
    "iso": "ss",
    "country": "South Sudan",
    "countryCode": "",
    "network": "Digitel "
  },
  {
    "mcc": "659",
    "mnc": "299",
    "iso": "ss",
    "country": "South Sudan",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "659",
    "mnc": "999",
    "iso": "ss",
    "country": "South Sudan",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "659",
    "mnc": "02",
    "iso": "ss",
    "country": "South Sudan",
    "countryCode": "",
    "network": "MTN "
  },
  {
    "mcc": "659",
    "mnc": "06",
    "iso": "ss",
    "country": "South Sudan",
    "countryCode": "",
    "network": "Zain "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "ACN "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Adamo Telecom "
  },
  {
    "mcc": "214",
    "mnc": "36",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Alai "
  },
  {
    "mcc": "214",
    "mnc": "02",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Alta Tecnologia en Comunicacions "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Aurea "
  },
  {
    "mcc": "214",
    "mnc": "14",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Avatel Movil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Billing Financial "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Bluephone "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "CloudComms "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Dialoga "
  },
  {
    "mcc": "214",
    "mnc": "22",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Digi.Mobil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Dragonet "
  },
  {
    "mcc": "214",
    "mnc": "08",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Euskaltel Movil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Evolutio "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Failed Calls "
  },
  {
    "mcc": "214",
    "mnc": "999",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Fix Line "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Global "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "GNET "
  },
  {
    "mcc": "214",
    "mnc": "34",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "ION MOBILE "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Jetnet "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Lemonvil "
  },
  {
    "mcc": "214",
    "mnc": "25",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Lycamobile "
  },
  {
    "mcc": "214",
    "mnc": "17",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "mobil R "
  },
  {
    "mcc": "214",
    "mnc": "07",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Movistar "
  },
  {
    "mcc": "214",
    "mnc": "38",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Movistar "
  },
  {
    "mcc": "214",
    "mnc": "05",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Movistar "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Olephone "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "On Movil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Oniti Telecom "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "OperadorsCat "
  },
  {
    "mcc": "214",
    "mnc": "03",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Orange "
  },
  {
    "mcc": "214",
    "mnc": "21",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Orange "
  },
  {
    "mcc": "214",
    "mnc": "09",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Orange "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Pepephone "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Premium Numbers "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "PTV Telecom movil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Quattre "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Sarenet "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "SEWAN "
  },
  {
    "mcc": "214",
    "mnc": "19",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Simyo "
  },
  {
    "mcc": "214",
    "mnc": "35",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "SUMA movil "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Suop "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Syma "
  },
  {
    "mcc": "214",
    "mnc": "16",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "mobil R "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Telsome "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "The Telecom Boutique "
  },
  {
    "mcc": "214",
    "mnc": "27",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Truphone "
  },
  {
    "mcc": "214",
    "mnc": "12",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Venus Movil "
  },
  {
    "mcc": "214",
    "mnc": "06",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Vodafone "
  },
  {
    "mcc": "214",
    "mnc": "01",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Vodafone "
  },
  {
    "mcc": "214",
    "mnc": "37",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Vodafone "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Vodafone Enabler "
  },
  {
    "mcc": "214",
    "mnc": "23",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Yoigo "
  },
  {
    "mcc": "214",
    "mnc": "33",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Yoigo "
  },
  {
    "mcc": "214",
    "mnc": "29",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Yoigo "
  },
  {
    "mcc": "214",
    "mnc": "04",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Yoigo "
  },
  {
    "mcc": "214",
    "mnc": "299",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "You Mobile "
  },
  {
    "mcc": "214",
    "mnc": "10",
    "iso": "es",
    "country": "Spain",
    "countryCode": "34",
    "network": "Zinnia "
  },
  {
    "mcc": "413",
    "mnc": "05",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Airtel "
  },
  {
    "mcc": "413",
    "mnc": "02",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Dialog "
  },
  {
    "mcc": "413",
    "mnc": "299",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Failed Calls "
  },
  {
    "mcc": "413",
    "mnc": "999",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Fix Line "
  },
  {
    "mcc": "413",
    "mnc": "08",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Hutch "
  },
  {
    "mcc": "413",
    "mnc": "01",
    "iso": "lk",
    "country": "Sri Lanka",
    "countryCode": "94",
    "network": "Mobitel "
  },
  {
    "mcc": "634",
    "mnc": "299",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "Failed Calls "
  },
  {
    "mcc": "634",
    "mnc": "999",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "Fix Line "
  },
  {
    "mcc": "634",
    "mnc": "03",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "MTN "
  },
  {
    "mcc": "634",
    "mnc": "02",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "MTN "
  },
  {
    "mcc": "634",
    "mnc": "07",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "Sudani One "
  },
  {
    "mcc": "634",
    "mnc": "01",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "Zain "
  },
  {
    "mcc": "634",
    "mnc": "06",
    "iso": "sd",
    "country": "Sudan",
    "countryCode": "249",
    "network": "Zain "
  },
  {
    "mcc": "746",
    "mnc": "03",
    "iso": "sr",
    "country": "Suriname",
    "countryCode": "597",
    "network": "Digicel "
  },
  {
    "mcc": "746",
    "mnc": "299",
    "iso": "sr",
    "country": "Suriname",
    "countryCode": "597",
    "network": "Failed Calls "
  },
  {
    "mcc": "746",
    "mnc": "999",
    "iso": "sr",
    "country": "Suriname",
    "countryCode": "597",
    "network": "Fix Line "
  },
  {
    "mcc": "746",
    "mnc": "02",
    "iso": "sr",
    "country": "Suriname",
    "countryCode": "597",
    "network": "Telesur "
  },
  {
    "mcc": "653",
    "mnc": "02",
    "iso": "sz",
    "country": "Swaziland",
    "countryCode": "268",
    "network": "Eswatini Mobile "
  },
  {
    "mcc": "653",
    "mnc": "01",
    "iso": "sz",
    "country": "Swaziland",
    "countryCode": "268",
    "network": "Eswatini Telecom "
  },
  {
    "mcc": "653",
    "mnc": "299",
    "iso": "sz",
    "country": "Swaziland",
    "countryCode": "268",
    "network": "Failed Calls "
  },
  {
    "mcc": "653",
    "mnc": "999",
    "iso": "sz",
    "country": "Swaziland",
    "countryCode": "268",
    "network": "Fix Line "
  },
  {
    "mcc": "653",
    "mnc": "10",
    "iso": "sz",
    "country": "Swaziland",
    "countryCode": "268",
    "network": "Swazi MTN "
  },
  {
    "mcc": "240",
    "mnc": "16",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": ""
  },
  {
    "mcc": "240",
    "mnc": "35",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "42 Telecom "
  },
  {
    "mcc": "240",
    "mnc": "13",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "A3 "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Advoco "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": ""
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Allo Telecom "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Bahnhof "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Benemen "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Biztel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "BM Sverige "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Bredband 2 "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Bredbandsson "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "BSG "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Chilimobil "
  },
  {
    "mcc": "240",
    "mnc": "11",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Com Hem "
  },
  {
    "mcc": "240",
    "mnc": "09",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Com4 "
  },
  {
    "mcc": "240",
    "mnc": "32",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Compatel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Connectel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Core Telecom "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "easy pbx "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "EasyTelecom "
  },
  {
    "mcc": "240",
    "mnc": "22",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "EUtel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Failed Calls "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fastcom "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Febo Telecom "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fello "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fibio "
  },
  {
    "mcc": "240",
    "mnc": "63",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fink Telecom "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Firstcom "
  },
  {
    "mcc": "240",
    "mnc": "999",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fix Line "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Fonia "
  },
  {
    "mcc": "240",
    "mnc": "18",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Messit / Minicall "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Global Telefoni "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "GlobalConnect "
  },
  {
    "mcc": "240",
    "mnc": "27",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Globetouch "
  },
  {
    "mcc": "240",
    "mnc": "17",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Gotanet "
  },
  {
    "mcc": "240",
    "mnc": "02",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "3 "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Horisen "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "iCentrex "
  },
  {
    "mcc": "240",
    "mnc": "23",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Infobip "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "InfraCom "
  },
  {
    "mcc": "240",
    "mnc": "36",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "interactive digital media / IDM "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Ipify "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Junyverse "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Karma Mobil "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Lancelot "
  },
  {
    "mcc": "240",
    "mnc": "28",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "LINK Mobility "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Loxysoft "
  },
  {
    "mcc": "240",
    "mnc": "12",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Lycamobile "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Maingate "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Megaphone "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "MessageBird "
  },
  {
    "mcc": "240",
    "mnc": "29",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "MI Carrier Services "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "miniTel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Mitto "
  },
  {
    "mcc": "240",
    "mnc": "33",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Mobile Arts "
  },
  {
    "mcc": "240",
    "mnc": "43",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "MobiWeb "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Molnstruktur "
  },
  {
    "mcc": "240",
    "mnc": "25",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Monty Mobile "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "My Beat "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Net at Once "
  },
  {
    "mcc": "240",
    "mnc": "40",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Netmore "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Netsize "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Bixia AB "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "onoff "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Premium Numbers "
  },
  {
    "mcc": "240",
    "mnc": "39",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Primlight "
  },
  {
    "mcc": "240",
    "mnc": "31",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Rebtel "
  },
  {
    "mcc": "240",
    "mnc": "20",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Sierra Wireless "
  },
  {
    "mcc": "240",
    "mnc": "15",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": ""
  },
  {
    "mcc": "240",
    "mnc": "37",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Sinch "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "soatso "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Soluno "
  },
  {
    "mcc": "240",
    "mnc": "45",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Spirius "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "SSTNet "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Svea Billing Services "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Svensk Konsumentmobil "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "TelaVox "
  },
  {
    "mcc": "240",
    "mnc": "14",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tele2 "
  },
  {
    "mcc": "240",
    "mnc": "05",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tele2 "
  },
  {
    "mcc": "240",
    "mnc": "07",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tele2 "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telecom3 Sverige AB "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Teledigit Scandinavia AB "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telekometen "
  },
  {
    "mcc": "240",
    "mnc": "44",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telenabler "
  },
  {
    "mcc": "240",
    "mnc": "42",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telenor Connexion "
  },
  {
    "mcc": "240",
    "mnc": "04",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telenor "
  },
  {
    "mcc": "240",
    "mnc": "08",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telenor "
  },
  {
    "mcc": "240",
    "mnc": "01",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telia "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tell it to Mi "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Telness "
  },
  {
    "mcc": "240",
    "mnc": "03",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Net 1 "
  },
  {
    "mcc": "240",
    "mnc": "48",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tismi "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Tolv Mobil "
  },
  {
    "mcc": "240",
    "mnc": "21",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Trafikverket "
  },
  {
    "mcc": "240",
    "mnc": "26",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Twilio "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Unicorn Telecom "
  },
  {
    "mcc": "240",
    "mnc": "19",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Verbal "
  },
  {
    "mcc": "240",
    "mnc": "46",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Viahub "
  },
  {
    "mcc": "240",
    "mnc": "47",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Viatel "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Vobbiz "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Voice Integrate "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Voicetech "
  },
  {
    "mcc": "240",
    "mnc": "38",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Voxbone / Bandwidth "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Weelia "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Wifi.se "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "Wifog Sverige "
  },
  {
    "mcc": "240",
    "mnc": "299",
    "iso": "se",
    "country": "Sweden",
    "countryCode": "46",
    "network": "XPLORA "
  },
  {
    "mcc": "228",
    "mnc": "58",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Beeone "
  },
  {
    "mcc": "228",
    "mnc": "05",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Comfone "
  },
  {
    "mcc": "228",
    "mnc": "09",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Comfone "
  },
  {
    "mcc": "228",
    "mnc": "299",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Failed Calls "
  },
  {
    "mcc": "228",
    "mnc": "999",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Fix Line "
  },
  {
    "mcc": "228",
    "mnc": "66",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Inovia "
  },
  {
    "mcc": "228",
    "mnc": "54",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Lycamobile "
  },
  {
    "mcc": "228",
    "mnc": "69",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "MTEL "
  },
  {
    "mcc": "228",
    "mnc": "65",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Nexphone "
  },
  {
    "mcc": "228",
    "mnc": "51",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "relario "
  },
  {
    "mcc": "228",
    "mnc": "03",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Salt Mobile "
  },
  {
    "mcc": "228",
    "mnc": "06",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "SBB "
  },
  {
    "mcc": "228",
    "mnc": "12",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Sunrise "
  },
  {
    "mcc": "228",
    "mnc": "60",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Sunrise "
  },
  {
    "mcc": "228",
    "mnc": "07",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Sunrise "
  },
  {
    "mcc": "228",
    "mnc": "02",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Sunrise "
  },
  {
    "mcc": "228",
    "mnc": "08",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Sunrise "
  },
  {
    "mcc": "228",
    "mnc": "01",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Swisscom "
  },
  {
    "mcc": "228",
    "mnc": "62",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Telecom26 "
  },
  {
    "mcc": "228",
    "mnc": "70",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Tismi "
  },
  {
    "mcc": "228",
    "mnc": "53",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "UPC "
  },
  {
    "mcc": "228",
    "mnc": "59",
    "iso": "ch",
    "country": "Switzerland",
    "countryCode": "41",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "417",
    "mnc": "299",
    "iso": "sy",
    "country": "Syria",
    "countryCode": "963",
    "network": "Failed Calls "
  },
  {
    "mcc": "417",
    "mnc": "999",
    "iso": "sy",
    "country": "Syria",
    "countryCode": "963",
    "network": "Fix Line "
  },
  {
    "mcc": "417",
    "mnc": "02",
    "iso": "sy",
    "country": "Syria",
    "countryCode": "963",
    "network": "MTN "
  },
  {
    "mcc": "417",
    "mnc": "01",
    "iso": "sy",
    "country": "Syria",
    "countryCode": "963",
    "network": "Syriatel "
  },
  {
    "mcc": "466",
    "mnc": "05",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "APT "
  },
  {
    "mcc": "466",
    "mnc": "12",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "APT "
  },
  {
    "mcc": "466",
    "mnc": "92",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Chunghwa Telecom "
  },
  {
    "mcc": "466",
    "mnc": "11",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Chunghwa Telecom "
  },
  {
    "mcc": "466",
    "mnc": "299",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Failed Calls "
  },
  {
    "mcc": "466",
    "mnc": "88",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Far EasTone "
  },
  {
    "mcc": "466",
    "mnc": "01",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Far EasTone "
  },
  {
    "mcc": "466",
    "mnc": "03",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Far EasTone "
  },
  {
    "mcc": "466",
    "mnc": "999",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Fix Line "
  },
  {
    "mcc": "466",
    "mnc": "89",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "T Star "
  },
  {
    "mcc": "466",
    "mnc": "97",
    "iso": "tw",
    "country": "Taiwan",
    "countryCode": "886",
    "network": "Taiwan Mobile "
  },
  {
    "mcc": "436",
    "mnc": "04",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Babilon-Mobile "
  },
  {
    "mcc": "436",
    "mnc": "299",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Failed Calls "
  },
  {
    "mcc": "436",
    "mnc": "999",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Fix Line "
  },
  {
    "mcc": "436",
    "mnc": "03",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Megafon "
  },
  {
    "mcc": "436",
    "mnc": "15",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "O-Mobile "
  },
  {
    "mcc": "436",
    "mnc": "299",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Premium Numbers "
  },
  {
    "mcc": "436",
    "mnc": "02",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Tcell "
  },
  {
    "mcc": "436",
    "mnc": "01",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Tcell "
  },
  {
    "mcc": "436",
    "mnc": "05",
    "iso": "tj",
    "country": "Tajikistan",
    "countryCode": "992",
    "network": "Zet-Mobile "
  },
  {
    "mcc": "640",
    "mnc": "05",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Airtel "
  },
  {
    "mcc": "640",
    "mnc": "299",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Failed Calls "
  },
  {
    "mcc": "640",
    "mnc": "999",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Fix Line "
  },
  {
    "mcc": "640",
    "mnc": "09",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Halotel / Viettel "
  },
  {
    "mcc": "640",
    "mnc": "99",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Mkulima African Telecommunication "
  },
  {
    "mcc": "640",
    "mnc": "14",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "MO Mobile "
  },
  {
    "mcc": "640",
    "mnc": "11",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Smile Communications "
  },
  {
    "mcc": "640",
    "mnc": "07",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Tanzania Telecommunication Corporation "
  },
  {
    "mcc": "640",
    "mnc": "02",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Tigo / MIC "
  },
  {
    "mcc": "640",
    "mnc": "04",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Vodacom "
  },
  {
    "mcc": "640",
    "mnc": "13",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "WiAfrica "
  },
  {
    "mcc": "640",
    "mnc": "03",
    "iso": "tz",
    "country": "Tanzania",
    "countryCode": "255",
    "network": "Zanzibar Telecom / Zantel "
  },
  {
    "mcc": "520",
    "mnc": "03",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "AIS "
  },
  {
    "mcc": "520",
    "mnc": "01",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "AIS "
  },
  {
    "mcc": "520",
    "mnc": "18",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "dtac "
  },
  {
    "mcc": "520",
    "mnc": "05",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "dtac TriNet "
  },
  {
    "mcc": "520",
    "mnc": "299",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "Failed Calls "
  },
  {
    "mcc": "520",
    "mnc": "999",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "Fix Line "
  },
  {
    "mcc": "520",
    "mnc": "00",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "my "
  },
  {
    "mcc": "520",
    "mnc": "15",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "TOTmobile "
  },
  {
    "mcc": "520",
    "mnc": "47",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "TOTmobile "
  },
  {
    "mcc": "520",
    "mnc": "04",
    "iso": "th",
    "country": "Thailand",
    "countryCode": "66",
    "network": "TrueMove H "
  },
  {
    "mcc": "615",
    "mnc": "03",
    "iso": "tg",
    "country": "Togo",
    "countryCode": "228",
    "network": "Atlantique Telecom / Moov "
  },
  {
    "mcc": "615",
    "mnc": "299",
    "iso": "tg",
    "country": "Togo",
    "countryCode": "228",
    "network": "Failed Calls "
  },
  {
    "mcc": "615",
    "mnc": "999",
    "iso": "tg",
    "country": "Togo",
    "countryCode": "228",
    "network": "Fix Line "
  },
  {
    "mcc": "615",
    "mnc": "01",
    "iso": "tg",
    "country": "Togo",
    "countryCode": "228",
    "network": "Togo Cellulaire / TogoCel "
  },
  {
    "mcc": "539",
    "mnc": "88",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "Digicel "
  },
  {
    "mcc": "539",
    "mnc": "43",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "Digicel "
  },
  {
    "mcc": "539",
    "mnc": "299",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "Failed Calls "
  },
  {
    "mcc": "539",
    "mnc": "999",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "Fix Line "
  },
  {
    "mcc": "539",
    "mnc": "01",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "U-Call "
  },
  {
    "mcc": "539",
    "mnc": "299",
    "iso": "to",
    "country": "Tonga",
    "countryCode": "676",
    "network": "WanTok "
  },
  {
    "mcc": "374",
    "mnc": "12",
    "iso": "tt",
    "country": "Trinidad and Tobago",
    "countryCode": "1868",
    "network": "bmobile "
  },
  {
    "mcc": "374",
    "mnc": "130",
    "iso": "tt",
    "country": "Trinidad and Tobago",
    "countryCode": "1868",
    "network": "Digicel "
  },
  {
    "mcc": "374",
    "mnc": "299",
    "iso": "tt",
    "country": "Trinidad and Tobago",
    "countryCode": "1868",
    "network": "Failed Calls "
  },
  {
    "mcc": "374",
    "mnc": "999",
    "iso": "tt",
    "country": "Trinidad and Tobago",
    "countryCode": "1868",
    "network": "Fix Line "
  },
  {
    "mcc": "605",
    "mnc": "299",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "Failed Calls "
  },
  {
    "mcc": "605",
    "mnc": "999",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "Fix Line "
  },
  {
    "mcc": "605",
    "mnc": "06",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "Lycamobile "
  },
  {
    "mcc": "605",
    "mnc": "03",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "Ooredoo "
  },
  {
    "mcc": "605",
    "mnc": "01",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "Orange "
  },
  {
    "mcc": "605",
    "mnc": "02",
    "iso": "tn",
    "country": "Tunisia",
    "countryCode": "216",
    "network": "TT Mobile "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Asistan Telekom "
  },
  {
    "mcc": "286",
    "mnc": "04",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Avea "
  },
  {
    "mcc": "286",
    "mnc": "03",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Avea "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "BasakCell "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Compatel "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Failed Calls "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Fenix Telekom "
  },
  {
    "mcc": "286",
    "mnc": "999",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Fix Line "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Foniva "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "IsNet "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Maxiphone "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Medium Telekom "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Mobilisim "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Netgsm "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Nida "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Oris "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Pelicell "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Plus Telekom "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Roitel "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "SesNet "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "TCDD "
  },
  {
    "mcc": "286",
    "mnc": "299",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "TTM "
  },
  {
    "mcc": "286",
    "mnc": "01",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Turkcell "
  },
  {
    "mcc": "286",
    "mnc": "02",
    "iso": "tr",
    "country": "Turkiye",
    "countryCode": "90",
    "network": "Vodafone "
  },
  {
    "mcc": "438",
    "mnc": "01",
    "iso": "tm",
    "country": "Turkmenistan",
    "countryCode": "993",
    "network": "MTS "
  },
  {
    "mcc": "438",
    "mnc": "299",
    "iso": "tm",
    "country": "Turkmenistan",
    "countryCode": "993",
    "network": "Failed Calls "
  },
  {
    "mcc": "438",
    "mnc": "999",
    "iso": "tm",
    "country": "Turkmenistan",
    "countryCode": "993",
    "network": "Fix Line "
  },
  {
    "mcc": "438",
    "mnc": "02",
    "iso": "tm",
    "country": "Turkmenistan",
    "countryCode": "993",
    "network": "TMCELL "
  },
  {
    "mcc": "376",
    "mnc": "360",
    "iso": "tc",
    "country": "Turks and Caicos Islands",
    "countryCode": "",
    "network": "Digicel "
  },
  {
    "mcc": "376",
    "mnc": "050",
    "iso": "tc",
    "country": "Turks and Caicos Islands",
    "countryCode": "",
    "network": "Digicel "
  },
  {
    "mcc": "376",
    "mnc": "299",
    "iso": "tc",
    "country": "Turks and Caicos Islands",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "376",
    "mnc": "999",
    "iso": "tc",
    "country": "Turks and Caicos Islands",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "376",
    "mnc": "350",
    "iso": "tc",
    "country": "Turks and Caicos Islands",
    "countryCode": "",
    "network": "Flow "
  },
  {
    "mcc": "553",
    "mnc": "299",
    "iso": "tv",
    "country": "Tuvalu",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "553",
    "mnc": "999",
    "iso": "tv",
    "country": "Tuvalu",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "553",
    "mnc": "01",
    "iso": "tv",
    "country": "Tuvalu",
    "countryCode": "",
    "network": "Tuvalu Telecom "
  },
  {
    "mcc": "641",
    "mnc": "22",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Airtel "
  },
  {
    "mcc": "641",
    "mnc": "01",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Airtel "
  },
  {
    "mcc": "641",
    "mnc": "299",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Failed Calls "
  },
  {
    "mcc": "641",
    "mnc": "999",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Fix Line "
  },
  {
    "mcc": "641",
    "mnc": "04",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Lycamobile "
  },
  {
    "mcc": "641",
    "mnc": "11",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Mango "
  },
  {
    "mcc": "641",
    "mnc": "10",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "MTN "
  },
  {
    "mcc": "641",
    "mnc": "33",
    "iso": "ug",
    "country": "Uganda",
    "countryCode": "256",
    "network": "Smile "
  },
  {
    "mcc": "255",
    "mnc": "07",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "3Mob "
  },
  {
    "mcc": "255",
    "mnc": "299",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Failed Calls "
  },
  {
    "mcc": "255",
    "mnc": "999",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Fix Line "
  },
  {
    "mcc": "255",
    "mnc": "04",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "IT "
  },
  {
    "mcc": "255",
    "mnc": "03",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Kyivstar "
  },
  {
    "mcc": "255",
    "mnc": "02",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Kyivstar "
  },
  {
    "mcc": "255",
    "mnc": "06",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "lifecell "
  },
  {
    "mcc": "255",
    "mnc": "21",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "PEOPLEnet "
  },
  {
    "mcc": "255",
    "mnc": "99",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Phoenix "
  },
  {
    "mcc": "255",
    "mnc": "01",
    "iso": "ua",
    "country": "Ukraine",
    "countryCode": "380",
    "network": "Vodafone "
  },
  {
    "mcc": "424",
    "mnc": "03",
    "iso": "ae",
    "country": "United Arab Emirates",
    "countryCode": "971",
    "network": "DU "
  },
  {
    "mcc": "424",
    "mnc": "02",
    "iso": "ae",
    "country": "United Arab Emirates",
    "countryCode": "971",
    "network": "Etisalat "
  },
  {
    "mcc": "424",
    "mnc": "299",
    "iso": "ae",
    "country": "United Arab Emirates",
    "countryCode": "971",
    "network": "Failed Calls "
  },
  {
    "mcc": "424",
    "mnc": "999",
    "iso": "ae",
    "country": "United Arab Emirates",
    "countryCode": "971",
    "network": "Fix Line "
  },
  {
    "mcc": "234",
    "mnc": "78",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Airwave "
  },
  {
    "mcc": "234",
    "mnc": "29",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "aql "
  },
  {
    "mcc": "234",
    "mnc": "76",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "BT Group "
  },
  {
    "mcc": "234",
    "mnc": "00",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "BT Group "
  },
  {
    "mcc": "234",
    "mnc": "08",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "BT OnePhone "
  },
  {
    "mcc": "234",
    "mnc": "18",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Cloud9 "
  },
  {
    "mcc": "234",
    "mnc": "32",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "EE/Everything Everywhere "
  },
  {
    "mcc": "234",
    "mnc": "33",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "EE/Everything Everywhere "
  },
  {
    "mcc": "234",
    "mnc": "31",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "EE/Everything Everywhere "
  },
  {
    "mcc": "234",
    "mnc": "30",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "EE/Everything Everywhere "
  },
  {
    "mcc": "234",
    "mnc": "299",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Failed Calls "
  },
  {
    "mcc": "234",
    "mnc": "999",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Fix Line "
  },
  {
    "mcc": "234",
    "mnc": "17",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "FlexTel "
  },
  {
    "mcc": "234",
    "mnc": "04",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "FMS Solutions "
  },
  {
    "mcc": "234",
    "mnc": "39",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Gamma Mobile "
  },
  {
    "mcc": "234",
    "mnc": "24",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Greenfone "
  },
  {
    "mcc": "234",
    "mnc": "72",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Hanhaa Mobile "
  },
  {
    "mcc": "234",
    "mnc": "71",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Home Office "
  },
  {
    "mcc": "234",
    "mnc": "94",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "3 "
  },
  {
    "mcc": "234",
    "mnc": "20",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "3 "
  },
  {
    "mcc": "234",
    "mnc": "23",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Icron Network "
  },
  {
    "mcc": "234",
    "mnc": "03",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Jersey Airtel "
  },
  {
    "mcc": "234",
    "mnc": "35",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "JSC Ingenicum "
  },
  {
    "mcc": "234",
    "mnc": "50",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "JT Mobile "
  },
  {
    "mcc": "234",
    "mnc": "14",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "LINK Mobility "
  },
  {
    "mcc": "234",
    "mnc": "26",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Lycamobile "
  },
  {
    "mcc": "234",
    "mnc": "58",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Manx Telecom Mobile "
  },
  {
    "mcc": "234",
    "mnc": "28",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Marathon Telecom "
  },
  {
    "mcc": "234",
    "mnc": "75",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Mass Response Service GmbH "
  },
  {
    "mcc": "234",
    "mnc": "56",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "NCSC "
  },
  {
    "mcc": "234",
    "mnc": "95",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Network Rail "
  },
  {
    "mcc": "234",
    "mnc": "12",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Network Rail "
  },
  {
    "mcc": "234",
    "mnc": "13",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Network Rail "
  },
  {
    "mcc": "234",
    "mnc": "51",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "now broadband "
  },
  {
    "mcc": "234",
    "mnc": "34",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Orange "
  },
  {
    "mcc": "234",
    "mnc": "74",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Pareteum "
  },
  {
    "mcc": "234",
    "mnc": "57",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Sky "
  },
  {
    "mcc": "234",
    "mnc": "40",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "spusu "
  },
  {
    "mcc": "234",
    "mnc": "55",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Sure Guernsey "
  },
  {
    "mcc": "234",
    "mnc": "36",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Sure Isle of Man "
  },
  {
    "mcc": "234",
    "mnc": "99",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Sure Jersey "
  },
  {
    "mcc": "234",
    "mnc": "37",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Synectiv "
  },
  {
    "mcc": "234",
    "mnc": "16",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Talk Talk "
  },
  {
    "mcc": "234",
    "mnc": "27",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Tata Communications Ltd "
  },
  {
    "mcc": "234",
    "mnc": "02",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "O2 "
  },
  {
    "mcc": "234",
    "mnc": "11",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "O2 "
  },
  {
    "mcc": "234",
    "mnc": "10",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "O2 "
  },
  {
    "mcc": "234",
    "mnc": "22",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Telesign Mobile "
  },
  {
    "mcc": "234",
    "mnc": "19",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "TeleWare "
  },
  {
    "mcc": "234",
    "mnc": "09",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Tismi "
  },
  {
    "mcc": "234",
    "mnc": "25",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Truphone "
  },
  {
    "mcc": "234",
    "mnc": "01",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vectone Mobile "
  },
  {
    "mcc": "234",
    "mnc": "38",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Virgin Mobile "
  },
  {
    "mcc": "234",
    "mnc": "15",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "234",
    "mnc": "92",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "234",
    "mnc": "77",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "234",
    "mnc": "89",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "234",
    "mnc": "07",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "234",
    "mnc": "91",
    "iso": "gb",
    "country": "United Kingdom",
    "countryCode": "44",
    "network": "Vodafone "
  },
  {
    "mcc": "310",
    "mnc": "130",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Appalachian Wireless "
  },
  {
    "mcc": "310",
    "mnc": "750",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Appalachian Wireless "
  },
  {
    "mcc": "312",
    "mnc": "130",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Appalachian Wireless "
  },
  {
    "mcc": "312",
    "mnc": "750",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Appalachian Wireless "
  },
  {
    "mcc": "312",
    "mnc": "710",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "ASTAC Cellular "
  },
  {
    "mcc": "310",
    "mnc": "710",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "ASTAC Cellular "
  },
  {
    "mcc": "310",
    "mnc": "760",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "ASTAC Cellular "
  },
  {
    "mcc": "312",
    "mnc": "760",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "ASTAC Cellular "
  },
  {
    "mcc": "313",
    "mnc": "670",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "680",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "070",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "016",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "150",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "210",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "950",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "180",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "150",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "680",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "090",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "680",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "380",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "950",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "080",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "030",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "170",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "030",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "016",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "016",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "210",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "170",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "380",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "950",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "070",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "150",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "950",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "410",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "090",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "070",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "180",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "380",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "030",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "380",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "180",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "410",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "016",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "080",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "170",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "670",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "150",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "080",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "410",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "070",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "410",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "210",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "670",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "030",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "090",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "180",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "680",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "313",
    "mnc": "170",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "311",
    "mnc": "090",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "210",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "670",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "312",
    "mnc": "080",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "AT&T Mobility "
  },
  {
    "mcc": "310",
    "mnc": "600",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Cellcom "
  },
  {
    "mcc": "310",
    "mnc": "630",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Choice Wireless "
  },
  {
    "mcc": "310",
    "mnc": "700",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "cv cellular "
  },
  {
    "mcc": "310",
    "mnc": "880",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "DTC Wireless "
  },
  {
    "mcc": "310",
    "mnc": "035",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "ETEX "
  },
  {
    "mcc": "310",
    "mnc": "990",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Evolve "
  },
  {
    "mcc": "310",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Failed Calls "
  },
  {
    "mcc": "310",
    "mnc": "999",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Fix Line "
  },
  {
    "mcc": "311",
    "mnc": "370",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "GCI Wireless "
  },
  {
    "mcc": "310",
    "mnc": "430",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "GCI Wireless "
  },
  {
    "mcc": "311",
    "mnc": "430",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "GCI Wireless "
  },
  {
    "mcc": "310",
    "mnc": "690",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "311",
    "mnc": "340",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "311",
    "mnc": "690",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "312",
    "mnc": "340",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "310",
    "mnc": "340",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "312",
    "mnc": "690",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Limitless "
  },
  {
    "mcc": "313",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "314",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "310",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "315",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "311",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "316",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "312",
    "mnc": "299",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Northstar Technology "
  },
  {
    "mcc": "310",
    "mnc": "540",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "OWTC "
  },
  {
    "mcc": "310",
    "mnc": "570",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "311",
    "mnc": "570",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "313",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "310",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "313",
    "mnc": "360",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "310",
    "mnc": "360",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "311",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "313",
    "mnc": "570",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "311",
    "mnc": "360",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Pioneer Cellular "
  },
  {
    "mcc": "312",
    "mnc": "270",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "190",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "800",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "010",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "490",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "200",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "800",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "160",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "830",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "230",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "940",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "230",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "270",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "940",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "870",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "250",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "010",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "310",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "490",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "160",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "830",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "120",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "530",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "230",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "830",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "190",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "870",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "240",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "240",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "490",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "880",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "260",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "120",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "490",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "530",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "120",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "870",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "160",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "660",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "240",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "870",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "200",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "880",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "250",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "250",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "530",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "882",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "270",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "160",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "530",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "010",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "660",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "010",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "880",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "190",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "800",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "250",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "880",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "230",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "882",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "260",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "260",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "660",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "940",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "311",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "190",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "660",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "120",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "800",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "200",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "882",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "200",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "316",
    "mnc": "260",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "882",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "830",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "311",
    "mnc": "240",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "312",
    "mnc": "940",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "270",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "T-Mobile "
  },
  {
    "mcc": "310",
    "mnc": "020",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Union Wireless "
  },
  {
    "mcc": "312",
    "mnc": "487",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "276",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "282",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "590",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "596",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "487",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "012",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "273",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "898",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "481",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "284",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "350",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "484",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "892",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "898",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "820",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "592",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "275",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "281",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "287",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "595",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "820",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "272",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "278",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "486",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "592",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "289",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "483",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "897",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "110",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "894",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "597",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "286",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "480",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "770",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "894",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "488",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "271",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "277",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "283",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "591",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "597",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "488",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "013",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "274",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "899",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "482",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "285",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "390",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "485",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "893",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "899",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "890",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "593",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "276",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "282",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "288",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "596",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "890",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "012",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "273",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "279",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "487",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "593",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "350",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "484",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "898",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "895",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "598",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "281",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "287",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "481",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "820",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "895",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "489",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "272",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "278",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "284",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "592",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "598",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "110",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "275",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "910",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "483",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "489",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "286",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "480",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "894",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "910",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "891",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "594",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "277",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "283",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "289",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "004",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "597",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "891",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "013",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "274",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "488",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "594",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "485",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "899",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "271",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "896",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "390",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "599",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "282",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "288",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "482",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "890",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "896",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "590",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "273",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "279",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "285",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "593",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "599",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "276",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "484",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "590",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "287",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "481",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "895",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "012",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "892",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "595",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "278",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "284",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "350",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "598",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "892",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "486",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "110",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "275",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "281",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "489",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "595",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "486",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "910",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "272",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "897",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "480",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "283",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "289",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "483",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "891",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "897",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "770",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "591",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "274",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "280",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "286",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "594",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "770",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "271",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "277",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "485",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "591",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "288",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "482",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "896",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "013",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "893",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "596",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "279",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "285",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "312",
    "mnc": "390",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "599",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "311",
    "mnc": "893",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Verizon Wireless "
  },
  {
    "mcc": "310",
    "mnc": "740",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Viaero Wireless "
  },
  {
    "mcc": "310",
    "mnc": "450",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "Viaero Wireless "
  },
  {
    "mcc": "310",
    "mnc": "860",
    "iso": "us",
    "country": "United States of America",
    "countryCode": "1",
    "network": "West Central Wireless "
  },
  {
    "mcc": "748",
    "mnc": "01",
    "iso": "uy",
    "country": "Uruguay",
    "countryCode": "598",
    "network": "Antel Movil "
  },
  {
    "mcc": "748",
    "mnc": "10",
    "iso": "uy",
    "country": "Uruguay",
    "countryCode": "598",
    "network": "Claro "
  },
  {
    "mcc": "748",
    "mnc": "299",
    "iso": "uy",
    "country": "Uruguay",
    "countryCode": "598",
    "network": "Failed Calls "
  },
  {
    "mcc": "748",
    "mnc": "999",
    "iso": "uy",
    "country": "Uruguay",
    "countryCode": "598",
    "network": "Fix Line "
  },
  {
    "mcc": "748",
    "mnc": "07",
    "iso": "uy",
    "country": "Uruguay",
    "countryCode": "598",
    "network": "Movistar "
  },
  {
    "mcc": "434",
    "mnc": "04",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "Beeline "
  },
  {
    "mcc": "434",
    "mnc": "299",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "Failed Calls "
  },
  {
    "mcc": "434",
    "mnc": "999",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "Fix Line "
  },
  {
    "mcc": "434",
    "mnc": "06",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "Perfectum Mobile "
  },
  {
    "mcc": "434",
    "mnc": "05",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "Ucell "
  },
  {
    "mcc": "434",
    "mnc": "07",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "UMS "
  },
  {
    "mcc": "434",
    "mnc": "03",
    "iso": "uz",
    "country": "Uzbekistan",
    "countryCode": "998",
    "network": "UzMobile "
  },
  {
    "mcc": "541",
    "mnc": "05",
    "iso": "vu",
    "country": "Vanuatu",
    "countryCode": "678",
    "network": "Digicel "
  },
  {
    "mcc": "541",
    "mnc": "299",
    "iso": "vu",
    "country": "Vanuatu",
    "countryCode": "678",
    "network": "Failed Calls "
  },
  {
    "mcc": "541",
    "mnc": "999",
    "iso": "vu",
    "country": "Vanuatu",
    "countryCode": "678",
    "network": "Fix Line "
  },
  {
    "mcc": "541",
    "mnc": "01",
    "iso": "vu",
    "country": "Vanuatu",
    "countryCode": "678",
    "network": "Smile "
  },
  {
    "mcc": "225",
    "mnc": "299",
    "iso": "va",
    "country": "Vatican",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "225",
    "mnc": "999",
    "iso": "va",
    "country": "Vatican",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "734",
    "mnc": "02",
    "iso": "ve",
    "country": "Venezuela",
    "countryCode": "58",
    "network": "Digitel "
  },
  {
    "mcc": "734",
    "mnc": "299",
    "iso": "ve",
    "country": "Venezuela",
    "countryCode": "58",
    "network": "Failed Calls "
  },
  {
    "mcc": "734",
    "mnc": "999",
    "iso": "ve",
    "country": "Venezuela",
    "countryCode": "58",
    "network": "Fix Line "
  },
  {
    "mcc": "734",
    "mnc": "06",
    "iso": "ve",
    "country": "Venezuela",
    "countryCode": "58",
    "network": "Movilnet "
  },
  {
    "mcc": "734",
    "mnc": "04",
    "iso": "ve",
    "country": "Venezuela",
    "countryCode": "58",
    "network": "Movistar "
  },
  {
    "mcc": "452",
    "mnc": "299",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Failed Calls "
  },
  {
    "mcc": "452",
    "mnc": "999",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Fix Line "
  },
  {
    "mcc": "452",
    "mnc": "07",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Gmobile "
  },
  {
    "mcc": "452",
    "mnc": "08",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "I-Telecom "
  },
  {
    "mcc": "452",
    "mnc": "01",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "MobiFone "
  },
  {
    "mcc": "452",
    "mnc": "09",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Reddi "
  },
  {
    "mcc": "452",
    "mnc": "05",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Vietnamobile "
  },
  {
    "mcc": "452",
    "mnc": "06",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Viettel "
  },
  {
    "mcc": "452",
    "mnc": "04",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "Viettel "
  },
  {
    "mcc": "452",
    "mnc": "02",
    "iso": "vn",
    "country": "Vietnam",
    "countryCode": "84",
    "network": "VinaPhone "
  },
  {
    "mcc": "376",
    "mnc": "299",
    "iso": "vi",
    "country": "Virgin Islands",
    "countryCode": "1340",
    "network": "Failed Calls "
  },
  {
    "mcc": "376",
    "mnc": "999",
    "iso": "vi",
    "country": "Virgin Islands",
    "countryCode": "1340",
    "network": "Fix Line "
  },
  {
    "mcc": "543",
    "mnc": "299",
    "iso": "wf",
    "country": "Wallis and Futuna",
    "countryCode": "",
    "network": "Failed Calls "
  },
  {
    "mcc": "543",
    "mnc": "999",
    "iso": "wf",
    "country": "Wallis and Futuna",
    "countryCode": "",
    "network": "Fix Line "
  },
  {
    "mcc": "543",
    "mnc": "01",
    "iso": "wf",
    "country": "Wallis and Futuna",
    "countryCode": "",
    "network": "Manuia "
  },
  {
    "mcc": "421",
    "mnc": "299",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "Failed Calls "
  },
  {
    "mcc": "421",
    "mnc": "999",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "Fix Line "
  },
  {
    "mcc": "421",
    "mnc": "01",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "SabaFon "
  },
  {
    "mcc": "421",
    "mnc": "02",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "Spacetel "
  },
  {
    "mcc": "421",
    "mnc": "04",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "Y "
  },
  {
    "mcc": "421",
    "mnc": "03",
    "iso": "ye",
    "country": "Yemen",
    "countryCode": "967",
    "network": "Yemen Mobile "
  },
  {
    "mcc": "645",
    "mnc": "01",
    "iso": "zm",
    "country": "Zambia",
    "countryCode": "260",
    "network": "Airtel "
  },
  {
    "mcc": "645",
    "mnc": "299",
    "iso": "zm",
    "country": "Zambia",
    "countryCode": "260",
    "network": "Failed Calls "
  },
  {
    "mcc": "645",
    "mnc": "999",
    "iso": "zm",
    "country": "Zambia",
    "countryCode": "260",
    "network": "Fix Line "
  },
  {
    "mcc": "645",
    "mnc": "02",
    "iso": "zm",
    "country": "Zambia",
    "countryCode": "260",
    "network": "MTN "
  },
  {
    "mcc": "645",
    "mnc": "03",
    "iso": "zm",
    "country": "Zambia",
    "countryCode": "260",
    "network": "Zamtel "
  },
  {
    "mcc": "648",
    "mnc": "04",
    "iso": "zw",
    "country": "Zimbabwe",
    "countryCode": "263",
    "network": "Econet "
  },
  {
    "mcc": "648",
    "mnc": "299",
    "iso": "zw",
    "country": "Zimbabwe",
    "countryCode": "263",
    "network": "Failed Calls "
  },
  {
    "mcc": "648",
    "mnc": "999",
    "iso": "zw",
    "country": "Zimbabwe",
    "countryCode": "263",
    "network": "Fix Line "
  },
  {
    "mcc": "648",
    "mnc": "01",
    "iso": "zw",
    "country": "Zimbabwe",
    "countryCode": "263",
    "network": "NetOne "
  },
  {
    "mcc": "648",
    "mnc": "03",
    "iso": "zw",
    "country": "Zimbabwe",
    "countryCode": "263",
    "network": "Telecel "
  }
]

export default data
